//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken,
} from "axios";

export class AssetLogonsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Get assets logons
   * @param userId (optional)
   * @param assetId (optional)
   * @param isOngoing (optional)
   * @param startedAtFrom (optional)
   * @param startedAtTo (optional)
   * @param finishedAtFrom (optional)
   * @param finishedAtTo (optional)
   * @return Success
   */
  getAllAssetLogons(
    userId: string | undefined,
    assetId: string | undefined,
    isOngoing: boolean | undefined,
    startedAtFrom: Date | undefined,
    startedAtTo: Date | undefined,
    finishedAtFrom: Date | undefined,
    finishedAtTo: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AssetLogonDTO[]> {
    let url_ = this.baseUrl + "/api/access-management/asset-logons?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (assetId === null)
      throw new Error("The parameter 'assetId' cannot be null.");
    else if (assetId !== undefined)
      url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
    if (isOngoing === null)
      throw new Error("The parameter 'isOngoing' cannot be null.");
    else if (isOngoing !== undefined)
      url_ += "isOngoing=" + encodeURIComponent("" + isOngoing) + "&";
    if (startedAtFrom === null)
      throw new Error("The parameter 'startedAtFrom' cannot be null.");
    else if (startedAtFrom !== undefined)
      url_ +=
        "startedAtFrom=" +
        encodeURIComponent(
          startedAtFrom ? "" + startedAtFrom.toISOString() : ""
        ) +
        "&";
    if (startedAtTo === null)
      throw new Error("The parameter 'startedAtTo' cannot be null.");
    else if (startedAtTo !== undefined)
      url_ +=
        "startedAtTo=" +
        encodeURIComponent(startedAtTo ? "" + startedAtTo.toISOString() : "") +
        "&";
    if (finishedAtFrom === null)
      throw new Error("The parameter 'finishedAtFrom' cannot be null.");
    else if (finishedAtFrom !== undefined)
      url_ +=
        "finishedAtFrom=" +
        encodeURIComponent(
          finishedAtFrom ? "" + finishedAtFrom.toISOString() : ""
        ) +
        "&";
    if (finishedAtTo === null)
      throw new Error("The parameter 'finishedAtTo' cannot be null.");
    else if (finishedAtTo !== undefined)
      url_ +=
        "finishedAtTo=" +
        encodeURIComponent(
          finishedAtTo ? "" + finishedAtTo.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllAssetLogons(_response);
      });
  }

  protected processGetAllAssetLogons(
    response: AxiosResponse
  ): Promise<AssetLogonDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(AssetLogonDTO.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AssetLogonDTO[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AssetLogonDTO[]>(null as any);
  }

  /**
   * Logs user on selected asset
   * @param body (optional) Log on asset request details
   * @return Success
   */
  logOnAsset(
    body: LogOnAssetRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<LogOnAssetDto> {
    let url_ = this.baseUrl + "/api/access-management/asset-logons/log-on";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogOnAsset(_response);
      });
  }

  protected processLogOnAsset(response: AxiosResponse): Promise<LogOnAssetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = LogOnAssetDto.fromJS(resultData200);
      return Promise.resolve<LogOnAssetDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<LogOnAssetDto>(null as any);
  }

  /**
   * Logs user off selected asset
   * @param body (optional) Log off asset request details
   * @return No Content
   */
  logOffAsset(
    body: LogOffAssetRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/access-management/asset-logons/log-off";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogOffAsset(_response);
      });
  }

  protected processLogOffAsset(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class AssetsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Returns all assets
   * @param name (optional)
   * @param isActive (optional)
   * @return Success
   */
  getAllAssets(
    name: string | undefined,
    isActive: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AssetDto[]> {
    let url_ = this.baseUrl + "/api/utilization/assets?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllAssets(_response);
      });
  }

  protected processGetAllAssets(response: AxiosResponse): Promise<AssetDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(AssetDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AssetDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AssetDto[]>(null as any);
  }

  /**
   * Creates new asset
   * @param body (optional) Create assety request
   * @return Success
   */
  createAsset(
    body: CreateAssetRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateAssetDto> {
    let url_ = this.baseUrl + "/api/utilization/assets";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateAsset(_response);
      });
  }

  protected processCreateAsset(
    response: AxiosResponse
  ): Promise<CreateAssetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateAssetDto.fromJS(resultData200);
      return Promise.resolve<CreateAssetDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateAssetDto>(null as any);
  }

  /**
   * Returns asset by given id
   * @param assetId Asset Id
   * @return Success
   */
  getAssetById(
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<AssetDto> {
    let url_ = this.baseUrl + "/api/utilization/assets/{assetId}";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAssetById(_response);
      });
  }

  protected processGetAssetById(response: AxiosResponse): Promise<AssetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AssetDto.fromJS(resultData200);
      return Promise.resolve<AssetDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AssetDto>(null as any);
  }

  /**
   * Returns all utilization execs of all assets
   * @return Success
   */
  getAllUtilExecs(
    cancelToken?: CancelToken | undefined
  ): Promise<GetAllUtilExecsQueryDto[]> {
    let url_ = this.baseUrl + "/api/utilization/assets/utilization-execs";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllUtilExecs(_response);
      });
  }

  protected processGetAllUtilExecs(
    response: AxiosResponse
  ): Promise<GetAllUtilExecsQueryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetAllUtilExecsQueryDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetAllUtilExecsQueryDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetAllUtilExecsQueryDto[]>(null as any);
  }

  /**
   * Returns utilization exec by assetId
   * @param assetId Asset Id
   * @return Success
   */
  getUtilExecByAssetId(
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetUtilExecByAssetIdDto> {
    let url_ =
      this.baseUrl + "/api/utilization/assets/{assetId}/utilization-execs";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilExecByAssetId(_response);
      });
  }

  protected processGetUtilExecByAssetId(
    response: AxiosResponse
  ): Promise<GetUtilExecByAssetIdDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetUtilExecByAssetIdDto.fromJS(resultData200);
      return Promise.resolve<GetUtilExecByAssetIdDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetUtilExecByAssetIdDto>(null as any);
  }

  /**
   * Returns active nested assets
   * @param showAll (optional)
   * @return Success
   */
  getNestedAssets(
    showAll: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetNestedAssetsQueryDto[]> {
    let url_ = this.baseUrl + "/api/utilization/assets/nested?";
    if (showAll === null)
      throw new Error("The parameter 'showAll' cannot be null.");
    else if (showAll !== undefined)
      url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNestedAssets(_response);
      });
  }

  protected processGetNestedAssets(
    response: AxiosResponse
  ): Promise<GetNestedAssetsQueryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetNestedAssetsQueryDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetNestedAssetsQueryDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetNestedAssetsQueryDto[]>(null as any);
  }

  /**
   * Changes asset details (name and description)
   * @param assetId The ID of the asset to be changed
   * @param body (optional) New details of the asset
   * @return No Content
   */
  changeAssetDetails(
    assetId: string,
    body: ChangeAssetDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/utilization/assets/{assetId}/details";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeAssetDetails(_response);
      });
  }

  protected processChangeAssetDetails(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Change asset state
   * @param assetId The ID of the asset to be changed
   * @param body (optional) New details of the asset
   * @return Success
   */
  changeAssetState(
    assetId: string,
    body: ChangeAssetStateRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ChangeAssetStateDto> {
    let url_ = this.baseUrl + "/api/utilization/assets/{assetId}/state";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeAssetState(_response);
      });
  }

  protected processChangeAssetState(
    response: AxiosResponse
  ): Promise<ChangeAssetStateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChangeAssetStateDto.fromJS(resultData200);
      return Promise.resolve<ChangeAssetStateDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ChangeAssetStateDto>(null as any);
  }

  /**
   * Activates asset in system if is deactivated
   * @param assetId The ID of the asset to be activated
   * @param activateChilds (optional) Holds the flag to activate childs recursively
   * @return No Content
   */
  activateAsset(
    assetId: string,
    activateChilds: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/utilization/assets/{assetId}/activate?";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    if (activateChilds === null)
      throw new Error("The parameter 'activateChilds' cannot be null.");
    else if (activateChilds !== undefined)
      url_ += "activateChilds=" + encodeURIComponent("" + activateChilds) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processActivateAsset(_response);
      });
  }

  protected processActivateAsset(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Deactivates asset in system if activated
   * @param assetId The ID of the asset to be deactivated
   * @param deactivateChilds (optional) Holds the flag to deactivate childs recursively
   * @return No Content
   */
  deactivateAsset(
    assetId: string,
    deactivateChilds: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/utilization/assets/{assetId}/deactivate?";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    if (deactivateChilds === null)
      throw new Error("The parameter 'deactivateChilds' cannot be null.");
    else if (deactivateChilds !== undefined)
      url_ +=
        "deactivateChilds=" + encodeURIComponent("" + deactivateChilds) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeactivateAsset(_response);
      });
  }

  protected processDeactivateAsset(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Returns all task execs of all assets
   * @return Success
   */
  getAllTaskExecs(
    cancelToken?: CancelToken | undefined
  ): Promise<GetAllTaskExecsQueryDto[]> {
    let url_ = this.baseUrl + "/api/manufacturing-execution/assets/task-execs";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllTaskExecs(_response);
      });
  }

  protected processGetAllTaskExecs(
    response: AxiosResponse
  ): Promise<GetAllTaskExecsQueryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetAllTaskExecsQueryDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetAllTaskExecsQueryDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetAllTaskExecsQueryDto[]>(null as any);
  }

  /**
   * Returns task execs of running job
   * @param taskId The ID of task
   * @return Success
   */
  getTaskExecByTaskId(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetTaskExecByTaskIdQueryDto> {
    let url_ =
      this.baseUrl + "/api/manufacturing-execution/assets/task-execs/{taskId}";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTaskExecByTaskId(_response);
      });
  }

  protected processGetTaskExecByTaskId(
    response: AxiosResponse
  ): Promise<GetTaskExecByTaskIdQueryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetTaskExecByTaskIdQueryDto.fromJS(resultData200);
      return Promise.resolve<GetTaskExecByTaskIdQueryDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetTaskExecByTaskIdQueryDto>(null as any);
  }

  /**
   * Changes asset positions (number of task execs)
   * @param assetId The ID of the asset to be changed
   * @param body (optional) New positions of the asset
   * @return No Content
   */
  changeAssetPositions(
    assetId: string,
    body: ChangeAssetPositionsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/assets/{assetId}/asset-positions";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeAssetPositions(_response);
      });
  }

  protected processChangeAssetPositions(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class AssetTypesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Returns all asset types
   * @param name (optional)
   * @param isActive (optional)
   * @return Success
   */
  getAllAssetTypes(
    name: string | undefined,
    isActive: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AssetTypeDto[]> {
    let url_ = this.baseUrl + "/api/utilization/asset-types?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllAssetTypes(_response);
      });
  }

  protected processGetAllAssetTypes(
    response: AxiosResponse
  ): Promise<AssetTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(AssetTypeDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AssetTypeDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AssetTypeDto[]>(null as any);
  }

  /**
   * Creates new asset type
   * @param body (optional) Create assety type request
   * @return Success
   */
  createAssetType(
    body: CreateAssetTypeRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateAssetTypeDto> {
    let url_ = this.baseUrl + "/api/utilization/asset-types";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateAssetType(_response);
      });
  }

  protected processCreateAssetType(
    response: AxiosResponse
  ): Promise<CreateAssetTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateAssetTypeDto.fromJS(resultData200);
      return Promise.resolve<CreateAssetTypeDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateAssetTypeDto>(null as any);
  }

  /**
   * Returns found asset type by its ID or null
   * @param assetTypeId ID of asset type to be returned
   * @return Success
   */
  getAssetTypeById(
    assetTypeId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<AssetTypeDto> {
    let url_ = this.baseUrl + "/api/utilization/asset-types/{assetTypeId}";
    if (assetTypeId === undefined || assetTypeId === null)
      throw new Error("The parameter 'assetTypeId' must be defined.");
    url_ = url_.replace("{assetTypeId}", encodeURIComponent("" + assetTypeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAssetTypeById(_response);
      });
  }

  protected processGetAssetTypeById(
    response: AxiosResponse
  ): Promise<AssetTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AssetTypeDto.fromJS(resultData200);
      return Promise.resolve<AssetTypeDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AssetTypeDto>(null as any);
  }

  /**
   * Changes asset type details (name and description)
   * @param assetTypeId The ID of the asset type to be changed
   * @param body (optional) New details of the asset type
   * @return No Content
   */
  changeAssetTypeDetails(
    assetTypeId: string,
    body: ChangeAssetTypeDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/utilization/asset-types/{assetTypeId}/details";
    if (assetTypeId === undefined || assetTypeId === null)
      throw new Error("The parameter 'assetTypeId' must be defined.");
    url_ = url_.replace("{assetTypeId}", encodeURIComponent("" + assetTypeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeAssetTypeDetails(_response);
      });
  }

  protected processChangeAssetTypeDetails(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Activates asset type in system if is deactivated
   * @param assetTypeId The ID of the asset type to be activated
   * @return No Content
   */
  activateAssetType(
    assetTypeId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/utilization/asset-types/{assetTypeId}/activate";
    if (assetTypeId === undefined || assetTypeId === null)
      throw new Error("The parameter 'assetTypeId' must be defined.");
    url_ = url_.replace("{assetTypeId}", encodeURIComponent("" + assetTypeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processActivateAssetType(_response);
      });
  }

  protected processActivateAssetType(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Deactivates asset type in system if activated
   * @param assetTypeId The ID of the asset type to be deactivated
   * @return No Content
   */
  deactivateAssetType(
    assetTypeId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/utilization/asset-types/{assetTypeId}/deactivate";
    if (assetTypeId === undefined || assetTypeId === null)
      throw new Error("The parameter 'assetTypeId' must be defined.");
    url_ = url_.replace("{assetTypeId}", encodeURIComponent("" + assetTypeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeactivateAssetType(_response);
      });
  }

  protected processDeactivateAssetType(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class AuthenticationClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  logIn(
    body: LoginUserRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<LoginUserDto> {
    let url_ = this.baseUrl + "/api/access-management/authentication/log-in";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogIn(_response);
      });
  }

  protected processLogIn(response: AxiosResponse): Promise<LoginUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = LoginUserDto.fromJS(resultData200);
      return Promise.resolve<LoginUserDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<LoginUserDto>(null as any);
  }

  /**
   * @return Success
   */
  refreshToken(
    cancelToken?: CancelToken | undefined
  ): Promise<RefreshTokenDto> {
    let url_ = this.baseUrl + "/api/access-management/authentication/refresh";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRefreshToken(_response);
      });
  }

  protected processRefreshToken(
    response: AxiosResponse
  ): Promise<RefreshTokenDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RefreshTokenDto.fromJS(resultData200);
      return Promise.resolve<RefreshTokenDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RefreshTokenDto>(null as any);
  }

  /**
   * @return No Content
   */
  logOut(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/access-management/authentication/log-out";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogOut(_response);
      });
  }

  protected processLogOut(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return No Content
   */
  changePassword(
    body: ChangePasswordRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/access-management/authentication/change-password";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangePassword(_response);
      });
  }

  protected processChangePassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return No Content
   */
  checkPassword(
    body: CheckPasswordRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/access-management/authentication/check-password";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCheckPassword(_response);
      });
  }

  protected processCheckPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class ConnectionsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Get connections
   * @param connectionTypeId (optional) 0 - Operators, 1 - Supervisors, 2 - Externals
   * @param userId (optional)
   * @param isOngoing (optional)
   * @param startedAtFrom (optional)
   * @param startedAtTo (optional)
   * @param finishedAtFrom (optional)
   * @param finishedAtTo (optional)
   * @return Success
   */
  getConnections(
    connectionTypeId: number | undefined,
    userId: string | undefined,
    isOngoing: boolean | undefined,
    startedAtFrom: Date | undefined,
    startedAtTo: Date | undefined,
    finishedAtFrom: Date | undefined,
    finishedAtTo: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ConnectionDTO[]> {
    let url_ = this.baseUrl + "/api/access-management/connections?";
    if (connectionTypeId === null)
      throw new Error("The parameter 'connectionTypeId' cannot be null.");
    else if (connectionTypeId !== undefined)
      url_ +=
        "connectionTypeId=" + encodeURIComponent("" + connectionTypeId) + "&";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (isOngoing === null)
      throw new Error("The parameter 'isOngoing' cannot be null.");
    else if (isOngoing !== undefined)
      url_ += "isOngoing=" + encodeURIComponent("" + isOngoing) + "&";
    if (startedAtFrom === null)
      throw new Error("The parameter 'startedAtFrom' cannot be null.");
    else if (startedAtFrom !== undefined)
      url_ +=
        "startedAtFrom=" +
        encodeURIComponent(
          startedAtFrom ? "" + startedAtFrom.toISOString() : ""
        ) +
        "&";
    if (startedAtTo === null)
      throw new Error("The parameter 'startedAtTo' cannot be null.");
    else if (startedAtTo !== undefined)
      url_ +=
        "startedAtTo=" +
        encodeURIComponent(startedAtTo ? "" + startedAtTo.toISOString() : "") +
        "&";
    if (finishedAtFrom === null)
      throw new Error("The parameter 'finishedAtFrom' cannot be null.");
    else if (finishedAtFrom !== undefined)
      url_ +=
        "finishedAtFrom=" +
        encodeURIComponent(
          finishedAtFrom ? "" + finishedAtFrom.toISOString() : ""
        ) +
        "&";
    if (finishedAtTo === null)
      throw new Error("The parameter 'finishedAtTo' cannot be null.");
    else if (finishedAtTo !== undefined)
      url_ +=
        "finishedAtTo=" +
        encodeURIComponent(
          finishedAtTo ? "" + finishedAtTo.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetConnections(_response);
      });
  }

  protected processGetConnections(
    response: AxiosResponse
  ): Promise<ConnectionDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ConnectionDTO.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ConnectionDTO[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ConnectionDTO[]>(null as any);
  }

  /**
   * Get active connection by id
   * @return Success
   */
  getConnectionById(
    connectionId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ConnectionDTO> {
    let url_ =
      this.baseUrl + "/api/access-management/connections/{connectionId}";
    if (connectionId === undefined || connectionId === null)
      throw new Error("The parameter 'connectionId' must be defined.");
    url_ = url_.replace(
      "{connectionId}",
      encodeURIComponent("" + connectionId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetConnectionById(_response);
      });
  }

  protected processGetConnectionById(
    response: AxiosResponse
  ): Promise<ConnectionDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ConnectionDTO.fromJS(resultData200);
      return Promise.resolve<ConnectionDTO>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ConnectionDTO>(null as any);
  }
}

export class ExtensionClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Generic endpoint to execute some logic or get data using extension procedures.
   * @param procedureName Name of procedure without schema or database name. All procedures must have 'extension' schema.
   * @param body (optional) Parameters passed to the procedure.
   * @return Success
   */
  executeProcedure(
    procedureName: string,
    body: { [key: string]: any } | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<any[]> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/extension/procedures/{procedureName}";
    if (procedureName === undefined || procedureName === null)
      throw new Error("The parameter 'procedureName' must be defined.");
    url_ = url_.replace(
      "{procedureName}",
      encodeURIComponent("" + procedureName)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processExecuteProcedure(_response);
      });
  }

  protected processExecuteProcedure(response: AxiosResponse): Promise<any[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(item);
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<any[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = DatabaseExceptionProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<any[]>(null as any);
  }
}

export class ItemsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param name (optional)
   * @return Success
   */
  getAllItems(
    name: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ItemDto[]> {
    let url_ = this.baseUrl + "/api/production-planning/items?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllItems(_response);
      });
  }

  protected processGetAllItems(response: AxiosResponse): Promise<ItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ItemDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ItemDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ItemDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createItem(
    body: CreateItemRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateItemDto> {
    let url_ = this.baseUrl + "/api/production-planning/items";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateItem(_response);
      });
  }

  protected processCreateItem(response: AxiosResponse): Promise<CreateItemDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateItemDto.fromJS(resultData200);
      return Promise.resolve<CreateItemDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateItemDto>(null as any);
  }

  /**
   * @return Success
   */
  getItemById(
    itemId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ItemDto> {
    let url_ = this.baseUrl + "/api/production-planning/items/{itemId}";
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetItemById(_response);
      });
  }

  protected processGetItemById(response: AxiosResponse): Promise<ItemDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ItemDto.fromJS(resultData200);
      return Promise.resolve<ItemDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ItemDto>(null as any);
  }
}

export class ItemTypesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllItemTypes(
    cancelToken?: CancelToken | undefined
  ): Promise<ItemTypeDto[]> {
    let url_ = this.baseUrl + "/api/production-planning/item-types";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllItemTypes(_response);
      });
  }

  protected processGetAllItemTypes(
    response: AxiosResponse
  ): Promise<ItemTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ItemTypeDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ItemTypeDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ItemTypeDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createItemType(
    body: CreateItemTypeRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateItemTypeDto> {
    let url_ = this.baseUrl + "/api/production-planning/item-types";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateItemType(_response);
      });
  }

  protected processCreateItemType(
    response: AxiosResponse
  ): Promise<CreateItemTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateItemTypeDto.fromJS(resultData200);
      return Promise.resolve<CreateItemTypeDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateItemTypeDto>(null as any);
  }

  /**
   * @return Success
   */
  getItemTypeById(
    itemTypeId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ItemTypeDto> {
    let url_ =
      this.baseUrl + "/api/production-planning/item-types/{itemTypeId}";
    if (itemTypeId === undefined || itemTypeId === null)
      throw new Error("The parameter 'itemTypeId' must be defined.");
    url_ = url_.replace("{itemTypeId}", encodeURIComponent("" + itemTypeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetItemTypeById(_response);
      });
  }

  protected processGetItemTypeById(
    response: AxiosResponse
  ): Promise<ItemTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ItemTypeDto.fromJS(resultData200);
      return Promise.resolve<ItemTypeDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ItemTypeDto>(null as any);
  }
}

export class MaintenanceClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Get all not sliced util logs on missed intervals
   * @param assetId (optional)
   * @param startAt (optional)
   * @param finishAt (optional)
   * @return Success
   */
  getNotSlicedUtilLogsOnMissedIntervals(
    assetId: string | undefined,
    startAt: Date | undefined,
    finishAt: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetNotSlicedUtilLogsOnMissedIntervalsDto[]> {
    let url_ =
      this.baseUrl +
      "/api/utilization/maintenance/utilization-events/not-sliced?";
    if (assetId === null)
      throw new Error("The parameter 'assetId' cannot be null.");
    else if (assetId !== undefined)
      url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (finishAt === null)
      throw new Error("The parameter 'finishAt' cannot be null.");
    else if (finishAt !== undefined)
      url_ +=
        "finishAt=" +
        encodeURIComponent(finishAt ? "" + finishAt.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNotSlicedUtilLogsOnMissedIntervals(_response);
      });
  }

  protected processGetNotSlicedUtilLogsOnMissedIntervals(
    response: AxiosResponse
  ): Promise<GetNotSlicedUtilLogsOnMissedIntervalsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(
            GetNotSlicedUtilLogsOnMissedIntervalsDto.fromJS(item)
          );
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetNotSlicedUtilLogsOnMissedIntervalsDto[]>(
        result200
      );
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException("Bad Request", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetNotSlicedUtilLogsOnMissedIntervalsDto[]>(
      null as any
    );
  }

  /**
   * Slice missed intervals
   * @param body (optional)
   * @return No Content
   */
  sliceUtilLogsOnMissedIntervals(
    body: SliceUtilLogsOnMissedIntervalsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/utilization/maintenance/utilization-events/slice";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSliceUtilLogsOnMissedIntervals(_response);
      });
  }

  protected processSliceUtilLogsOnMissedIntervals(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class OeeClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Returns availability by assetId for current shift or datetime range
   * @param assetId Asset id
   * @param startDate (optional) Start should be defined as a full hour or the start of a shift. Defaults to the start of the current shift.
   * @param endDate (optional) End should be defined as a full hour or the end of a shift. Taken into account if start is given. If start is not given default is the end of the current change, otherwise current datetime.
   * @return Success
   */
  getAvailabilityByAssetId(
    assetId: string,
    startDate: Date | undefined,
    endDate: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetAvailabilityByAssetIdDto> {
    let url_ =
      this.baseUrl + "/api/utilization/oee/assets/{assetId}/availability?";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ +=
        "startDate=" +
        encodeURIComponent(startDate ? "" + startDate.toISOString() : "") +
        "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ +=
        "endDate=" +
        encodeURIComponent(endDate ? "" + endDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAvailabilityByAssetId(_response);
      });
  }

  protected processGetAvailabilityByAssetId(
    response: AxiosResponse
  ): Promise<GetAvailabilityByAssetIdDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetAvailabilityByAssetIdDto.fromJS(resultData200);
      return Promise.resolve<GetAvailabilityByAssetIdDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetAvailabilityByAssetIdDto>(null as any);
  }

  /**
     * Returns availability in intervals for current shift or datetime range. Availability on intervals accumulates based on all previous intervals.
     * @param body (optional) assetIds - list of asset ids, can not be empty (required at least 1 id)
    startDate - start should be defined as a full hour or the start of a shift. Defaults to the start of the current shift.
    endDate - End should be defined as a full hour or the end of a shift. Taken into account if start is given. If start is not given default is the end of the current change, otherwise current datetime.
     * @return Success
     */
  getAssetIntervalsAvailabilityByAssetIds(
    body: GetAssetIntervalAvailabilityByAssetIdsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetAssetIntervalAvailabilityByAssetIdsDto[]> {
    let url_ =
      this.baseUrl + "/api/utilization/oee/assets/availability/intervals";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAssetIntervalsAvailabilityByAssetIds(_response);
      });
  }

  protected processGetAssetIntervalsAvailabilityByAssetIds(
    response: AxiosResponse
  ): Promise<GetAssetIntervalAvailabilityByAssetIdsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(
            GetAssetIntervalAvailabilityByAssetIdsDto.fromJS(item)
          );
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetAssetIntervalAvailabilityByAssetIdsDto[]>(
        result200
      );
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException("Bad Request", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetAssetIntervalAvailabilityByAssetIdsDto[]>(
      null as any
    );
  }

  /**
   * Returns performance by assetId for current shift or datetime range. Calculated based on on weighted tasks performance.
   * @param assetId Asset id
   * @param startDate (optional) Start should be defined as a full hour or the start of a shift. Defaults to the start of the current shift.
   * @param endDate (optional) End should be defined as a full hour or the end of a shift. Taken into account if start is given. If start is not given default is the end of the current change, otherwise current datetime.
   * @return Success
   */
  getPerformanceByAssetId(
    assetId: string,
    startDate: Date | undefined,
    endDate: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetPerformanceByAssetIdDto> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/oee/assets/{assetId}/performance?";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ +=
        "startDate=" +
        encodeURIComponent(startDate ? "" + startDate.toISOString() : "") +
        "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ +=
        "endDate=" +
        encodeURIComponent(endDate ? "" + endDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPerformanceByAssetId(_response);
      });
  }

  protected processGetPerformanceByAssetId(
    response: AxiosResponse
  ): Promise<GetPerformanceByAssetIdDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetPerformanceByAssetIdDto.fromJS(resultData200);
      return Promise.resolve<GetPerformanceByAssetIdDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetPerformanceByAssetIdDto>(null as any);
  }

  /**
   * Returns quality by assetId for current shift or datetime range
   * @param assetId Asset id
   * @param startDate (optional) Start should be defined as a full hour or the start of a shift. Defaults to the start of the current shift.
   * @param endDate (optional) End should be defined as a full hour or the end of a shift. Taken into account if start is given. If start is not given default is the end of the current change, otherwise current datetime.
   * @return Success
   */
  getQualityByAssetId(
    assetId: string,
    startDate: Date | undefined,
    endDate: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetQualityByAssetIdDto> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/oee/assets/{assetId}/quality?";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ +=
        "startDate=" +
        encodeURIComponent(startDate ? "" + startDate.toISOString() : "") +
        "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ +=
        "endDate=" +
        encodeURIComponent(endDate ? "" + endDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetQualityByAssetId(_response);
      });
  }

  protected processGetQualityByAssetId(
    response: AxiosResponse
  ): Promise<GetQualityByAssetIdDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetQualityByAssetIdDto.fromJS(resultData200);
      return Promise.resolve<GetQualityByAssetIdDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetQualityByAssetIdDto>(null as any);
  }

  /**
     * Returns performance in intervals for current shift or datetime range. Performance on intervals accumulates based on all previous intervals.
     * @param body (optional) assetIds - list of asset ids, can not be empty (required at least 1 id)
    startDate - start should be defined as a full hour or the start of a shift. Defaults to the start of the current shift.
    endDate - End should be defined as a full hour or the end of a shift. Taken into account if start is given. If start is not given default is the end of the current change, otherwise current datetime.
     * @return Success
     */
  getAssetsPerformanceByAssetIds(
    body: GetAssetIntervalPerformanceByAssetIdsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetAssetIntervalPerformanceByAssetIdsDto[]> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/oee/assets/performance/intervals";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAssetsPerformanceByAssetIds(_response);
      });
  }

  protected processGetAssetsPerformanceByAssetIds(
    response: AxiosResponse
  ): Promise<GetAssetIntervalPerformanceByAssetIdsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(
            GetAssetIntervalPerformanceByAssetIdsDto.fromJS(item)
          );
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetAssetIntervalPerformanceByAssetIdsDto[]>(
        result200
      );
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException("Bad Request", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetAssetIntervalPerformanceByAssetIdsDto[]>(
      null as any
    );
  }

  /**
     * Returns quality in intervals for current shift or datetime range. Quality on intervals accumulates based on all previous intervals.
     * @param body (optional) assetIds - list of asset ids, can not be empty (required at least 1 id)
    startDate - start should be defined as a full hour or the start of a shift. Defaults to the start of the current shift.
    endDate - End should be defined as a full hour or the end of a shift. Taken into account if start is given. If start is not given default is the end of the current change, otherwise current datetime.
     * @return Success
     */
  getAssetsQualityByAssetIds(
    body: GetAssetIntervalQualityByAssetIdsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetAssetIntervalQualityByAssetIdsDto[]> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/oee/assets/quality/intervals";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAssetsQualityByAssetIds(_response);
      });
  }

  protected processGetAssetsQualityByAssetIds(
    response: AxiosResponse
  ): Promise<GetAssetIntervalQualityByAssetIdsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetAssetIntervalQualityByAssetIdsDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetAssetIntervalQualityByAssetIdsDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException("Bad Request", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetAssetIntervalQualityByAssetIdsDto[]>(null as any);
  }
}

export class PeriodsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllPeriods(cancelToken?: CancelToken | undefined): Promise<PeriodDto[]> {
    let url_ = this.baseUrl + "/api/production-planning/periods";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllPeriods(_response);
      });
  }

  protected processGetAllPeriods(
    response: AxiosResponse
  ): Promise<PeriodDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(PeriodDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<PeriodDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PeriodDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createPeriods(
    body: CreatePeriodRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreatePeriodDto> {
    let url_ = this.baseUrl + "/api/production-planning/periods";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreatePeriods(_response);
      });
  }

  protected processCreatePeriods(
    response: AxiosResponse
  ): Promise<CreatePeriodDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreatePeriodDto.fromJS(resultData200);
      return Promise.resolve<CreatePeriodDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreatePeriodDto>(null as any);
  }
}

export class ProductionEventsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   * @deprecated
   */
  getProductionSummaryByAsset(
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ProductionSummaryDto[]> {
    let url_ =
      this.baseUrl +
      "/api/reporting/production-events/assets/{assetId}/summary";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProductionSummaryByAsset(_response);
      });
  }

  protected processGetProductionSummaryByAsset(
    response: AxiosResponse
  ): Promise<ProductionSummaryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ProductionSummaryDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ProductionSummaryDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ProductionSummaryDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getProductionLogByLogId(
    logId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ProductionLogDto> {
    let url_ =
      this.baseUrl + "/api/manufacturing-execution/production-events/{logId}";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProductionLogByLogId(_response);
      });
  }

  protected processGetProductionLogByLogId(
    response: AxiosResponse
  ): Promise<ProductionLogDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProductionLogDto.fromJS(resultData200);
      return Promise.resolve<ProductionLogDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ProductionLogDto>(null as any);
  }

  /**
   * @param workOrderId (optional)
   * @param taskId (optional)
   * @param assetId (optional)
   * @param itemId (optional)
   * @param productionReasonId (optional)
   * @param userId (optional)
   * @param startedAtFrom (optional)
   * @param startedAtTo (optional)
   * @param finishedAtFrom (optional)
   * @param finishedAtTo (optional)
   * @return Success
   */
  getProductionEvents(
    workOrderId: string | undefined,
    taskId: string | undefined,
    assetId: string | undefined,
    itemId: string | undefined,
    productionReasonId: string | undefined,
    userId: string | undefined,
    startedAtFrom: Date | undefined,
    startedAtTo: Date | undefined,
    finishedAtFrom: Date | undefined,
    finishedAtTo: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetProductionLogsDto[]> {
    let url_ = this.baseUrl + "/api/manufacturing-execution/production-events?";
    if (workOrderId === null)
      throw new Error("The parameter 'workOrderId' cannot be null.");
    else if (workOrderId !== undefined)
      url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
    if (taskId === null)
      throw new Error("The parameter 'taskId' cannot be null.");
    else if (taskId !== undefined)
      url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
    if (assetId === null)
      throw new Error("The parameter 'assetId' cannot be null.");
    else if (assetId !== undefined)
      url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
    if (itemId === null)
      throw new Error("The parameter 'itemId' cannot be null.");
    else if (itemId !== undefined)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (productionReasonId === null)
      throw new Error("The parameter 'productionReasonId' cannot be null.");
    else if (productionReasonId !== undefined)
      url_ +=
        "productionReasonId=" +
        encodeURIComponent("" + productionReasonId) +
        "&";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (startedAtFrom === null)
      throw new Error("The parameter 'startedAtFrom' cannot be null.");
    else if (startedAtFrom !== undefined)
      url_ +=
        "startedAtFrom=" +
        encodeURIComponent(
          startedAtFrom ? "" + startedAtFrom.toISOString() : ""
        ) +
        "&";
    if (startedAtTo === null)
      throw new Error("The parameter 'startedAtTo' cannot be null.");
    else if (startedAtTo !== undefined)
      url_ +=
        "startedAtTo=" +
        encodeURIComponent(startedAtTo ? "" + startedAtTo.toISOString() : "") +
        "&";
    if (finishedAtFrom === null)
      throw new Error("The parameter 'finishedAtFrom' cannot be null.");
    else if (finishedAtFrom !== undefined)
      url_ +=
        "finishedAtFrom=" +
        encodeURIComponent(
          finishedAtFrom ? "" + finishedAtFrom.toISOString() : ""
        ) +
        "&";
    if (finishedAtTo === null)
      throw new Error("The parameter 'finishedAtTo' cannot be null.");
    else if (finishedAtTo !== undefined)
      url_ +=
        "finishedAtTo=" +
        encodeURIComponent(
          finishedAtTo ? "" + finishedAtTo.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProductionEvents(_response);
      });
  }

  protected processGetProductionEvents(
    response: AxiosResponse
  ): Promise<GetProductionLogsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetProductionLogsDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetProductionLogsDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetProductionLogsDto[]>(null as any);
  }

  /**
   * Get production events by asset for current shift
   * @param assetId Id of asset
   * @return Success
   */
  getProductionEventsByAssetId(
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ProductionLogDto[]> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/production-events/assets/{assetId}";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProductionEventsByAssetId(_response);
      });
  }

  protected processGetProductionEventsByAssetId(
    response: AxiosResponse
  ): Promise<ProductionLogDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ProductionLogDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ProductionLogDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ProductionLogDto[]>(null as any);
  }

  /**
   * Returns nested history of production event from provided logId source log and all relevant events (unlike plain version)
   * @param logId Id of the production event log
   * @return Success
   */
  getPlainProductionLogHistoryByLogId(
    logId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetPlainProductionLogHistoryByLogIdDto[]> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/production-events/{logId}/history/plain";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPlainProductionLogHistoryByLogId(_response);
      });
  }

  protected processGetPlainProductionLogHistoryByLogId(
    response: AxiosResponse
  ): Promise<GetPlainProductionLogHistoryByLogIdDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetPlainProductionLogHistoryByLogIdDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetPlainProductionLogHistoryByLogIdDto[]>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetPlainProductionLogHistoryByLogIdDto[]>(
      null as any
    );
  }

  /**
   * Returns nested history of production event from provided logId source log and all relevant events (unlike plain version)
   * @param logId Id of the production event log
   * @return Success
   */
  getNestedProductionLogHistoryByLogId(
    logId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetNestedProductionLogHistoryByLogIdDto> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/production-events/{logId}/history/nested";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNestedProductionLogHistoryByLogId(_response);
      });
  }

  protected processGetNestedProductionLogHistoryByLogId(
    response: AxiosResponse
  ): Promise<GetNestedProductionLogHistoryByLogIdDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetNestedProductionLogHistoryByLogIdDto.fromJS(resultData200);
      return Promise.resolve<GetNestedProductionLogHistoryByLogIdDto>(
        result200
      );
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetNestedProductionLogHistoryByLogIdDto>(
      null as any
    );
  }

  /**
   * Correct task production event
   * @param logId Id of the production event log to be corrected
   * @param body (optional) Details about corrected production event
   * @return Success
   */
  correctProductionEvent(
    logId: string,
    body: CorrectProductionLogRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CorrectProductionLogDto> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/production-events/{logId}/correct";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCorrectProductionEvent(_response);
      });
  }

  protected processCorrectProductionEvent(
    response: AxiosResponse
  ): Promise<CorrectProductionLogDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CorrectProductionLogDto.fromJS(resultData200);
      return Promise.resolve<CorrectProductionLogDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CorrectProductionLogDto>(null as any);
  }

  /**
   * Split task production event into separate events
   * @param logId Id of the production event log to be splitted
   * @param body (optional) Details about splitted production event
   * @return Success
   */
  splitProductionEvent(
    logId: string,
    body: SplitProductionLogRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<SplitProductionLogDto> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/production-events/{logId}/split";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSplitProductionEvent(_response);
      });
  }

  protected processSplitProductionEvent(
    response: AxiosResponse
  ): Promise<SplitProductionLogDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SplitProductionLogDto.fromJS(resultData200);
      return Promise.resolve<SplitProductionLogDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SplitProductionLogDto>(null as any);
  }
}

export class ProductionReasonsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Get production reasons
   * @return Success
   */
  getProductionReasons(
    cancelToken?: CancelToken | undefined
  ): Promise<ProductionReasonDto[]> {
    let url_ = this.baseUrl + "/api/manufacturing-execution/production-reasons";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProductionReasons(_response);
      });
  }

  protected processGetProductionReasons(
    response: AxiosResponse
  ): Promise<ProductionReasonDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ProductionReasonDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ProductionReasonDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ProductionReasonDto[]>(null as any);
  }
}

export class RolesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Get roles
   * @return Success
   */
  getRoles(cancelToken?: CancelToken | undefined): Promise<RoleDto[]> {
    let url_ = this.baseUrl + "/api/access-management/roles";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRoles(_response);
      });
  }

  protected processGetRoles(response: AxiosResponse): Promise<RoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(RoleDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<RoleDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RoleDto[]>(null as any);
  }

  /**
   * Add role
   * @param body (optional) Create role request
   * @return Success
   */
  addRole(
    body: CreateRoleRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateRoleDto> {
    let url_ = this.baseUrl + "/api/access-management/roles";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddRole(_response);
      });
  }

  protected processAddRole(response: AxiosResponse): Promise<CreateRoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateRoleDto.fromJS(resultData200);
      return Promise.resolve<CreateRoleDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateRoleDto>(null as any);
  }

  /**
   * Get role by given id
   * @param roleId Given role id
   * @return Success
   */
  getRoleById(
    roleId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<RoleDto> {
    let url_ = this.baseUrl + "/api/access-management/roles/{roleId}";
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRoleById(_response);
      });
  }

  protected processGetRoleById(response: AxiosResponse): Promise<RoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RoleDto.fromJS(resultData200);
      return Promise.resolve<RoleDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RoleDto>(null as any);
  }

  /**
   * Change role details
   * @param roleId Role id
   * @param body (optional) Change role request
   * @return No Content
   */
  changeRoleDetails(
    roleId: string,
    body: ChangeRoleDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/access-management/roles/{roleId}";
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeRoleDetails(_response);
      });
  }

  protected processChangeRoleDetails(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Deletes role
   * @param roleId Role id
   * @return No Content
   */
  deleteRole(
    roleId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/access-management/roles/delete/{roleId}";
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteRole(_response);
      });
  }

  protected processDeleteRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class ShiftTemplatesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllShiftTemplates(
    cancelToken?: CancelToken | undefined
  ): Promise<ShiftTemplateDto[]> {
    let url_ = this.baseUrl + "/api/production-planning/shift-templates";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllShiftTemplates(_response);
      });
  }

  protected processGetAllShiftTemplates(
    response: AxiosResponse
  ): Promise<ShiftTemplateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ShiftTemplateDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ShiftTemplateDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ShiftTemplateDto[]>(null as any);
  }

  /**
   * Creates new shift template
   * @param body (optional) ShiftTemplateType: 0 - Regular, 1 - Holiday
   * @return Success
   */
  createShiftTemplate(
    body: CreateShiftTemplateRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateShiftTemplateDto> {
    let url_ = this.baseUrl + "/api/production-planning/shift-templates";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateShiftTemplate(_response);
      });
  }

  protected processCreateShiftTemplate(
    response: AxiosResponse
  ): Promise<CreateShiftTemplateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateShiftTemplateDto.fromJS(resultData200);
      return Promise.resolve<CreateShiftTemplateDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateShiftTemplateDto>(null as any);
  }

  /**
   * @return No Content
   */
  specifyShiftSchedule(
    shiftTemplateId: string,
    periodId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/production-planning/shift-templates/{shiftTemplateId}/periods/{periodId}";
    if (shiftTemplateId === undefined || shiftTemplateId === null)
      throw new Error("The parameter 'shiftTemplateId' must be defined.");
    url_ = url_.replace(
      "{shiftTemplateId}",
      encodeURIComponent("" + shiftTemplateId)
    );
    if (periodId === undefined || periodId === null)
      throw new Error("The parameter 'periodId' must be defined.");
    url_ = url_.replace("{periodId}", encodeURIComponent("" + periodId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSpecifyShiftSchedule(_response);
      });
  }

  protected processSpecifyShiftSchedule(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return No Content
   */
  assignShiftTempleteToAsset(
    shiftTemplateId: string,
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/production-planning/shift-templates/{shiftTemplateId}/assets/{assetId}";
    if (shiftTemplateId === undefined || shiftTemplateId === null)
      throw new Error("The parameter 'shiftTemplateId' must be defined.");
    url_ = url_.replace(
      "{shiftTemplateId}",
      encodeURIComponent("" + shiftTemplateId)
    );
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAssignShiftTempleteToAsset(_response);
      });
  }

  protected processAssignShiftTempleteToAsset(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class SystemAttributeGroupsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createSystemAttributeGroup(
    body: CreateSystemAttributeGroupRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateSystemAttributeGroupDto> {
    let url_ = this.baseUrl + "/api/access-management/system-attribute-groups";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSystemAttributeGroup(_response);
      });
  }

  protected processCreateSystemAttributeGroup(
    response: AxiosResponse
  ): Promise<CreateSystemAttributeGroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateSystemAttributeGroupDto.fromJS(resultData200);
      return Promise.resolve<CreateSystemAttributeGroupDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateSystemAttributeGroupDto>(null as any);
  }

  /**
   * @return Success
   */
  getNestedSystemAttributeGroups(
    cancelToken?: CancelToken | undefined
  ): Promise<NestedSystemAttributeGroupDTO[]> {
    let url_ =
      this.baseUrl + "/api/access-management/system-attribute-groups/nested";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNestedSystemAttributeGroups(_response);
      });
  }

  protected processGetNestedSystemAttributeGroups(
    response: AxiosResponse
  ): Promise<NestedSystemAttributeGroupDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(NestedSystemAttributeGroupDTO.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<NestedSystemAttributeGroupDTO[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<NestedSystemAttributeGroupDTO[]>(null as any);
  }

  /**
   * @return Success
   */
  getSystemAttributeGroupsById(
    groupId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<SystemAttributeGroupDTO> {
    let url_ =
      this.baseUrl + "/api/access-management/system-attribute-groups/{groupId}";
    if (groupId === undefined || groupId === null)
      throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSystemAttributeGroupsById(_response);
      });
  }

  protected processGetSystemAttributeGroupsById(
    response: AxiosResponse
  ): Promise<SystemAttributeGroupDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SystemAttributeGroupDTO.fromJS(resultData200);
      return Promise.resolve<SystemAttributeGroupDTO>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SystemAttributeGroupDTO>(null as any);
  }
}

export class SystemAttributesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createSystemAttribute(
    body: CreateSystemAttributeRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateSystemAttributeDto> {
    let url_ = this.baseUrl + "/api/access-management/system-attributes";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSystemAttribute(_response);
      });
  }

  protected processCreateSystemAttribute(
    response: AxiosResponse
  ): Promise<CreateSystemAttributeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateSystemAttributeDto.fromJS(resultData200);
      return Promise.resolve<CreateSystemAttributeDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateSystemAttributeDto>(null as any);
  }

  /**
   * Get all system attributes
   * @return Success
   */
  getAllSystemAttributes(
    cancelToken?: CancelToken | undefined
  ): Promise<SystemAttributeDTO[]> {
    let url_ = this.baseUrl + "/api/access-management/system-attributes";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllSystemAttributes(_response);
      });
  }

  protected processGetAllSystemAttributes(
    response: AxiosResponse
  ): Promise<SystemAttributeDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(SystemAttributeDTO.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<SystemAttributeDTO[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SystemAttributeDTO[]>(null as any);
  }

  /**
   * @return Success
   */
  assignSystemAttributeToAsset(
    systemAttributeId: string,
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<AssignSystemAttributeToAssetDto> {
    let url_ =
      this.baseUrl +
      "/api/access-management/system-attributes/{systemAttributeId}/link/assets/{assetId}";
    if (systemAttributeId === undefined || systemAttributeId === null)
      throw new Error("The parameter 'systemAttributeId' must be defined.");
    url_ = url_.replace(
      "{systemAttributeId}",
      encodeURIComponent("" + systemAttributeId)
    );
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAssignSystemAttributeToAsset(_response);
      });
  }

  protected processAssignSystemAttributeToAsset(
    response: AxiosResponse
  ): Promise<AssignSystemAttributeToAssetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AssignSystemAttributeToAssetDto.fromJS(resultData200);
      return Promise.resolve<AssignSystemAttributeToAssetDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AssignSystemAttributeToAssetDto>(null as any);
  }

  /**
   * Get system attribute by id
   * @return Success
   */
  getSystemAttributeById(
    systemAttributeId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<SystemAttributeDTO> {
    let url_ =
      this.baseUrl +
      "/api/access-management/system-attributes/{systemAttributeId}";
    if (systemAttributeId === undefined || systemAttributeId === null)
      throw new Error("The parameter 'systemAttributeId' must be defined.");
    url_ = url_.replace(
      "{systemAttributeId}",
      encodeURIComponent("" + systemAttributeId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSystemAttributeById(_response);
      });
  }

  protected processGetSystemAttributeById(
    response: AxiosResponse
  ): Promise<SystemAttributeDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SystemAttributeDTO.fromJS(resultData200);
      return Promise.resolve<SystemAttributeDTO>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SystemAttributeDTO>(null as any);
  }

  /**
   * Remove system attribute
   * @param systemAttributeId Id of system attribute
   * @return No Content
   */
  deleteSystemAttribute(
    systemAttributeId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/access-management/system-attributes/{systemAttributeId}";
    if (systemAttributeId === undefined || systemAttributeId === null)
      throw new Error("The parameter 'systemAttributeId' must be defined.");
    url_ = url_.replace(
      "{systemAttributeId}",
      encodeURIComponent("" + systemAttributeId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSystemAttribute(_response);
      });
  }

  protected processDeleteSystemAttribute(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get system attribute by group id
   * @return Success
   */
  getSystemAttributesByGroupId(
    groupId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<SystemAttributeDTO[]> {
    let url_ =
      this.baseUrl +
      "/api/access-management/system-attributes/system-attribute-groups/{groupId}";
    if (groupId === undefined || groupId === null)
      throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSystemAttributesByGroupId(_response);
      });
  }

  protected processGetSystemAttributesByGroupId(
    response: AxiosResponse
  ): Promise<SystemAttributeDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(SystemAttributeDTO.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<SystemAttributeDTO[]>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SystemAttributeDTO[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return No Content
   */
  changeSystemAttributeDetails(
    systemAttributeId: string,
    body: ChangeSystemAttributeDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/access-management/system-attributes/{systemAttributeId}/details";
    if (systemAttributeId === undefined || systemAttributeId === null)
      throw new Error("The parameter 'systemAttributeId' must be defined.");
    url_ = url_.replace(
      "{systemAttributeId}",
      encodeURIComponent("" + systemAttributeId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeSystemAttributeDetails(_response);
      });
  }

  protected processChangeSystemAttributeDetails(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class TaskEventsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param workOrderId (optional)
   * @param taskId (optional)
   * @param assetId (optional)
   * @param userId (optional)
   * @param isOngoing (optional)
   * @param startedAtFrom (optional)
   * @param startedAtTo (optional)
   * @param finishedAtFrom (optional)
   * @param finishedAtTo (optional)
   * @return Success
   */
  getTaskEvents(
    workOrderId: string | undefined,
    taskId: string | undefined,
    assetId: string | undefined,
    userId: string | undefined,
    isOngoing: boolean | undefined,
    startedAtFrom: Date | undefined,
    startedAtTo: Date | undefined,
    finishedAtFrom: Date | undefined,
    finishedAtTo: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetTaskLogsDto[]> {
    let url_ = this.baseUrl + "/api/manufacturing-execution/task-events?";
    if (workOrderId === null)
      throw new Error("The parameter 'workOrderId' cannot be null.");
    else if (workOrderId !== undefined)
      url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
    if (taskId === null)
      throw new Error("The parameter 'taskId' cannot be null.");
    else if (taskId !== undefined)
      url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
    if (assetId === null)
      throw new Error("The parameter 'assetId' cannot be null.");
    else if (assetId !== undefined)
      url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (isOngoing === null)
      throw new Error("The parameter 'isOngoing' cannot be null.");
    else if (isOngoing !== undefined)
      url_ += "isOngoing=" + encodeURIComponent("" + isOngoing) + "&";
    if (startedAtFrom === null)
      throw new Error("The parameter 'startedAtFrom' cannot be null.");
    else if (startedAtFrom !== undefined)
      url_ +=
        "startedAtFrom=" +
        encodeURIComponent(
          startedAtFrom ? "" + startedAtFrom.toISOString() : ""
        ) +
        "&";
    if (startedAtTo === null)
      throw new Error("The parameter 'startedAtTo' cannot be null.");
    else if (startedAtTo !== undefined)
      url_ +=
        "startedAtTo=" +
        encodeURIComponent(startedAtTo ? "" + startedAtTo.toISOString() : "") +
        "&";
    if (finishedAtFrom === null)
      throw new Error("The parameter 'finishedAtFrom' cannot be null.");
    else if (finishedAtFrom !== undefined)
      url_ +=
        "finishedAtFrom=" +
        encodeURIComponent(
          finishedAtFrom ? "" + finishedAtFrom.toISOString() : ""
        ) +
        "&";
    if (finishedAtTo === null)
      throw new Error("The parameter 'finishedAtTo' cannot be null.");
    else if (finishedAtTo !== undefined)
      url_ +=
        "finishedAtTo=" +
        encodeURIComponent(
          finishedAtTo ? "" + finishedAtTo.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTaskEvents(_response);
      });
  }

  protected processGetTaskEvents(
    response: AxiosResponse
  ): Promise<GetTaskLogsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetTaskLogsDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetTaskLogsDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetTaskLogsDto[]>(null as any);
  }
}

export class TaskLogonsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Logs user on selected task
   * @param body (optional) Log on task request details
   * @return No Content
   */
  logOnTask(
    body: LogOnTaskRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/access-management/task-logons/log-on";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogOnTask(_response);
      });
  }

  protected processLogOnTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Logs user off selected task
   * @param body (optional) Log off task request details
   * @return No Content
   */
  logOffTask(
    body: LogOffTaskRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/access-management/task-logons/log-off";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogOffTask(_response);
      });
  }

  protected processLogOffTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get task logons by filters
   * @param taskId (optional)
   * @param userId (optional)
   * @param isOngoing (optional)
   * @param startedAtFrom (optional)
   * @param startedAtTo (optional)
   * @param finishedAtFrom (optional)
   * @param finishedAtTo (optional)
   * @return Success
   */
  getTaskLogons(
    taskId: string | undefined,
    userId: string | undefined,
    isOngoing: boolean | undefined,
    startedAtFrom: Date | undefined,
    startedAtTo: Date | undefined,
    finishedAtFrom: Date | undefined,
    finishedAtTo: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<TaskLogonDTO[]> {
    let url_ = this.baseUrl + "/api/access-management/task-logons?";
    if (taskId === null)
      throw new Error("The parameter 'taskId' cannot be null.");
    else if (taskId !== undefined)
      url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (isOngoing === null)
      throw new Error("The parameter 'isOngoing' cannot be null.");
    else if (isOngoing !== undefined)
      url_ += "isOngoing=" + encodeURIComponent("" + isOngoing) + "&";
    if (startedAtFrom === null)
      throw new Error("The parameter 'startedAtFrom' cannot be null.");
    else if (startedAtFrom !== undefined)
      url_ +=
        "startedAtFrom=" +
        encodeURIComponent(
          startedAtFrom ? "" + startedAtFrom.toISOString() : ""
        ) +
        "&";
    if (startedAtTo === null)
      throw new Error("The parameter 'startedAtTo' cannot be null.");
    else if (startedAtTo !== undefined)
      url_ +=
        "startedAtTo=" +
        encodeURIComponent(startedAtTo ? "" + startedAtTo.toISOString() : "") +
        "&";
    if (finishedAtFrom === null)
      throw new Error("The parameter 'finishedAtFrom' cannot be null.");
    else if (finishedAtFrom !== undefined)
      url_ +=
        "finishedAtFrom=" +
        encodeURIComponent(
          finishedAtFrom ? "" + finishedAtFrom.toISOString() : ""
        ) +
        "&";
    if (finishedAtTo === null)
      throw new Error("The parameter 'finishedAtTo' cannot be null.");
    else if (finishedAtTo !== undefined)
      url_ +=
        "finishedAtTo=" +
        encodeURIComponent(
          finishedAtTo ? "" + finishedAtTo.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTaskLogons(_response);
      });
  }

  protected processGetTaskLogons(
    response: AxiosResponse
  ): Promise<TaskLogonDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(TaskLogonDTO.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<TaskLogonDTO[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<TaskLogonDTO[]>(null as any);
  }
}

export class TasksClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param workOrderId (optional)
   * @param name (optional)
   * @param nbr (optional)
   * @param description (optional)
   * @param taskStateId (optional)
   * @param itemId (optional)
   * @param notes (optional)
   * @param scheduledAssetId (optional)
   * @param priority (optional)
   * @param scheduledStartAtFrom (optional)
   * @param scheduledStartAtTo (optional)
   * @param scheduledFinishAtFrom (optional)
   * @param scheduledFinishAtTo (optional)
   * @return Success
   */
  getAllTasks(
    workOrderId: string | undefined,
    name: string | undefined,
    nbr: number | undefined,
    description: string | undefined,
    taskStateId: string | undefined,
    itemId: string | undefined,
    notes: string | undefined,
    scheduledAssetId: string | undefined,
    priority: number | undefined,
    scheduledStartAtFrom: Date | undefined,
    scheduledStartAtTo: Date | undefined,
    scheduledFinishAtFrom: Date | undefined,
    scheduledFinishAtTo: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<TaskDto[]> {
    let url_ = this.baseUrl + "/api/production-planning/tasks?";
    if (workOrderId === null)
      throw new Error("The parameter 'workOrderId' cannot be null.");
    else if (workOrderId !== undefined)
      url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (nbr === null) throw new Error("The parameter 'nbr' cannot be null.");
    else if (nbr !== undefined)
      url_ += "nbr=" + encodeURIComponent("" + nbr) + "&";
    if (description === null)
      throw new Error("The parameter 'description' cannot be null.");
    else if (description !== undefined)
      url_ += "description=" + encodeURIComponent("" + description) + "&";
    if (taskStateId === null)
      throw new Error("The parameter 'taskStateId' cannot be null.");
    else if (taskStateId !== undefined)
      url_ += "taskStateId=" + encodeURIComponent("" + taskStateId) + "&";
    if (itemId === null)
      throw new Error("The parameter 'itemId' cannot be null.");
    else if (itemId !== undefined)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (notes === null)
      throw new Error("The parameter 'notes' cannot be null.");
    else if (notes !== undefined)
      url_ += "notes=" + encodeURIComponent("" + notes) + "&";
    if (scheduledAssetId === null)
      throw new Error("The parameter 'scheduledAssetId' cannot be null.");
    else if (scheduledAssetId !== undefined)
      url_ +=
        "scheduledAssetId=" + encodeURIComponent("" + scheduledAssetId) + "&";
    if (priority === null)
      throw new Error("The parameter 'priority' cannot be null.");
    else if (priority !== undefined)
      url_ += "priority=" + encodeURIComponent("" + priority) + "&";
    if (scheduledStartAtFrom === null)
      throw new Error("The parameter 'scheduledStartAtFrom' cannot be null.");
    else if (scheduledStartAtFrom !== undefined)
      url_ +=
        "scheduledStartAtFrom=" +
        encodeURIComponent(
          scheduledStartAtFrom ? "" + scheduledStartAtFrom.toISOString() : ""
        ) +
        "&";
    if (scheduledStartAtTo === null)
      throw new Error("The parameter 'scheduledStartAtTo' cannot be null.");
    else if (scheduledStartAtTo !== undefined)
      url_ +=
        "scheduledStartAtTo=" +
        encodeURIComponent(
          scheduledStartAtTo ? "" + scheduledStartAtTo.toISOString() : ""
        ) +
        "&";
    if (scheduledFinishAtFrom === null)
      throw new Error("The parameter 'scheduledFinishAtFrom' cannot be null.");
    else if (scheduledFinishAtFrom !== undefined)
      url_ +=
        "scheduledFinishAtFrom=" +
        encodeURIComponent(
          scheduledFinishAtFrom ? "" + scheduledFinishAtFrom.toISOString() : ""
        ) +
        "&";
    if (scheduledFinishAtTo === null)
      throw new Error("The parameter 'scheduledFinishAtTo' cannot be null.");
    else if (scheduledFinishAtTo !== undefined)
      url_ +=
        "scheduledFinishAtTo=" +
        encodeURIComponent(
          scheduledFinishAtTo ? "" + scheduledFinishAtTo.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllTasks(_response);
      });
  }

  protected processGetAllTasks(response: AxiosResponse): Promise<TaskDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(TaskDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<TaskDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<TaskDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createTask(
    body: CreateTaskRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateTaskDto> {
    let url_ = this.baseUrl + "/api/production-planning/tasks";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateTask(_response);
      });
  }

  protected processCreateTask(response: AxiosResponse): Promise<CreateTaskDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateTaskDto.fromJS(resultData200);
      return Promise.resolve<CreateTaskDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = InvalidCommandExceptionProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateTaskDto>(null as any);
  }

  /**
   * @return Success
   */
  getTaskById(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetTaskByIdQueryDto> {
    let url_ = this.baseUrl + "/api/production-planning/tasks/{taskId}";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTaskById(_response);
      });
  }

  protected processGetTaskById(
    response: AxiosResponse
  ): Promise<GetTaskByIdQueryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetTaskByIdQueryDto.fromJS(resultData200);
      return Promise.resolve<GetTaskByIdQueryDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetTaskByIdQueryDto>(null as any);
  }

  /**
   * Deletes task. Task's state must be 'New'.
   * @param taskId The ID of the task to be deleted
   * @return No Content
   */
  deleteTask(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/production-planning/tasks/{taskId}";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteTask(_response);
      });
  }

  protected processDeleteTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return No Content
   */
  releaseTask(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/production-planning/tasks/{taskId}/release";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processReleaseTask(_response);
      });
  }

  protected processReleaseTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return No Content
   */
  cancelTask(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/production-planning/tasks/{taskId}/cancel";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCancelTask(_response);
      });
  }

  protected processCancelTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return No Content
   */
  restoreTask(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/production-planning/tasks/{taskId}/restore";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRestoreTask(_response);
      });
  }

  protected processRestoreTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return No Content
   */
  requeueTask(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/production-planning/tasks/{taskId}/requeue";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRequeueTask(_response);
      });
  }

  protected processRequeueTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Changes task definition details
   * @param taskId The ID of the task to be changed
   * @param body (optional) New details of the task
   * @return No Content
   */
  changeTaskDefinitionDetails(
    taskId: string,
    body: ChangeTaskDefinitionDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/production-planning/tasks/{taskId}/definition/details";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeTaskDefinitionDetails(_response);
      });
  }

  protected processChangeTaskDefinitionDetails(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Changes task execution details
   * @param taskId The ID of the task to be changed
   * @param body (optional) New details of the task
   * @return No Content
   */
  changeTaskExecutionDetails(
    taskId: string,
    body: ChangeTaskExecutionDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/production-planning/tasks/{taskId}/execution/details";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeTaskExecutionDetails(_response);
      });
  }

  protected processChangeTaskExecutionDetails(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Changes task schedule details
   * @param taskId The ID of the task to be changed
   * @param body (optional) New details of the task
   * @return No Content
   */
  changeTaskScheduleDetails(
    taskId: string,
    body: ChangeTaskScheduleDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/production-planning/tasks/{taskId}/schedule/details";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeTaskScheduleDetails(_response);
      });
  }

  protected processChangeTaskScheduleDetails(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return No Content
   */
  runTask(
    taskId: string,
    body: RunTaskRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/manufacturing-execution/tasks/{taskId}/run";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRunTask(_response);
      });
  }

  protected processRunTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return No Content
   */
  resumeTask(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/manufacturing-execution/tasks/{taskId}/resume";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processResumeTask(_response);
      });
  }

  protected processResumeTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return No Content
   */
  pauseTask(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/manufacturing-execution/tasks/{taskId}/pause";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPauseTask(_response);
      });
  }

  protected processPauseTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return No Content
   */
  completeTask(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/manufacturing-execution/tasks/{taskId}/end";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCompleteTask(_response);
      });
  }

  protected processCompleteTask(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return No Content
   */
  addGoodProduction(
    taskId: string,
    body: RegisterGoodProductionRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/tasks/{taskId}/add-good-production";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddGoodProduction(_response);
      });
  }

  protected processAddGoodProduction(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return No Content
   */
  addBadProduction(
    taskId: string,
    body: RegisterBadProductionRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/tasks/{taskId}/add-bad-production";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddBadProduction(_response);
      });
  }

  protected processAddBadProduction(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return No Content
   */
  reduceGoodProduction(
    taskId: string,
    body: UnregisterGoodProductionRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/tasks/{taskId}/reduce-good-production";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processReduceGoodProduction(_response);
      });
  }

  protected processReduceGoodProduction(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return No Content
   */
  reduceBadProduction(
    taskId: string,
    body: UnregisterBadProductionRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/tasks/{taskId}/reduce-bad-production";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processReduceBadProduction(_response);
      });
  }

  protected processReduceBadProduction(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  getWorkQueueByTaskId(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WorkQueueDto> {
    let url_ =
      this.baseUrl + "/api/manufacturing-execution/tasks/{taskId}/work-queue";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetWorkQueueByTaskId(_response);
      });
  }

  protected processGetWorkQueueByTaskId(
    response: AxiosResponse
  ): Promise<WorkQueueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WorkQueueDto.fromJS(resultData200);
      return Promise.resolve<WorkQueueDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WorkQueueDto>(null as any);
  }

  /**
   * @return Success
   */
  getWorkQueueByAssetId(
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WorkQueueDto[]> {
    let url_ =
      this.baseUrl +
      "/api/manufacturing-execution/tasks/assets/{assetId}/work-queue";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetWorkQueueByAssetId(_response);
      });
  }

  protected processGetWorkQueueByAssetId(
    response: AxiosResponse
  ): Promise<WorkQueueDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(WorkQueueDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<WorkQueueDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WorkQueueDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getRunnedTaskById(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<RunnedTaskDto> {
    let url_ = this.baseUrl + "/api/manufacturing-execution/tasks/{taskId}";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRunnedTaskById(_response);
      });
  }

  protected processGetRunnedTaskById(
    response: AxiosResponse
  ): Promise<RunnedTaskDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RunnedTaskDto.fromJS(resultData200);
      return Promise.resolve<RunnedTaskDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RunnedTaskDto>(null as any);
  }

  /**
   * @param workOrderId (optional)
   * @param name (optional)
   * @param description (optional)
   * @param taskStateNames (optional)
   * @param itemId (optional)
   * @param assetIds (optional)
   * @param notes (optional)
   * @param completedTimeRange (optional)
   * @param canceledTimeRange (optional)
   * @param priority (optional)
   * @return Success
   */
  getTasks(
    workOrderId: string | undefined,
    name: string | undefined,
    description: string | undefined,
    taskStateNames: string | undefined,
    itemId: string | undefined,
    assetIds: string | undefined,
    notes: string | undefined,
    completedTimeRange: number | undefined,
    canceledTimeRange: number | undefined,
    priority: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ManufacturingTaskDto[]> {
    let url_ = this.baseUrl + "/api/manufacturing-execution/tasks?";
    if (workOrderId === null)
      throw new Error("The parameter 'workOrderId' cannot be null.");
    else if (workOrderId !== undefined)
      url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (description === null)
      throw new Error("The parameter 'description' cannot be null.");
    else if (description !== undefined)
      url_ += "description=" + encodeURIComponent("" + description) + "&";
    if (taskStateNames === null)
      throw new Error("The parameter 'taskStateNames' cannot be null.");
    else if (taskStateNames !== undefined)
      url_ += "taskStateNames=" + encodeURIComponent("" + taskStateNames) + "&";
    if (itemId === null)
      throw new Error("The parameter 'itemId' cannot be null.");
    else if (itemId !== undefined)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (assetIds === null)
      throw new Error("The parameter 'assetIds' cannot be null.");
    else if (assetIds !== undefined)
      url_ += "assetIds=" + encodeURIComponent("" + assetIds) + "&";
    if (notes === null)
      throw new Error("The parameter 'notes' cannot be null.");
    else if (notes !== undefined)
      url_ += "notes=" + encodeURIComponent("" + notes) + "&";
    if (completedTimeRange === null)
      throw new Error("The parameter 'completedTimeRange' cannot be null.");
    else if (completedTimeRange !== undefined)
      url_ +=
        "completedTimeRange=" +
        encodeURIComponent("" + completedTimeRange) +
        "&";
    if (canceledTimeRange === null)
      throw new Error("The parameter 'canceledTimeRange' cannot be null.");
    else if (canceledTimeRange !== undefined)
      url_ +=
        "canceledTimeRange=" + encodeURIComponent("" + canceledTimeRange) + "&";
    if (priority === null)
      throw new Error("The parameter 'priority' cannot be null.");
    else if (priority !== undefined)
      url_ += "priority=" + encodeURIComponent("" + priority) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTasks(_response);
      });
  }

  protected processGetTasks(
    response: AxiosResponse
  ): Promise<ManufacturingTaskDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ManufacturingTaskDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ManufacturingTaskDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ManufacturingTaskDto[]>(null as any);
  }
}

export class TaskStatesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllTaskStates(
    cancelToken?: CancelToken | undefined
  ): Promise<TaskStateDto[]> {
    let url_ = this.baseUrl + "/api/production-planning/task-states";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllTaskStates(_response);
      });
  }

  protected processGetAllTaskStates(
    response: AxiosResponse
  ): Promise<TaskStateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(TaskStateDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<TaskStateDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<TaskStateDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getTaskStateById(
    taskStateId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<TaskStateDto> {
    let url_ =
      this.baseUrl + "/api/production-planning/task-states/{taskStateId}";
    if (taskStateId === undefined || taskStateId === null)
      throw new Error("The parameter 'taskStateId' must be defined.");
    url_ = url_.replace("{taskStateId}", encodeURIComponent("" + taskStateId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTaskStateById(_response);
      });
  }

  protected processGetTaskStateById(
    response: AxiosResponse
  ): Promise<TaskStateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TaskStateDto.fromJS(resultData200);
      return Promise.resolve<TaskStateDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<TaskStateDto>(null as any);
  }

  /**
   * @return Success
   */
  getAvailableTaskStatesByTaskId(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<TaskStateDto[]> {
    let url_ =
      this.baseUrl + "/api/production-planning/task-states/tasks/{taskId}";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAvailableTaskStatesByTaskId(_response);
      });
  }

  protected processGetAvailableTaskStatesByTaskId(
    response: AxiosResponse
  ): Promise<TaskStateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(TaskStateDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<TaskStateDto[]>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<TaskStateDto[]>(null as any);
  }
}

export class UomConversionsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createUomConv(
    body: CreateUomConvRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateUomConvDto> {
    let url_ = this.baseUrl + "/api/production-planning/uom-conversions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateUomConv(_response);
      });
  }

  protected processCreateUomConv(
    response: AxiosResponse
  ): Promise<CreateUomConvDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateUomConvDto.fromJS(resultData200);
      return Promise.resolve<CreateUomConvDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateUomConvDto>(null as any);
  }

  /**
   * @return Success
   */
  getAllUomConvs(cancelToken?: CancelToken | undefined): Promise<UomConvDto[]> {
    let url_ = this.baseUrl + "/api/production-planning/uom-conversions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllUomConvs(_response);
      });
  }

  protected processGetAllUomConvs(
    response: AxiosResponse
  ): Promise<UomConvDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UomConvDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UomConvDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UomConvDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getUomConvById(
    uomConversionId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UomConvDto> {
    let url_ =
      this.baseUrl +
      "/api/production-planning/uom-conversions/{uomConversionId}";
    if (uomConversionId === undefined || uomConversionId === null)
      throw new Error("The parameter 'uomConversionId' must be defined.");
    url_ = url_.replace(
      "{uomConversionId}",
      encodeURIComponent("" + uomConversionId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUomConvById(_response);
      });
  }

  protected processGetUomConvById(
    response: AxiosResponse
  ): Promise<UomConvDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UomConvDto.fromJS(resultData200);
      return Promise.resolve<UomConvDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UomConvDto>(null as any);
  }
}

export class UomsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createUom(
    body: CreateUomRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateUomDto> {
    let url_ = this.baseUrl + "/api/production-planning/uoms";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateUom(_response);
      });
  }

  protected processCreateUom(response: AxiosResponse): Promise<CreateUomDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateUomDto.fromJS(resultData200);
      return Promise.resolve<CreateUomDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateUomDto>(null as any);
  }

  /**
   * @param name (optional)
   * @param description (optional)
   * @param abbreviation (optional)
   * @return Success
   */
  getAllUom(
    name: string | undefined,
    description: string | undefined,
    abbreviation: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<UomDto[]> {
    let url_ = this.baseUrl + "/api/production-planning/uoms?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (description === null)
      throw new Error("The parameter 'description' cannot be null.");
    else if (description !== undefined)
      url_ += "description=" + encodeURIComponent("" + description) + "&";
    if (abbreviation === null)
      throw new Error("The parameter 'abbreviation' cannot be null.");
    else if (abbreviation !== undefined)
      url_ += "abbreviation=" + encodeURIComponent("" + abbreviation) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllUom(_response);
      });
  }

  protected processGetAllUom(response: AxiosResponse): Promise<UomDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(UomDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UomDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UomDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getUomById(
    uomId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UomDto> {
    let url_ = this.baseUrl + "/api/production-planning/uoms/{uomId}";
    if (uomId === undefined || uomId === null)
      throw new Error("The parameter 'uomId' must be defined.");
    url_ = url_.replace("{uomId}", encodeURIComponent("" + uomId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUomById(_response);
      });
  }

  protected processGetUomById(response: AxiosResponse): Promise<UomDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UomDto.fromJS(resultData200);
      return Promise.resolve<UomDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UomDto>(null as any);
  }
}

export class UsersClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Returns users
   * @param isActive (optional)
   * @return Success
   */
  getUsers(
    isActive: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<UserDto[]> {
    let url_ = this.baseUrl + "/api/access-management/users?";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUsers(_response);
      });
  }

  protected processGetUsers(response: AxiosResponse): Promise<UserDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(UserDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UserDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UserDto[]>(null as any);
  }

  /**
   * Add user
   * @param body (optional)
   * @return Success
   */
  registerUser(
    body: RegisterUserRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<RegisterUserDto> {
    let url_ = this.baseUrl + "/api/access-management/users";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRegisterUser(_response);
      });
  }

  protected processRegisterUser(
    response: AxiosResponse
  ): Promise<RegisterUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RegisterUserDto.fromJS(resultData200);
      return Promise.resolve<RegisterUserDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RegisterUserDto>(null as any);
  }

  /**
   * Get user by id
   * @return Success
   */
  getUserById(
    userId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UserDto> {
    let url_ = this.baseUrl + "/api/access-management/users/{userId}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUserById(_response);
      });
  }

  protected processGetUserById(response: AxiosResponse): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDto.fromJS(resultData200);
      return Promise.resolve<UserDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UserDto>(null as any);
  }

  /**
   * Get user by name
   * @return Success
   */
  getUserByUserName(
    userName: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UserDto> {
    let url_ =
      this.baseUrl + "/api/access-management/users/user-names/{userName}";
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUserByUserName(_response);
      });
  }

  protected processGetUserByUserName(
    response: AxiosResponse
  ): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDto.fromJS(resultData200);
      return Promise.resolve<UserDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UserDto>(null as any);
  }

  /**
   * Deactivates user
   * @param userId Id of user
   * @return No Content
   */
  deactivateUser(
    userId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/access-management/users/{userId}/deactivate";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeactivateUser(_response);
      });
  }

  protected processDeactivateUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Activates user
   * @param userId Id of user
   * @return No Content
   */
  activateUser(
    userId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/access-management/users/{userId}/activate";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PATCH",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processActivateUser(_response);
      });
  }

  protected processActivateUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Change user details
   * @param body (optional)
   * @return No Content
   */
  changeUserDetails(
    userId: string,
    body: ChangeUserDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/access-management/users/{userId}/details";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeUserDetails(_response);
      });
  }

  protected processChangeUserDetails(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Add user to role
   * @return No Content
   */
  addUserToRole(
    userId: string,
    roleId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/access-management/users/{userId}/link/roles/{roleId}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddUserToRole(_response);
      });
  }

  protected processAddUserToRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Remove user from role
   * @return No Content
   */
  removeUserFromRole(
    userId: string,
    roleId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/access-management/users/{userId}/link/roles/{roleId}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveUserFromRole(_response);
      });
  }

  protected processRemoveUserFromRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class UtilizationCategoriesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Creates new utilization category
   * @param body (optional) Create util category request
   * @return Success
   */
  createUtilCategory(
    body: CreateUtilCategoryRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateUtilCategoryDto> {
    let url_ = this.baseUrl + "/api/utilization/utilization-categories";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateUtilCategory(_response);
      });
  }

  protected processCreateUtilCategory(
    response: AxiosResponse
  ): Promise<CreateUtilCategoryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateUtilCategoryDto.fromJS(resultData200);
      return Promise.resolve<CreateUtilCategoryDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateUtilCategoryDto>(null as any);
  }

  /**
   * Return util categories
   * @return Success
   */
  getUtilCategories(
    cancelToken?: CancelToken | undefined
  ): Promise<UtilCategoryDto[]> {
    let url_ = this.baseUrl + "/api/utilization/utilization-categories";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilCategories(_response);
      });
  }

  protected processGetUtilCategories(
    response: AxiosResponse
  ): Promise<UtilCategoryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UtilCategoryDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UtilCategoryDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilCategoryDto[]>(null as any);
  }

  /**
   * Returns util category by its ID or null
   * @return Success
   */
  getUtilCategoryById(
    utilCategoryId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilCategoryDto> {
    let url_ =
      this.baseUrl + "/api/utilization/utilization-categories/{utilCategoryId}";
    if (utilCategoryId === undefined || utilCategoryId === null)
      throw new Error("The parameter 'utilCategoryId' must be defined.");
    url_ = url_.replace(
      "{utilCategoryId}",
      encodeURIComponent("" + utilCategoryId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilCategoryById(_response);
      });
  }

  protected processGetUtilCategoryById(
    response: AxiosResponse
  ): Promise<UtilCategoryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UtilCategoryDto.fromJS(resultData200);
      return Promise.resolve<UtilCategoryDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilCategoryDto>(null as any);
  }
}

export class UtilizationEventsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Returns util history
   * @param assetId (optional)
   * @param userId (optional)
   * @param isOngoing (optional)
   * @param startedAtFrom (optional)
   * @param startedAtTo (optional)
   * @param finishedAtFrom (optional)
   * @param finishedAtTo (optional)
   * @return Success
   */
  getUtilizationEvents(
    assetId: string | undefined,
    userId: string | undefined,
    isOngoing: boolean | undefined,
    startedAtFrom: Date | undefined,
    startedAtTo: Date | undefined,
    finishedAtFrom: Date | undefined,
    finishedAtTo: Date | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetUtilLogsDto[]> {
    let url_ = this.baseUrl + "/api/utilization/utilization-events?";
    if (assetId === null)
      throw new Error("The parameter 'assetId' cannot be null.");
    else if (assetId !== undefined)
      url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (isOngoing === null)
      throw new Error("The parameter 'isOngoing' cannot be null.");
    else if (isOngoing !== undefined)
      url_ += "isOngoing=" + encodeURIComponent("" + isOngoing) + "&";
    if (startedAtFrom === null)
      throw new Error("The parameter 'startedAtFrom' cannot be null.");
    else if (startedAtFrom !== undefined)
      url_ +=
        "startedAtFrom=" +
        encodeURIComponent(
          startedAtFrom ? "" + startedAtFrom.toISOString() : ""
        ) +
        "&";
    if (startedAtTo === null)
      throw new Error("The parameter 'startedAtTo' cannot be null.");
    else if (startedAtTo !== undefined)
      url_ +=
        "startedAtTo=" +
        encodeURIComponent(startedAtTo ? "" + startedAtTo.toISOString() : "") +
        "&";
    if (finishedAtFrom === null)
      throw new Error("The parameter 'finishedAtFrom' cannot be null.");
    else if (finishedAtFrom !== undefined)
      url_ +=
        "finishedAtFrom=" +
        encodeURIComponent(
          finishedAtFrom ? "" + finishedAtFrom.toISOString() : ""
        ) +
        "&";
    if (finishedAtTo === null)
      throw new Error("The parameter 'finishedAtTo' cannot be null.");
    else if (finishedAtTo !== undefined)
      url_ +=
        "finishedAtTo=" +
        encodeURIComponent(
          finishedAtTo ? "" + finishedAtTo.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilizationEvents(_response);
      });
  }

  protected processGetUtilizationEvents(
    response: AxiosResponse
  ): Promise<GetUtilLogsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetUtilLogsDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetUtilLogsDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetUtilLogsDto[]>(null as any);
  }

  /**
   * Returns single util event by id
   * @param logId Id of utilization event
   * @return Success
   */
  getUtilizationEventByLogId(
    logId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetUtilLogByIdDto> {
    let url_ = this.baseUrl + "/api/utilization/utilization-events/{logId}";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilizationEventByLogId(_response);
      });
  }

  protected processGetUtilizationEventByLogId(
    response: AxiosResponse
  ): Promise<GetUtilLogByIdDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetUtilLogByIdDto.fromJS(resultData200);
      return Promise.resolve<GetUtilLogByIdDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetUtilLogByIdDto>(null as any);
  }

  /**
   * Returns util history by asset for current shift
   * @param assetId ID of asset
   * @return Success
   */
  getUtilEventsByAssetId(
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetUtilLogsByAssetIdQueryDto[]> {
    let url_ =
      this.baseUrl + "/api/utilization/utilization-events/assets/{assetId}";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilEventsByAssetId(_response);
      });
  }

  protected processGetUtilEventsByAssetId(
    response: AxiosResponse
  ): Promise<GetUtilLogsByAssetIdQueryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetUtilLogsByAssetIdQueryDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetUtilLogsByAssetIdQueryDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetUtilLogsByAssetIdQueryDto[]>(null as any);
  }

  /**
   * Returns util raws history grouped by states by asset
   * @return Success
   */
  getUtilRawsGroupedByStatesByAssetId(
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetUtilRawsGroupedByStatesByAssetIdQueryDto[]> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-events/grouped-raws/{assetId}";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilRawsGroupedByStatesByAssetId(_response);
      });
  }

  protected processGetUtilRawsGroupedByStatesByAssetId(
    response: AxiosResponse
  ): Promise<GetUtilRawsGroupedByStatesByAssetIdQueryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(
            GetUtilRawsGroupedByStatesByAssetIdQueryDto.fromJS(item)
          );
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetUtilRawsGroupedByStatesByAssetIdQueryDto[]>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetUtilRawsGroupedByStatesByAssetIdQueryDto[]>(
      null as any
    );
  }

  /**
   * Returns plain history of utilization event from provided logId to the source
   * @return Success
   */
  getPlainUtilizationEventHistory(
    logId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetPlainUtilLogsByLogIdDto[]> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-events/{logId}/history/plain";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPlainUtilizationEventHistory(_response);
      });
  }

  protected processGetPlainUtilizationEventHistory(
    response: AxiosResponse
  ): Promise<GetPlainUtilLogsByLogIdDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetPlainUtilLogsByLogIdDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetPlainUtilLogsByLogIdDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetPlainUtilLogsByLogIdDto[]>(null as any);
  }

  /**
   * Returns nested history of utilization event from provided logId source log and all relevant events (unlike plain version)
   * @return Success
   */
  getNestedUtilizationEventHistory(
    logId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetNestedUtilLogsByLogIdDto> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-events/{logId}/history/nested";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNestedUtilizationEventHistory(_response);
      });
  }

  protected processGetNestedUtilizationEventHistory(
    response: AxiosResponse
  ): Promise<GetNestedUtilLogsByLogIdDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetNestedUtilLogsByLogIdDto.fromJS(resultData200);
      return Promise.resolve<GetNestedUtilLogsByLogIdDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetNestedUtilLogsByLogIdDto>(null as any);
  }

  /**
   * Correct asset utilization event
   * @param logId Id of the utilization event log to be corrected
   * @param body (optional) Details about corrected utilization event
   * @return Success
   */
  correctHistoricalAssetState(
    logId: string,
    body: CorrectUtilLogRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CorrectUtilLogDto> {
    let url_ =
      this.baseUrl + "/api/utilization/utilization-events/{logId}/correct";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCorrectHistoricalAssetState(_response);
      });
  }

  protected processCorrectHistoricalAssetState(
    response: AxiosResponse
  ): Promise<CorrectUtilLogDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CorrectUtilLogDto.fromJS(resultData200);
      return Promise.resolve<CorrectUtilLogDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CorrectUtilLogDto>(null as any);
  }

  /**
   * Split asset utilization event into two separate events
   * @param logId Id of the utilization event log to be splitted
   * @param body (optional) Details about splitted utilization event
   * @return Success
   */
  splitHistoricalAssetState(
    logId: string,
    body: SplitUtilLogRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<SplitUtilLogDto> {
    let url_ =
      this.baseUrl + "/api/utilization/utilization-events/{logId}/split";
    if (logId === undefined || logId === null)
      throw new Error("The parameter 'logId' must be defined.");
    url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSplitHistoricalAssetState(_response);
      });
  }

  protected processSplitHistoricalAssetState(
    response: AxiosResponse
  ): Promise<SplitUtilLogDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SplitUtilLogDto.fromJS(resultData200);
      return Promise.resolve<SplitUtilLogDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SplitUtilLogDto>(null as any);
  }

  /**
   * @return Success
   * @deprecated
   */
  getUtilizationSummaryByAsset(
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilizationSummaryDto[]> {
    let url_ =
      this.baseUrl +
      "/api/reporting/utilization-events/assets/{assetId}/summary";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilizationSummaryByAsset(_response);
      });
  }

  protected processGetUtilizationSummaryByAsset(
    response: AxiosResponse
  ): Promise<UtilizationSummaryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UtilizationSummaryDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UtilizationSummaryDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilizationSummaryDto[]>(null as any);
  }
}

export class UtilizationRawGroupsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Returns all util raw groups
   * @param name (optional)
   * @param isActive (optional)
   * @return Success
   */
  getAllUtilRawGroups(
    name: string | undefined,
    isActive: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilRawGroupDto[]> {
    let url_ = this.baseUrl + "/api/utilization/utilization-raw-groups?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllUtilRawGroups(_response);
      });
  }

  protected processGetAllUtilRawGroups(
    response: AxiosResponse
  ): Promise<UtilRawGroupDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UtilRawGroupDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UtilRawGroupDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilRawGroupDto[]>(null as any);
  }

  /**
   * Creates new util raw group
   * @param body (optional) Create util raw group request
   * @return Success
   */
  createUtilRawGroup(
    body: CreateUtilRawGroupRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateUtilRawGroupDto> {
    let url_ = this.baseUrl + "/api/utilization/utilization-raw-groups";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateUtilRawGroup(_response);
      });
  }

  protected processCreateUtilRawGroup(
    response: AxiosResponse
  ): Promise<CreateUtilRawGroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateUtilRawGroupDto.fromJS(resultData200);
      return Promise.resolve<CreateUtilRawGroupDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateUtilRawGroupDto>(null as any);
  }

  /**
   * Returns found util raw group by its ID or null
   * @param groupId ID of util raw group to be returned
   * @return Success
   */
  getUtilRawGroupById(
    groupId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilRawGroupDto> {
    let url_ =
      this.baseUrl + "/api/utilization/utilization-raw-groups/{groupId}";
    if (groupId === undefined || groupId === null)
      throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilRawGroupById(_response);
      });
  }

  protected processGetUtilRawGroupById(
    response: AxiosResponse
  ): Promise<UtilRawGroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UtilRawGroupDto.fromJS(resultData200);
      return Promise.resolve<UtilRawGroupDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilRawGroupDto>(null as any);
  }
}

export class UtilizationRawsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Returns all util raws
   * @param name (optional)
   * @param isActive (optional)
   * @return Success
   */
  getAllUtilRaws(
    name: string | undefined,
    isActive: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilRawDto[]> {
    let url_ = this.baseUrl + "/api/utilization/utilization-raws?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllUtilRaws(_response);
      });
  }

  protected processGetAllUtilRaws(
    response: AxiosResponse
  ): Promise<UtilRawDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UtilRawDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UtilRawDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilRawDto[]>(null as any);
  }

  /**
   * Creates new util raw
   * @param body (optional) Create util raw request
   * @return Success
   */
  createUtilRaw(
    body: CreateUtilRawRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateUtilRawDto> {
    let url_ = this.baseUrl + "/api/utilization/utilization-raws";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateUtilRaw(_response);
      });
  }

  protected processCreateUtilRaw(
    response: AxiosResponse
  ): Promise<CreateUtilRawDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateUtilRawDto.fromJS(resultData200);
      return Promise.resolve<CreateUtilRawDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateUtilRawDto>(null as any);
  }

  /**
   * Returns all util raws nested way
   * @return Success
   */
  getNestedUtilRaws(
    cancelToken?: CancelToken | undefined
  ): Promise<GetNestedUtilRawsQueryGroupDto[]> {
    let url_ = this.baseUrl + "/api/utilization/utilization-raws/nested";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNestedUtilRaws(_response);
      });
  }

  protected processGetNestedUtilRaws(
    response: AxiosResponse
  ): Promise<GetNestedUtilRawsQueryGroupDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetNestedUtilRawsQueryGroupDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetNestedUtilRawsQueryGroupDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetNestedUtilRawsQueryGroupDto[]>(null as any);
  }

  /**
   * Returns available util raws nested way
   * @param assetId Id of asset
   * @param utilRawId (optional) Id of current util raw (for change asset state) or util raw that will be corrected/splitted
   * @param actionType (optional) Enum indicating action type for which available util raws are returned (0 - change state, 1 - corret, 2 - split)
   * @return Success
   */
  getAvailableNestedUtilRawsByAsset(
    assetId: string,
    utilRawId: string | undefined,
    actionType: GetAvailableUtilRawsActionType | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetNestedAvailableUtilRawsQueryGroupDto[]> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-raws/assets/{assetId}/available/nested?";
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    if (utilRawId === null)
      throw new Error("The parameter 'utilRawId' cannot be null.");
    else if (utilRawId !== undefined)
      url_ += "utilRawId=" + encodeURIComponent("" + utilRawId) + "&";
    if (actionType === null)
      throw new Error("The parameter 'actionType' cannot be null.");
    else if (actionType !== undefined)
      url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAvailableNestedUtilRawsByAsset(_response);
      });
  }

  protected processGetAvailableNestedUtilRawsByAsset(
    response: AxiosResponse
  ): Promise<GetNestedAvailableUtilRawsQueryGroupDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetNestedAvailableUtilRawsQueryGroupDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GetNestedAvailableUtilRawsQueryGroupDto[]>(
        result200
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetNestedAvailableUtilRawsQueryGroupDto[]>(
      null as any
    );
  }

  /**
   * Returns found util raw by its ID or null
   * @param utilRawId ID of util raw to be returned
   * @return Success
   */
  getUtilRawById(
    utilRawId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilRawDto> {
    let url_ = this.baseUrl + "/api/utilization/utilization-raws/{utilRawId}";
    if (utilRawId === undefined || utilRawId === null)
      throw new Error("The parameter 'utilRawId' must be defined.");
    url_ = url_.replace("{utilRawId}", encodeURIComponent("" + utilRawId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilRawById(_response);
      });
  }

  protected processGetUtilRawById(
    response: AxiosResponse
  ): Promise<UtilRawDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UtilRawDto.fromJS(resultData200);
      return Promise.resolve<UtilRawDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilRawDto>(null as any);
  }

  /**
   * Allow util raw access for specified role
   * @param utilRawId Id of util raw
   * @param roleId Id of role
   * @return Success
   */
  allowUtilRawAccessForRole(
    utilRawId: string,
    roleId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<AllowUtilRawAccessForRoleDto> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-raws/{utilRawId}/link/roles/{roleId}";
    if (utilRawId === undefined || utilRawId === null)
      throw new Error("The parameter 'utilRawId' must be defined.");
    url_ = url_.replace("{utilRawId}", encodeURIComponent("" + utilRawId));
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAllowUtilRawAccessForRole(_response);
      });
  }

  protected processAllowUtilRawAccessForRole(
    response: AxiosResponse
  ): Promise<AllowUtilRawAccessForRoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AllowUtilRawAccessForRoleDto.fromJS(resultData200);
      return Promise.resolve<AllowUtilRawAccessForRoleDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AllowUtilRawAccessForRoleDto>(null as any);
  }

  /**
   * Remove util raw access for specified role
   * @param utilRawId Id of util raw
   * @param roleId Id of role
   * @return No Content
   */
  removeUtilRawAccessForRole(
    utilRawId: string,
    roleId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-raws/{utilRawId}/link/roles/{roleId}";
    if (utilRawId === undefined || utilRawId === null)
      throw new Error("The parameter 'utilRawId' must be defined.");
    url_ = url_.replace("{utilRawId}", encodeURIComponent("" + utilRawId));
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveUtilRawAccessForRole(_response);
      });
  }

  protected processRemoveUtilRawAccessForRole(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Allow util raw access on specified asset
   * @param utilRawId Id of util raw
   * @param assetId Id of asset
   * @return Success
   */
  allowUtilRawAccessOnAsset(
    utilRawId: string,
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<AllowUtilRawAccessOnAssetDto> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-raws/{utilRawId}/link/assets/{assetId}";
    if (utilRawId === undefined || utilRawId === null)
      throw new Error("The parameter 'utilRawId' must be defined.");
    url_ = url_.replace("{utilRawId}", encodeURIComponent("" + utilRawId));
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAllowUtilRawAccessOnAsset(_response);
      });
  }

  protected processAllowUtilRawAccessOnAsset(
    response: AxiosResponse
  ): Promise<AllowUtilRawAccessOnAssetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AllowUtilRawAccessOnAssetDto.fromJS(resultData200);
      return Promise.resolve<AllowUtilRawAccessOnAssetDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AllowUtilRawAccessOnAssetDto>(null as any);
  }

  /**
   * Remove util raw access on specified asset
   * @param utilRawId Id of util raw
   * @param assetId Id of asset
   * @return No Content
   */
  removeUtilRawAccessOnAsset(
    utilRawId: string,
    assetId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-raws/{utilRawId}/link/assets/{assetId}";
    if (utilRawId === undefined || utilRawId === null)
      throw new Error("The parameter 'utilRawId' must be defined.");
    url_ = url_.replace("{utilRawId}", encodeURIComponent("" + utilRawId));
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveUtilRawAccessOnAsset(_response);
      });
  }

  protected processRemoveUtilRawAccessOnAsset(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Allow util raw access for util raw
   * @param utilRawId Id of util raw
   * @param availableUtilRawId Id of utilRaw that will be available to select
   * @param body (optional) IsActiveOnAdd - specify if link works on change state command, IsActiveOnEdit - specify if link works on correct/split command, Bidirectional - specify if one or two directional links are needed
   * @return Success
   */
  allowUtilRawAccessForUtilRaw(
    utilRawId: string,
    availableUtilRawId: string,
    body: AllowUtilRawAccessForUtilRawRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AllowUtilRawAccessForUtilRawDto> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-raws/{utilRawId}/link/util-raws/{availableUtilRawId}";
    if (utilRawId === undefined || utilRawId === null)
      throw new Error("The parameter 'utilRawId' must be defined.");
    url_ = url_.replace("{utilRawId}", encodeURIComponent("" + utilRawId));
    if (availableUtilRawId === undefined || availableUtilRawId === null)
      throw new Error("The parameter 'availableUtilRawId' must be defined.");
    url_ = url_.replace(
      "{availableUtilRawId}",
      encodeURIComponent("" + availableUtilRawId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAllowUtilRawAccessForUtilRaw(_response);
      });
  }

  protected processAllowUtilRawAccessForUtilRaw(
    response: AxiosResponse
  ): Promise<AllowUtilRawAccessForUtilRawDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AllowUtilRawAccessForUtilRawDto.fromJS(resultData200);
      return Promise.resolve<AllowUtilRawAccessForUtilRawDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AllowUtilRawAccessForUtilRawDto>(null as any);
  }

  /**
   * Remove util raw access on util raw
   * @param utilRawId Id of util raw
   * @param availableUtilRawId Id of utilRaw that won't be available to select anymore
   * @return No Content
   */
  removeUtilRawAccessForUtilRaw(
    utilRawId: string,
    availableUtilRawId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-raws/{utilRawId}/link/util-raws/{availableUtilRawId}";
    if (utilRawId === undefined || utilRawId === null)
      throw new Error("The parameter 'utilRawId' must be defined.");
    url_ = url_.replace("{utilRawId}", encodeURIComponent("" + utilRawId));
    if (availableUtilRawId === undefined || availableUtilRawId === null)
      throw new Error("The parameter 'availableUtilRawId' must be defined.");
    url_ = url_.replace(
      "{availableUtilRawId}",
      encodeURIComponent("" + availableUtilRawId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveUtilRawAccessForUtilRaw(_response);
      });
  }

  protected processRemoveUtilRawAccessForUtilRaw(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Give util raw util category
   * @param utilRawId Id of util raw
   * @param utilCategoryId Id of util category
   * @return Success
   */
  giveUtilRawUtilCategory(
    utilRawId: string,
    utilCategoryId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GiveUtilRawUtilCategoryDto> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-raws/{utilRawId}/link/utilization-categories/{utilCategoryId}";
    if (utilRawId === undefined || utilRawId === null)
      throw new Error("The parameter 'utilRawId' must be defined.");
    url_ = url_.replace("{utilRawId}", encodeURIComponent("" + utilRawId));
    if (utilCategoryId === undefined || utilCategoryId === null)
      throw new Error("The parameter 'utilCategoryId' must be defined.");
    url_ = url_.replace(
      "{utilCategoryId}",
      encodeURIComponent("" + utilCategoryId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGiveUtilRawUtilCategory(_response);
      });
  }

  protected processGiveUtilRawUtilCategory(
    response: AxiosResponse
  ): Promise<GiveUtilRawUtilCategoryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GiveUtilRawUtilCategoryDto.fromJS(resultData200);
      return Promise.resolve<GiveUtilRawUtilCategoryDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GiveUtilRawUtilCategoryDto>(null as any);
  }

  /**
   * Remove util raw util category
   * @param utilRawId Id of util raw
   * @param utilCategoryId Id of util category
   * @return No Content
   */
  removeUtilRawUtilCategory(
    utilRawId: string,
    utilCategoryId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/utilization/utilization-raws/{utilRawId}/link/utilization-categories/{utilCategoryId}";
    if (utilRawId === undefined || utilRawId === null)
      throw new Error("The parameter 'utilRawId' must be defined.");
    url_ = url_.replace("{utilRawId}", encodeURIComponent("" + utilRawId));
    if (utilCategoryId === undefined || utilCategoryId === null)
      throw new Error("The parameter 'utilCategoryId' must be defined.");
    url_ = url_.replace(
      "{utilCategoryId}",
      encodeURIComponent("" + utilCategoryId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveUtilRawUtilCategory(_response);
      });
  }

  protected processRemoveUtilRawUtilCategory(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class UtilizationStateGroupsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Returns all util state groups
   * @param name (optional)
   * @param isActive (optional)
   * @return Success
   */
  getAllUtilStateGroups(
    name: string | undefined,
    isActive: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilStateGroupDto[]> {
    let url_ = this.baseUrl + "/api/utilization/utilization-state-groups?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllUtilStateGroups(_response);
      });
  }

  protected processGetAllUtilStateGroups(
    response: AxiosResponse
  ): Promise<UtilStateGroupDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UtilStateGroupDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UtilStateGroupDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilStateGroupDto[]>(null as any);
  }

  /**
   * Creates new util state group
   * @param body (optional) Create util state group request
   * @return Success
   */
  createUtilStateGroup(
    body: CreateUtilStateGroupRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateUtilStateGroupDto> {
    let url_ = this.baseUrl + "/api/utilization/utilization-state-groups";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateUtilStateGroup(_response);
      });
  }

  protected processCreateUtilStateGroup(
    response: AxiosResponse
  ): Promise<CreateUtilStateGroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateUtilStateGroupDto.fromJS(resultData200);
      return Promise.resolve<CreateUtilStateGroupDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateUtilStateGroupDto>(null as any);
  }

  /**
   * Returns found util state group by its ID or null
   * @param groupId ID of util state group to be returned
   * @return Success
   */
  getUtilStateGroupById(
    groupId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilStateGroupDto> {
    let url_ =
      this.baseUrl + "/api/utilization/utilization-state-groups/{groupId}";
    if (groupId === undefined || groupId === null)
      throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilStateGroupById(_response);
      });
  }

  protected processGetUtilStateGroupById(
    response: AxiosResponse
  ): Promise<UtilStateGroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UtilStateGroupDto.fromJS(resultData200);
      return Promise.resolve<UtilStateGroupDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilStateGroupDto>(null as any);
  }
}

export class UtilizationStatesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Returns all util states
   * @param name (optional)
   * @param isActive (optional)
   * @return Success
   */
  getAllUtilStates(
    name: string | undefined,
    isActive: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilStateDto[]> {
    let url_ = this.baseUrl + "/api/utilization/utilization-states?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllUtilStates(_response);
      });
  }

  protected processGetAllUtilStates(
    response: AxiosResponse
  ): Promise<UtilStateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UtilStateDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UtilStateDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilStateDto[]>(null as any);
  }

  /**
   * Creates new util state
   * @param body (optional) Create util state request
   * @return Success
   */
  createUtilState(
    body: CreateUtilStateRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateUtilStateDto> {
    let url_ = this.baseUrl + "/api/utilization/utilization-states";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateUtilState(_response);
      });
  }

  protected processCreateUtilState(
    response: AxiosResponse
  ): Promise<CreateUtilStateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateUtilStateDto.fromJS(resultData200);
      return Promise.resolve<CreateUtilStateDto>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateUtilStateDto>(null as any);
  }

  /**
   * Returns found util state by its ID or null
   * @param utilStateId ID of util state to be returned
   * @return Success
   */
  getUtilStateById(
    utilStateId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<UtilStateDto> {
    let url_ =
      this.baseUrl + "/api/utilization/utilization-states/{utilStateId}";
    if (utilStateId === undefined || utilStateId === null)
      throw new Error("The parameter 'utilStateId' must be defined.");
    url_ = url_.replace("{utilStateId}", encodeURIComponent("" + utilStateId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUtilStateById(_response);
      });
  }

  protected processGetUtilStateById(
    response: AxiosResponse
  ): Promise<UtilStateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UtilStateDto.fromJS(resultData200);
      return Promise.resolve<UtilStateDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("Not Found", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UtilStateDto>(null as any);
  }
}

export class WorkOrdersClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createWorkOrder(
    body: CreateWorkOrderRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateWorkOrderDto> {
    let url_ = this.baseUrl + "/api/production-planning/work-orders";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateWorkOrder(_response);
      });
  }

  protected processCreateWorkOrder(
    response: AxiosResponse
  ): Promise<CreateWorkOrderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateWorkOrderDto.fromJS(resultData200);
      return Promise.resolve<CreateWorkOrderDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = InvalidCommandExceptionProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateWorkOrderDto>(null as any);
  }

  /**
   * @param name (optional)
   * @return Success
   */
  getAllWorkOrders(
    name: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<WorkOrderDto[]> {
    let url_ = this.baseUrl + "/api/production-planning/work-orders?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllWorkOrders(_response);
      });
  }

  protected processGetAllWorkOrders(
    response: AxiosResponse
  ): Promise<WorkOrderDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(WorkOrderDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<WorkOrderDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WorkOrderDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getWorkOrderById(
    workOrderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetWorkOrderByIdQueryDto> {
    let url_ =
      this.baseUrl + "/api/production-planning/work-orders/{workOrderId}";
    if (workOrderId === undefined || workOrderId === null)
      throw new Error("The parameter 'workOrderId' must be defined.");
    url_ = url_.replace("{workOrderId}", encodeURIComponent("" + workOrderId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetWorkOrderById(_response);
      });
  }

  protected processGetWorkOrderById(
    response: AxiosResponse
  ): Promise<GetWorkOrderByIdQueryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetWorkOrderByIdQueryDto.fromJS(resultData200);
      return Promise.resolve<GetWorkOrderByIdQueryDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetWorkOrderByIdQueryDto>(null as any);
  }

  /**
   * Deletes work order. Can not contain any tasks.
   * @param workOrderId The ID of the work order to be deleted
   * @return No Content
   */
  deleteWorkOrder(
    workOrderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/production-planning/work-orders/{workOrderId}";
    if (workOrderId === undefined || workOrderId === null)
      throw new Error("The parameter 'workOrderId' must be defined.");
    url_ = url_.replace("{workOrderId}", encodeURIComponent("" + workOrderId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteWorkOrder(_response);
      });
  }

  protected processDeleteWorkOrder(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  getWorkOrderByTaskId(
    taskId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<GetWorkOrderByTaskIdQueryDto> {
    let url_ =
      this.baseUrl + "/api/production-planning/work-orders/tasks/{taskId}";
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetWorkOrderByTaskId(_response);
      });
  }

  protected processGetWorkOrderByTaskId(
    response: AxiosResponse
  ): Promise<GetWorkOrderByTaskIdQueryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetWorkOrderByTaskIdQueryDto.fromJS(resultData200);
      return Promise.resolve<GetWorkOrderByTaskIdQueryDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetWorkOrderByTaskIdQueryDto>(null as any);
  }

  /**
   * Changes work order definition details
   * @param workOrderId The ID of the work order to be changed
   * @param body (optional) New definition details of the work order
   * @return No Content
   */
  changeWorkOrderDefinitionDetails(
    workOrderId: string,
    body: ChangeWorkOrderDefinitionDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/production-planning/work-orders/{workOrderId}/definition/details";
    if (workOrderId === undefined || workOrderId === null)
      throw new Error("The parameter 'workOrderId' must be defined.");
    url_ = url_.replace("{workOrderId}", encodeURIComponent("" + workOrderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeWorkOrderDefinitionDetails(_response);
      });
  }

  protected processChangeWorkOrderDefinitionDetails(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Changes work order execution details
   * @param workOrderId The ID of the work order to be changed
   * @param body (optional) New execution details of the work order
   * @return No Content
   */
  changeWorkOrderExecutionDetails(
    workOrderId: string,
    body: ChangeWorkOrderExecutionDetailsRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/production-planning/work-orders/{workOrderId}/execution/details";
    if (workOrderId === undefined || workOrderId === null)
      throw new Error("The parameter 'workOrderId' must be defined.");
    url_ = url_.replace("{workOrderId}", encodeURIComponent("" + workOrderId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeWorkOrderExecutionDetails(_response);
      });
  }

  protected processChangeWorkOrderExecutionDetails(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class AllowUtilRawAccessForRoleDto
  implements IAllowUtilRawAccessForRoleDto
{
  linkId!: string;

  constructor(data?: IAllowUtilRawAccessForRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.linkId = _data["linkId"] !== undefined ? _data["linkId"] : <any>null;
    }
  }

  static fromJS(data: any): AllowUtilRawAccessForRoleDto {
    data = typeof data === "object" ? data : {};
    let result = new AllowUtilRawAccessForRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["linkId"] = this.linkId !== undefined ? this.linkId : <any>null;
    return data;
  }
}

export interface IAllowUtilRawAccessForRoleDto {
  linkId: string;
}

export class AllowUtilRawAccessForUtilRawDto
  implements IAllowUtilRawAccessForUtilRawDto
{
  directLinkId!: string;
  reverseLinkId!: string | null;

  constructor(data?: IAllowUtilRawAccessForUtilRawDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.directLinkId =
        _data["directLinkId"] !== undefined ? _data["directLinkId"] : <any>null;
      this.reverseLinkId =
        _data["reverseLinkId"] !== undefined
          ? _data["reverseLinkId"]
          : <any>null;
    }
  }

  static fromJS(data: any): AllowUtilRawAccessForUtilRawDto {
    data = typeof data === "object" ? data : {};
    let result = new AllowUtilRawAccessForUtilRawDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["directLinkId"] =
      this.directLinkId !== undefined ? this.directLinkId : <any>null;
    data["reverseLinkId"] =
      this.reverseLinkId !== undefined ? this.reverseLinkId : <any>null;
    return data;
  }
}

export interface IAllowUtilRawAccessForUtilRawDto {
  directLinkId: string;
  reverseLinkId: string | null;
}

export class AllowUtilRawAccessForUtilRawRequest
  implements IAllowUtilRawAccessForUtilRawRequest
{
  isActiveOnAdd!: boolean;
  isActiveOnEdit!: boolean;
  bidirectional!: boolean;

  constructor(data?: IAllowUtilRawAccessForUtilRawRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActiveOnAdd =
        _data["isActiveOnAdd"] !== undefined
          ? _data["isActiveOnAdd"]
          : <any>null;
      this.isActiveOnEdit =
        _data["isActiveOnEdit"] !== undefined
          ? _data["isActiveOnEdit"]
          : <any>null;
      this.bidirectional =
        _data["bidirectional"] !== undefined
          ? _data["bidirectional"]
          : <any>null;
    }
  }

  static fromJS(data: any): AllowUtilRawAccessForUtilRawRequest {
    data = typeof data === "object" ? data : {};
    let result = new AllowUtilRawAccessForUtilRawRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["isActiveOnAdd"] =
      this.isActiveOnAdd !== undefined ? this.isActiveOnAdd : <any>null;
    data["isActiveOnEdit"] =
      this.isActiveOnEdit !== undefined ? this.isActiveOnEdit : <any>null;
    data["bidirectional"] =
      this.bidirectional !== undefined ? this.bidirectional : <any>null;
    return data;
  }
}

export interface IAllowUtilRawAccessForUtilRawRequest {
  isActiveOnAdd: boolean;
  isActiveOnEdit: boolean;
  bidirectional: boolean;
}

export class AllowUtilRawAccessOnAssetDto
  implements IAllowUtilRawAccessOnAssetDto
{
  linkId!: string;

  constructor(data?: IAllowUtilRawAccessOnAssetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.linkId = _data["linkId"] !== undefined ? _data["linkId"] : <any>null;
    }
  }

  static fromJS(data: any): AllowUtilRawAccessOnAssetDto {
    data = typeof data === "object" ? data : {};
    let result = new AllowUtilRawAccessOnAssetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["linkId"] = this.linkId !== undefined ? this.linkId : <any>null;
    return data;
  }
}

export interface IAllowUtilRawAccessOnAssetDto {
  linkId: string;
}

export class AssetDto implements IAssetDto {
  id!: string;
  parentAssetId!: string | null;
  parentAssetName!: string | null;
  assetTypeId!: string;
  assetTypeName!: string | null;
  name!: string | null;
  description!: string | null;
  logInByPin!: boolean;
  currentUtilLogId!: string | null;
  currentUtilLogSliceId!: string | null;
  currentShiftTemplateId!: string | null;
  currentShiftStartTime!: Date | null;
  currentShiftEndTime!: Date | null;
  currentShiftLogId!: string | null;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;
  createdAt!: Date;
  editedById!: string | null;
  editedByUserName!: string | null;
  editedByFullName!: string | null;
  editedAt!: Date | null;
  isActive!: boolean;

  constructor(data?: IAssetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.parentAssetId =
        _data["parentAssetId"] !== undefined
          ? _data["parentAssetId"]
          : <any>null;
      this.parentAssetName =
        _data["parentAssetName"] !== undefined
          ? _data["parentAssetName"]
          : <any>null;
      this.assetTypeId =
        _data["assetTypeId"] !== undefined ? _data["assetTypeId"] : <any>null;
      this.assetTypeName =
        _data["assetTypeName"] !== undefined
          ? _data["assetTypeName"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.logInByPin =
        _data["logInByPin"] !== undefined ? _data["logInByPin"] : <any>null;
      this.currentUtilLogId =
        _data["currentUtilLogId"] !== undefined
          ? _data["currentUtilLogId"]
          : <any>null;
      this.currentUtilLogSliceId =
        _data["currentUtilLogSliceId"] !== undefined
          ? _data["currentUtilLogSliceId"]
          : <any>null;
      this.currentShiftTemplateId =
        _data["currentShiftTemplateId"] !== undefined
          ? _data["currentShiftTemplateId"]
          : <any>null;
      this.currentShiftStartTime = _data["currentShiftStartTime"]
        ? new Date(_data["currentShiftStartTime"].toString())
        : <any>null;
      this.currentShiftEndTime = _data["currentShiftEndTime"]
        ? new Date(_data["currentShiftEndTime"].toString())
        : <any>null;
      this.currentShiftLogId =
        _data["currentShiftLogId"] !== undefined
          ? _data["currentShiftLogId"]
          : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      this.editedById =
        _data["editedById"] !== undefined ? _data["editedById"] : <any>null;
      this.editedByUserName =
        _data["editedByUserName"] !== undefined
          ? _data["editedByUserName"]
          : <any>null;
      this.editedByFullName =
        _data["editedByFullName"] !== undefined
          ? _data["editedByFullName"]
          : <any>null;
      this.editedAt = _data["editedAt"]
        ? new Date(_data["editedAt"].toString())
        : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): AssetDto {
    data = typeof data === "object" ? data : {};
    let result = new AssetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["parentAssetId"] =
      this.parentAssetId !== undefined ? this.parentAssetId : <any>null;
    data["parentAssetName"] =
      this.parentAssetName !== undefined ? this.parentAssetName : <any>null;
    data["assetTypeId"] =
      this.assetTypeId !== undefined ? this.assetTypeId : <any>null;
    data["assetTypeName"] =
      this.assetTypeName !== undefined ? this.assetTypeName : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["logInByPin"] =
      this.logInByPin !== undefined ? this.logInByPin : <any>null;
    data["currentUtilLogId"] =
      this.currentUtilLogId !== undefined ? this.currentUtilLogId : <any>null;
    data["currentUtilLogSliceId"] =
      this.currentUtilLogSliceId !== undefined
        ? this.currentUtilLogSliceId
        : <any>null;
    data["currentShiftTemplateId"] =
      this.currentShiftTemplateId !== undefined
        ? this.currentShiftTemplateId
        : <any>null;
    data["currentShiftStartTime"] = this.currentShiftStartTime
      ? this.currentShiftStartTime.toISOString()
      : <any>null;
    data["currentShiftEndTime"] = this.currentShiftEndTime
      ? this.currentShiftEndTime.toISOString()
      : <any>null;
    data["currentShiftLogId"] =
      this.currentShiftLogId !== undefined ? this.currentShiftLogId : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data["editedById"] =
      this.editedById !== undefined ? this.editedById : <any>null;
    data["editedByUserName"] =
      this.editedByUserName !== undefined ? this.editedByUserName : <any>null;
    data["editedByFullName"] =
      this.editedByFullName !== undefined ? this.editedByFullName : <any>null;
    data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface IAssetDto {
  id: string;
  parentAssetId: string | null;
  parentAssetName: string | null;
  assetTypeId: string;
  assetTypeName: string | null;
  name: string | null;
  description: string | null;
  logInByPin: boolean;
  currentUtilLogId: string | null;
  currentUtilLogSliceId: string | null;
  currentShiftTemplateId: string | null;
  currentShiftStartTime: Date | null;
  currentShiftEndTime: Date | null;
  currentShiftLogId: string | null;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
  createdAt: Date;
  editedById: string | null;
  editedByUserName: string | null;
  editedByFullName: string | null;
  editedAt: Date | null;
  isActive: boolean;
}

export class AssetLogonDTO implements IAssetLogonDTO {
  assetId!: string;
  assetName!: string | null;
  userId!: string;
  userName!: string | null;
  userFullName!: string | null;
  connectionId!: string;
  startedAt!: Date;
  finishedAt!: Date | null;
  lastHeartbeatAt!: Date;

  constructor(data?: IAssetLogonDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
      this.userName =
        _data["userName"] !== undefined ? _data["userName"] : <any>null;
      this.userFullName =
        _data["userFullName"] !== undefined ? _data["userFullName"] : <any>null;
      this.connectionId =
        _data["connectionId"] !== undefined ? _data["connectionId"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.lastHeartbeatAt = _data["lastHeartbeatAt"]
        ? new Date(_data["lastHeartbeatAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): AssetLogonDTO {
    data = typeof data === "object" ? data : {};
    let result = new AssetLogonDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["userId"] = this.userId !== undefined ? this.userId : <any>null;
    data["userName"] = this.userName !== undefined ? this.userName : <any>null;
    data["userFullName"] =
      this.userFullName !== undefined ? this.userFullName : <any>null;
    data["connectionId"] =
      this.connectionId !== undefined ? this.connectionId : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["lastHeartbeatAt"] = this.lastHeartbeatAt
      ? this.lastHeartbeatAt.toISOString()
      : <any>null;
    return data;
  }
}

export interface IAssetLogonDTO {
  assetId: string;
  assetName: string | null;
  userId: string;
  userName: string | null;
  userFullName: string | null;
  connectionId: string;
  startedAt: Date;
  finishedAt: Date | null;
  lastHeartbeatAt: Date;
}

export class AssetTypeDto implements IAssetTypeDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;
  createdAt!: Date;
  editedById!: string | null;
  editedByUserName!: string | null;
  editedByFullName!: string | null;
  editedAt!: Date | null;
  isActive!: boolean;

  constructor(data?: IAssetTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      this.editedById =
        _data["editedById"] !== undefined ? _data["editedById"] : <any>null;
      this.editedByUserName =
        _data["editedByUserName"] !== undefined
          ? _data["editedByUserName"]
          : <any>null;
      this.editedByFullName =
        _data["editedByFullName"] !== undefined
          ? _data["editedByFullName"]
          : <any>null;
      this.editedAt = _data["editedAt"]
        ? new Date(_data["editedAt"].toString())
        : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): AssetTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new AssetTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data["editedById"] =
      this.editedById !== undefined ? this.editedById : <any>null;
    data["editedByUserName"] =
      this.editedByUserName !== undefined ? this.editedByUserName : <any>null;
    data["editedByFullName"] =
      this.editedByFullName !== undefined ? this.editedByFullName : <any>null;
    data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface IAssetTypeDto {
  id: string;
  name: string | null;
  description: string | null;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
  createdAt: Date;
  editedById: string | null;
  editedByUserName: string | null;
  editedByFullName: string | null;
  editedAt: Date | null;
  isActive: boolean;
}

export class AssignSystemAttributeToAssetDto
  implements IAssignSystemAttributeToAssetDto
{
  linkId!: string;

  constructor(data?: IAssignSystemAttributeToAssetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.linkId = _data["linkId"] !== undefined ? _data["linkId"] : <any>null;
    }
  }

  static fromJS(data: any): AssignSystemAttributeToAssetDto {
    data = typeof data === "object" ? data : {};
    let result = new AssignSystemAttributeToAssetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["linkId"] = this.linkId !== undefined ? this.linkId : <any>null;
    return data;
  }
}

export interface IAssignSystemAttributeToAssetDto {
  linkId: string;
}

export class ChangeAssetDetailsRequest implements IChangeAssetDetailsRequest {
  name!: string | null;
  description!: string | null;

  constructor(data?: IChangeAssetDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
    }
  }

  static fromJS(data: any): ChangeAssetDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeAssetDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    return data;
  }
}

export interface IChangeAssetDetailsRequest {
  name: string | null;
  description: string | null;
}

export class ChangeAssetPositionsRequest
  implements IChangeAssetPositionsRequest
{
  assetPositions!: number;

  constructor(data?: IChangeAssetPositionsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetPositions =
        _data["assetPositions"] !== undefined
          ? _data["assetPositions"]
          : <any>null;
    }
  }

  static fromJS(data: any): ChangeAssetPositionsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeAssetPositionsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetPositions"] =
      this.assetPositions !== undefined ? this.assetPositions : <any>null;
    return data;
  }
}

export interface IChangeAssetPositionsRequest {
  assetPositions: number;
}

export class ChangeAssetStateDto implements IChangeAssetStateDto {
  currentUtilLogId!: string;

  constructor(data?: IChangeAssetStateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentUtilLogId =
        _data["currentUtilLogId"] !== undefined
          ? _data["currentUtilLogId"]
          : <any>null;
    }
  }

  static fromJS(data: any): ChangeAssetStateDto {
    data = typeof data === "object" ? data : {};
    let result = new ChangeAssetStateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["currentUtilLogId"] =
      this.currentUtilLogId !== undefined ? this.currentUtilLogId : <any>null;
    return data;
  }
}

export interface IChangeAssetStateDto {
  currentUtilLogId: string;
}

export class ChangeAssetStateRequest implements IChangeAssetStateRequest {
  utilRawId!: string;
  comment!: string | null;

  constructor(data?: IChangeAssetStateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.utilRawId =
        _data["utilRawId"] !== undefined ? _data["utilRawId"] : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
    }
  }

  static fromJS(data: any): ChangeAssetStateRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeAssetStateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["utilRawId"] =
      this.utilRawId !== undefined ? this.utilRawId : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    return data;
  }
}

export interface IChangeAssetStateRequest {
  utilRawId: string;
  comment: string | null;
}

export class ChangeAssetTypeDetailsRequest
  implements IChangeAssetTypeDetailsRequest
{
  name!: string | null;
  description!: string | null;

  constructor(data?: IChangeAssetTypeDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
    }
  }

  static fromJS(data: any): ChangeAssetTypeDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeAssetTypeDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    return data;
  }
}

export interface IChangeAssetTypeDetailsRequest {
  name: string | null;
  description: string | null;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
  password!: string | null;

  constructor(data?: IChangePasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password =
        _data["password"] !== undefined ? _data["password"] : <any>null;
    }
  }

  static fromJS(data: any): ChangePasswordRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangePasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["password"] = this.password !== undefined ? this.password : <any>null;
    return data;
  }
}

export interface IChangePasswordRequest {
  password: string | null;
}

export class ChangeRoleDetailsRequest implements IChangeRoleDetailsRequest {
  name!: string | null;
  defaultLang!: string | null;
  defaultConfSet!: string | null;

  constructor(data?: IChangeRoleDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.defaultLang =
        _data["defaultLang"] !== undefined ? _data["defaultLang"] : <any>null;
      this.defaultConfSet =
        _data["defaultConfSet"] !== undefined
          ? _data["defaultConfSet"]
          : <any>null;
    }
  }

  static fromJS(data: any): ChangeRoleDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeRoleDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["defaultLang"] =
      this.defaultLang !== undefined ? this.defaultLang : <any>null;
    data["defaultConfSet"] =
      this.defaultConfSet !== undefined ? this.defaultConfSet : <any>null;
    return data;
  }
}

export interface IChangeRoleDetailsRequest {
  name: string | null;
  defaultLang: string | null;
  defaultConfSet: string | null;
}

export class ChangeSystemAttributeDetailsRequest
  implements IChangeSystemAttributeDetailsRequest
{
  name!: string | null;
  description!: string | null;
  value!: string | null;
  valueType!: ValueType;

  constructor(data?: IChangeSystemAttributeDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      this.valueType =
        _data["valueType"] !== undefined ? _data["valueType"] : <any>null;
    }
  }

  static fromJS(data: any): ChangeSystemAttributeDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeSystemAttributeDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["value"] = this.value !== undefined ? this.value : <any>null;
    data["valueType"] =
      this.valueType !== undefined ? this.valueType : <any>null;
    return data;
  }
}

export interface IChangeSystemAttributeDetailsRequest {
  name: string | null;
  description: string | null;
  value: string | null;
  valueType: ValueType;
}

export class ChangeTaskDefinitionDetailsRequest
  implements IChangeTaskDefinitionDetailsRequest
{
  name!: string | null;
  notes!: string | null;
  description!: string | null;
  priority!: number | null;

  constructor(data?: IChangeTaskDefinitionDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
    }
  }

  static fromJS(data: any): ChangeTaskDefinitionDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeTaskDefinitionDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    return data;
  }
}

export interface IChangeTaskDefinitionDetailsRequest {
  name: string | null;
  notes: string | null;
  description: string | null;
  priority: number | null;
}

export class ChangeTaskExecutionDetailsRequest
  implements IChangeTaskExecutionDetailsRequest
{
  nbr!: number | null;
  itemId!: string | null;
  quantityRequired!: number | null;
  uomConversionId!: string | null;
  productionRateUom!: ProductionRateUom;
  batchSize!: number | null;

  constructor(data?: IChangeTaskExecutionDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.nbr = _data["nbr"] !== undefined ? _data["nbr"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.uomConversionId =
        _data["uomConversionId"] !== undefined
          ? _data["uomConversionId"]
          : <any>null;
      this.productionRateUom =
        _data["productionRateUom"] !== undefined
          ? _data["productionRateUom"]
          : <any>null;
      this.batchSize =
        _data["batchSize"] !== undefined ? _data["batchSize"] : <any>null;
    }
  }

  static fromJS(data: any): ChangeTaskExecutionDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeTaskExecutionDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["nbr"] = this.nbr !== undefined ? this.nbr : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["uomConversionId"] =
      this.uomConversionId !== undefined ? this.uomConversionId : <any>null;
    data["productionRateUom"] =
      this.productionRateUom !== undefined ? this.productionRateUom : <any>null;
    data["batchSize"] =
      this.batchSize !== undefined ? this.batchSize : <any>null;
    return data;
  }
}

export interface IChangeTaskExecutionDetailsRequest {
  nbr: number | null;
  itemId: string | null;
  quantityRequired: number | null;
  uomConversionId: string | null;
  productionRateUom: ProductionRateUom;
  batchSize: number | null;
}

export class ChangeTaskScheduleDetailsRequest
  implements IChangeTaskScheduleDetailsRequest
{
  scheduledAssetId!: string | null;
  scheduledStartAt!: Date | null;
  scheduledFinishAt!: Date | null;
  estimatedProdRate!: number | null;

  constructor(data?: IChangeTaskScheduleDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scheduledAssetId =
        _data["scheduledAssetId"] !== undefined
          ? _data["scheduledAssetId"]
          : <any>null;
      this.scheduledStartAt = _data["scheduledStartAt"]
        ? new Date(_data["scheduledStartAt"].toString())
        : <any>null;
      this.scheduledFinishAt = _data["scheduledFinishAt"]
        ? new Date(_data["scheduledFinishAt"].toString())
        : <any>null;
      this.estimatedProdRate =
        _data["estimatedProdRate"] !== undefined
          ? _data["estimatedProdRate"]
          : <any>null;
    }
  }

  static fromJS(data: any): ChangeTaskScheduleDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeTaskScheduleDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["scheduledAssetId"] =
      this.scheduledAssetId !== undefined ? this.scheduledAssetId : <any>null;
    data["scheduledStartAt"] = this.scheduledStartAt
      ? this.scheduledStartAt.toISOString()
      : <any>null;
    data["scheduledFinishAt"] = this.scheduledFinishAt
      ? this.scheduledFinishAt.toISOString()
      : <any>null;
    data["estimatedProdRate"] =
      this.estimatedProdRate !== undefined ? this.estimatedProdRate : <any>null;
    return data;
  }
}

export interface IChangeTaskScheduleDetailsRequest {
  scheduledAssetId: string | null;
  scheduledStartAt: Date | null;
  scheduledFinishAt: Date | null;
  estimatedProdRate: number | null;
}

export class ChangeUserDetailsRequest implements IChangeUserDetailsRequest {
  userName!: string | null;
  firstName!: string | null;
  lastName!: string | null;
  description!: string | null;
  email!: string | null;
  expirationDate!: Date | null;

  constructor(data?: IChangeUserDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName =
        _data["userName"] !== undefined ? _data["userName"] : <any>null;
      this.firstName =
        _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
      this.lastName =
        _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
      this.expirationDate = _data["expirationDate"]
        ? new Date(_data["expirationDate"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): ChangeUserDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeUserDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userName"] = this.userName !== undefined ? this.userName : <any>null;
    data["firstName"] =
      this.firstName !== undefined ? this.firstName : <any>null;
    data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["email"] = this.email !== undefined ? this.email : <any>null;
    data["expirationDate"] = this.expirationDate
      ? this.expirationDate.toISOString()
      : <any>null;
    return data;
  }
}

export interface IChangeUserDetailsRequest {
  userName: string | null;
  firstName: string | null;
  lastName: string | null;
  description: string | null;
  email: string | null;
  expirationDate: Date | null;
}

export class ChangeWorkOrderDefinitionDetailsRequest
  implements IChangeWorkOrderDefinitionDetailsRequest
{
  name!: string | null;
  description!: string | null;
  notes!: string | null;

  constructor(data?: IChangeWorkOrderDefinitionDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
    }
  }

  static fromJS(data: any): ChangeWorkOrderDefinitionDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeWorkOrderDefinitionDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    return data;
  }
}

export interface IChangeWorkOrderDefinitionDetailsRequest {
  name: string | null;
  description: string | null;
  notes: string | null;
}

export class ChangeWorkOrderExecutionDetailsRequest
  implements IChangeWorkOrderExecutionDetailsRequest
{
  itemId!: string | null;
  quantityRequired!: number | null;
  dueDateTime!: Date | null;

  constructor(data?: IChangeWorkOrderExecutionDetailsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.dueDateTime = _data["dueDateTime"]
        ? new Date(_data["dueDateTime"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): ChangeWorkOrderExecutionDetailsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeWorkOrderExecutionDetailsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["dueDateTime"] = this.dueDateTime
      ? this.dueDateTime.toISOString()
      : <any>null;
    return data;
  }
}

export interface IChangeWorkOrderExecutionDetailsRequest {
  itemId: string | null;
  quantityRequired: number | null;
  dueDateTime: Date | null;
}

export class CheckPasswordRequest implements ICheckPasswordRequest {
  password!: string | null;

  constructor(data?: ICheckPasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password =
        _data["password"] !== undefined ? _data["password"] : <any>null;
    }
  }

  static fromJS(data: any): CheckPasswordRequest {
    data = typeof data === "object" ? data : {};
    let result = new CheckPasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["password"] = this.password !== undefined ? this.password : <any>null;
    return data;
  }
}

export interface ICheckPasswordRequest {
  password: string | null;
}

export enum ConnectionCategory {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export class ConnectionDTO implements IConnectionDTO {
  id!: string;
  connectionTypeId!: number;
  connectionTypeName!: string | null;
  connectionTypeDescription!: string | null;
  userId!: string;
  userName!: string | null;
  userFullName!: string | null;
  startedAt!: Date;
  finishedAt!: Date | null;
  expireAt!: Date;
  lastHeartbeatAt!: Date;

  constructor(data?: IConnectionDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.connectionTypeId =
        _data["connectionTypeId"] !== undefined
          ? _data["connectionTypeId"]
          : <any>null;
      this.connectionTypeName =
        _data["connectionTypeName"] !== undefined
          ? _data["connectionTypeName"]
          : <any>null;
      this.connectionTypeDescription =
        _data["connectionTypeDescription"] !== undefined
          ? _data["connectionTypeDescription"]
          : <any>null;
      this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
      this.userName =
        _data["userName"] !== undefined ? _data["userName"] : <any>null;
      this.userFullName =
        _data["userFullName"] !== undefined ? _data["userFullName"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.expireAt = _data["expireAt"]
        ? new Date(_data["expireAt"].toString())
        : <any>null;
      this.lastHeartbeatAt = _data["lastHeartbeatAt"]
        ? new Date(_data["lastHeartbeatAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): ConnectionDTO {
    data = typeof data === "object" ? data : {};
    let result = new ConnectionDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["connectionTypeId"] =
      this.connectionTypeId !== undefined ? this.connectionTypeId : <any>null;
    data["connectionTypeName"] =
      this.connectionTypeName !== undefined
        ? this.connectionTypeName
        : <any>null;
    data["connectionTypeDescription"] =
      this.connectionTypeDescription !== undefined
        ? this.connectionTypeDescription
        : <any>null;
    data["userId"] = this.userId !== undefined ? this.userId : <any>null;
    data["userName"] = this.userName !== undefined ? this.userName : <any>null;
    data["userFullName"] =
      this.userFullName !== undefined ? this.userFullName : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>null;
    data["lastHeartbeatAt"] = this.lastHeartbeatAt
      ? this.lastHeartbeatAt.toISOString()
      : <any>null;
    return data;
  }
}

export interface IConnectionDTO {
  id: string;
  connectionTypeId: number;
  connectionTypeName: string | null;
  connectionTypeDescription: string | null;
  userId: string;
  userName: string | null;
  userFullName: string | null;
  startedAt: Date;
  finishedAt: Date | null;
  expireAt: Date;
  lastHeartbeatAt: Date;
}

export class CorrectProductionLogDto implements ICorrectProductionLogDto {
  oldLogId!: string;
  newLogId!: string;
  newReasonLogId!: string | null;

  constructor(data?: ICorrectProductionLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.oldLogId =
        _data["oldLogId"] !== undefined ? _data["oldLogId"] : <any>null;
      this.newLogId =
        _data["newLogId"] !== undefined ? _data["newLogId"] : <any>null;
      this.newReasonLogId =
        _data["newReasonLogId"] !== undefined
          ? _data["newReasonLogId"]
          : <any>null;
    }
  }

  static fromJS(data: any): CorrectProductionLogDto {
    data = typeof data === "object" ? data : {};
    let result = new CorrectProductionLogDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["oldLogId"] = this.oldLogId !== undefined ? this.oldLogId : <any>null;
    data["newLogId"] = this.newLogId !== undefined ? this.newLogId : <any>null;
    data["newReasonLogId"] =
      this.newReasonLogId !== undefined ? this.newReasonLogId : <any>null;
    return data;
  }
}

export interface ICorrectProductionLogDto {
  oldLogId: string;
  newLogId: string;
  newReasonLogId: string | null;
}

export class CorrectProductionLogRequest
  implements ICorrectProductionLogRequest
{
  productionReasonId!: string | null;
  quantityProduced!: number;
  comment!: string | null;

  constructor(data?: ICorrectProductionLogRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productionReasonId =
        _data["productionReasonId"] !== undefined
          ? _data["productionReasonId"]
          : <any>null;
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
    }
  }

  static fromJS(data: any): CorrectProductionLogRequest {
    data = typeof data === "object" ? data : {};
    let result = new CorrectProductionLogRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["productionReasonId"] =
      this.productionReasonId !== undefined
        ? this.productionReasonId
        : <any>null;
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    return data;
  }
}

export interface ICorrectProductionLogRequest {
  productionReasonId: string | null;
  quantityProduced: number;
  comment: string | null;
}

export class CorrectUtilLogDto implements ICorrectUtilLogDto {
  oldLogId!: string;
  newLogId!: string;

  constructor(data?: ICorrectUtilLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.oldLogId =
        _data["oldLogId"] !== undefined ? _data["oldLogId"] : <any>null;
      this.newLogId =
        _data["newLogId"] !== undefined ? _data["newLogId"] : <any>null;
    }
  }

  static fromJS(data: any): CorrectUtilLogDto {
    data = typeof data === "object" ? data : {};
    let result = new CorrectUtilLogDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["oldLogId"] = this.oldLogId !== undefined ? this.oldLogId : <any>null;
    data["newLogId"] = this.newLogId !== undefined ? this.newLogId : <any>null;
    return data;
  }
}

export interface ICorrectUtilLogDto {
  oldLogId: string;
  newLogId: string;
}

export class CorrectUtilLogRequest implements ICorrectUtilLogRequest {
  newUtilRawId!: string;
  comment!: string | null;

  constructor(data?: ICorrectUtilLogRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.newUtilRawId =
        _data["newUtilRawId"] !== undefined ? _data["newUtilRawId"] : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
    }
  }

  static fromJS(data: any): CorrectUtilLogRequest {
    data = typeof data === "object" ? data : {};
    let result = new CorrectUtilLogRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["newUtilRawId"] =
      this.newUtilRawId !== undefined ? this.newUtilRawId : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    return data;
  }
}

export interface ICorrectUtilLogRequest {
  newUtilRawId: string;
  comment: string | null;
}

export class CreateAssetDto implements ICreateAssetDto {
  id!: string;

  constructor(data?: ICreateAssetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateAssetDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateAssetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateAssetDto {
  id: string;
}

export class CreateAssetRequest implements ICreateAssetRequest {
  parentAssetId!: string | null;
  assetTypeId!: string;
  name!: string | null;
  description!: string | null;
  logInByPin!: boolean;
  assetPositions!: number;
  isActive!: boolean;

  constructor(data?: ICreateAssetRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentAssetId =
        _data["parentAssetId"] !== undefined
          ? _data["parentAssetId"]
          : <any>null;
      this.assetTypeId =
        _data["assetTypeId"] !== undefined ? _data["assetTypeId"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.logInByPin =
        _data["logInByPin"] !== undefined ? _data["logInByPin"] : <any>null;
      this.assetPositions =
        _data["assetPositions"] !== undefined
          ? _data["assetPositions"]
          : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): CreateAssetRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateAssetRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["parentAssetId"] =
      this.parentAssetId !== undefined ? this.parentAssetId : <any>null;
    data["assetTypeId"] =
      this.assetTypeId !== undefined ? this.assetTypeId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["logInByPin"] =
      this.logInByPin !== undefined ? this.logInByPin : <any>null;
    data["assetPositions"] =
      this.assetPositions !== undefined ? this.assetPositions : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface ICreateAssetRequest {
  parentAssetId: string | null;
  assetTypeId: string;
  name: string | null;
  description: string | null;
  logInByPin: boolean;
  assetPositions: number;
  isActive: boolean;
}

export class CreateAssetTypeDto implements ICreateAssetTypeDto {
  id!: string;

  constructor(data?: ICreateAssetTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateAssetTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateAssetTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateAssetTypeDto {
  id: string;
}

export class CreateAssetTypeRequest implements ICreateAssetTypeRequest {
  name!: string | null;
  description!: string | null;
  isActive!: boolean;

  constructor(data?: ICreateAssetTypeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): CreateAssetTypeRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateAssetTypeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface ICreateAssetTypeRequest {
  name: string | null;
  description: string | null;
  isActive: boolean;
}

export class CreateItemDto implements ICreateItemDto {
  id!: string;

  constructor(data?: ICreateItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateItemDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateItemDto {
  id: string;
}

export class CreateItemRequest implements ICreateItemRequest {
  name!: string | null;
  description!: string | null;
  nomProdRate!: number | null;
  nomCovTime!: number | null;
  notes!: string | null;
  uomId!: string;
  itemTypeId!: string;

  constructor(data?: ICreateItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.nomProdRate =
        _data["nomProdRate"] !== undefined ? _data["nomProdRate"] : <any>null;
      this.nomCovTime =
        _data["nomCovTime"] !== undefined ? _data["nomCovTime"] : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.uomId = _data["uomId"] !== undefined ? _data["uomId"] : <any>null;
      this.itemTypeId =
        _data["itemTypeId"] !== undefined ? _data["itemTypeId"] : <any>null;
    }
  }

  static fromJS(data: any): CreateItemRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["nomProdRate"] =
      this.nomProdRate !== undefined ? this.nomProdRate : <any>null;
    data["nomCovTime"] =
      this.nomCovTime !== undefined ? this.nomCovTime : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["uomId"] = this.uomId !== undefined ? this.uomId : <any>null;
    data["itemTypeId"] =
      this.itemTypeId !== undefined ? this.itemTypeId : <any>null;
    return data;
  }
}

export interface ICreateItemRequest {
  name: string | null;
  description: string | null;
  nomProdRate: number | null;
  nomCovTime: number | null;
  notes: string | null;
  uomId: string;
  itemTypeId: string;
}

export class CreateItemTypeDto implements ICreateItemTypeDto {
  id!: string;

  constructor(data?: ICreateItemTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateItemTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateItemTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateItemTypeDto {
  id: string;
}

export class CreateItemTypeRequest implements ICreateItemTypeRequest {
  name!: string | null;
  description!: string | null;
  state!: ItemTypeState;

  constructor(data?: ICreateItemTypeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
    }
  }

  static fromJS(data: any): CreateItemTypeRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateItemTypeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["state"] = this.state !== undefined ? this.state : <any>null;
    return data;
  }
}

export interface ICreateItemTypeRequest {
  name: string | null;
  description: string | null;
  state: ItemTypeState;
}

export class CreatePeriodDto implements ICreatePeriodDto {
  id!: string;

  constructor(data?: ICreatePeriodDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreatePeriodDto {
    data = typeof data === "object" ? data : {};
    let result = new CreatePeriodDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreatePeriodDto {
  id: string;
}

export class CreatePeriodRequest implements ICreatePeriodRequest {
  name!: string | null;
  startTime!: string;
  endTime!: string;
  startDate!: Date;
  endDate!: Date;
  recurrence!: Recurrence;
  interval!: number | null;
  monday!: boolean;
  tuesday!: boolean;
  wednesday!: boolean;
  thursday!: boolean;
  friday!: boolean;
  saturday!: boolean;
  sunday!: boolean;

  constructor(data?: ICreatePeriodRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.startTime =
        _data["startTime"] !== undefined ? _data["startTime"] : <any>null;
      this.endTime =
        _data["endTime"] !== undefined ? _data["endTime"] : <any>null;
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : <any>null;
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : <any>null;
      this.recurrence =
        _data["recurrence"] !== undefined ? _data["recurrence"] : <any>null;
      this.interval =
        _data["interval"] !== undefined ? _data["interval"] : <any>null;
      this.monday = _data["monday"] !== undefined ? _data["monday"] : <any>null;
      this.tuesday =
        _data["tuesday"] !== undefined ? _data["tuesday"] : <any>null;
      this.wednesday =
        _data["wednesday"] !== undefined ? _data["wednesday"] : <any>null;
      this.thursday =
        _data["thursday"] !== undefined ? _data["thursday"] : <any>null;
      this.friday = _data["friday"] !== undefined ? _data["friday"] : <any>null;
      this.saturday =
        _data["saturday"] !== undefined ? _data["saturday"] : <any>null;
      this.sunday = _data["sunday"] !== undefined ? _data["sunday"] : <any>null;
    }
  }

  static fromJS(data: any): CreatePeriodRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreatePeriodRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["startTime"] =
      this.startTime !== undefined ? this.startTime : <any>null;
    data["endTime"] = this.endTime !== undefined ? this.endTime : <any>null;
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : <any>null;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
    data["recurrence"] =
      this.recurrence !== undefined ? this.recurrence : <any>null;
    data["interval"] = this.interval !== undefined ? this.interval : <any>null;
    data["monday"] = this.monday !== undefined ? this.monday : <any>null;
    data["tuesday"] = this.tuesday !== undefined ? this.tuesday : <any>null;
    data["wednesday"] =
      this.wednesday !== undefined ? this.wednesday : <any>null;
    data["thursday"] = this.thursday !== undefined ? this.thursday : <any>null;
    data["friday"] = this.friday !== undefined ? this.friday : <any>null;
    data["saturday"] = this.saturday !== undefined ? this.saturday : <any>null;
    data["sunday"] = this.sunday !== undefined ? this.sunday : <any>null;
    return data;
  }
}

export interface ICreatePeriodRequest {
  name: string | null;
  startTime: string;
  endTime: string;
  startDate: Date;
  endDate: Date;
  recurrence: Recurrence;
  interval: number | null;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export class CreateRoleDto implements ICreateRoleDto {
  id!: string;

  constructor(data?: ICreateRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateRoleDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateRoleDto {
  id: string;
}

export class CreateRoleRequest implements ICreateRoleRequest {
  name!: string | null;
  defaultLang!: string | null;
  defaultConfSet!: string | null;

  constructor(data?: ICreateRoleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.defaultLang =
        _data["defaultLang"] !== undefined ? _data["defaultLang"] : <any>null;
      this.defaultConfSet =
        _data["defaultConfSet"] !== undefined
          ? _data["defaultConfSet"]
          : <any>null;
    }
  }

  static fromJS(data: any): CreateRoleRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateRoleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["defaultLang"] =
      this.defaultLang !== undefined ? this.defaultLang : <any>null;
    data["defaultConfSet"] =
      this.defaultConfSet !== undefined ? this.defaultConfSet : <any>null;
    return data;
  }
}

export interface ICreateRoleRequest {
  name: string | null;
  defaultLang: string | null;
  defaultConfSet: string | null;
}

export class CreateShiftTemplateDto implements ICreateShiftTemplateDto {
  id!: string;

  constructor(data?: ICreateShiftTemplateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateShiftTemplateDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateShiftTemplateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateShiftTemplateDto {
  id: string;
}

export class CreateShiftTemplateRequest implements ICreateShiftTemplateRequest {
  name!: string | null;
  description!: string | null;
  shiftTemplateType!: ShiftTemplateType;

  constructor(data?: ICreateShiftTemplateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.shiftTemplateType =
        _data["shiftTemplateType"] !== undefined
          ? _data["shiftTemplateType"]
          : <any>null;
    }
  }

  static fromJS(data: any): CreateShiftTemplateRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateShiftTemplateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["shiftTemplateType"] =
      this.shiftTemplateType !== undefined ? this.shiftTemplateType : <any>null;
    return data;
  }
}

export interface ICreateShiftTemplateRequest {
  name: string | null;
  description: string | null;
  shiftTemplateType: ShiftTemplateType;
}

export class CreateSystemAttributeDto implements ICreateSystemAttributeDto {
  id!: string;

  constructor(data?: ICreateSystemAttributeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateSystemAttributeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateSystemAttributeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateSystemAttributeDto {
  id: string;
}

export class CreateSystemAttributeGroupDto
  implements ICreateSystemAttributeGroupDto
{
  id!: string;

  constructor(data?: ICreateSystemAttributeGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateSystemAttributeGroupDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateSystemAttributeGroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateSystemAttributeGroupDto {
  id: string;
}

export class CreateSystemAttributeGroupRequest
  implements ICreateSystemAttributeGroupRequest
{
  name!: string | null;
  description!: string | null;
  parentSystemAttributeGroupId!: string | null;

  constructor(data?: ICreateSystemAttributeGroupRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.parentSystemAttributeGroupId =
        _data["parentSystemAttributeGroupId"] !== undefined
          ? _data["parentSystemAttributeGroupId"]
          : <any>null;
    }
  }

  static fromJS(data: any): CreateSystemAttributeGroupRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateSystemAttributeGroupRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["parentSystemAttributeGroupId"] =
      this.parentSystemAttributeGroupId !== undefined
        ? this.parentSystemAttributeGroupId
        : <any>null;
    return data;
  }
}

export interface ICreateSystemAttributeGroupRequest {
  name: string | null;
  description: string | null;
  parentSystemAttributeGroupId: string | null;
}

export class CreateSystemAttributeRequest
  implements ICreateSystemAttributeRequest
{
  systemAttributeGroupId!: string;
  name!: string | null;
  description!: string | null;
  value!: string | null;
  valueType!: ValueType;

  constructor(data?: ICreateSystemAttributeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.systemAttributeGroupId =
        _data["systemAttributeGroupId"] !== undefined
          ? _data["systemAttributeGroupId"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      this.valueType =
        _data["valueType"] !== undefined ? _data["valueType"] : <any>null;
    }
  }

  static fromJS(data: any): CreateSystemAttributeRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateSystemAttributeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["systemAttributeGroupId"] =
      this.systemAttributeGroupId !== undefined
        ? this.systemAttributeGroupId
        : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["value"] = this.value !== undefined ? this.value : <any>null;
    data["valueType"] =
      this.valueType !== undefined ? this.valueType : <any>null;
    return data;
  }
}

export interface ICreateSystemAttributeRequest {
  systemAttributeGroupId: string;
  name: string | null;
  description: string | null;
  value: string | null;
  valueType: ValueType;
}

export class CreateTaskDto implements ICreateTaskDto {
  id!: string;

  constructor(data?: ICreateTaskDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateTaskDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateTaskDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateTaskDto {
  id: string;
}

export class CreateTaskRequest implements ICreateTaskRequest {
  workOrderId!: string;
  name!: string | null;
  nbr!: number;
  description!: string | null;
  itemId!: string;
  quantityRequired!: number;
  notes!: string | null;
  schedAssetId!: string;
  schedStart!: Date;
  schedEnd!: Date;
  priority!: number;
  uomConversionId!: string | null;
  estimatedProdRate!: number;
  productionRateUom!: ProductionRateUom;
  batchSize!: number;

  constructor(data?: ICreateTaskRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.workOrderId =
        _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.nbr = _data["nbr"] !== undefined ? _data["nbr"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.schedAssetId =
        _data["schedAssetId"] !== undefined ? _data["schedAssetId"] : <any>null;
      this.schedStart = _data["schedStart"]
        ? new Date(_data["schedStart"].toString())
        : <any>null;
      this.schedEnd = _data["schedEnd"]
        ? new Date(_data["schedEnd"].toString())
        : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.uomConversionId =
        _data["uomConversionId"] !== undefined
          ? _data["uomConversionId"]
          : <any>null;
      this.estimatedProdRate =
        _data["estimatedProdRate"] !== undefined
          ? _data["estimatedProdRate"]
          : <any>null;
      this.productionRateUom =
        _data["productionRateUom"] !== undefined
          ? _data["productionRateUom"]
          : <any>null;
      this.batchSize =
        _data["batchSize"] !== undefined ? _data["batchSize"] : <any>null;
    }
  }

  static fromJS(data: any): CreateTaskRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateTaskRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["workOrderId"] =
      this.workOrderId !== undefined ? this.workOrderId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["nbr"] = this.nbr !== undefined ? this.nbr : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["schedAssetId"] =
      this.schedAssetId !== undefined ? this.schedAssetId : <any>null;
    data["schedStart"] = this.schedStart
      ? this.schedStart.toISOString()
      : <any>null;
    data["schedEnd"] = this.schedEnd ? this.schedEnd.toISOString() : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["uomConversionId"] =
      this.uomConversionId !== undefined ? this.uomConversionId : <any>null;
    data["estimatedProdRate"] =
      this.estimatedProdRate !== undefined ? this.estimatedProdRate : <any>null;
    data["productionRateUom"] =
      this.productionRateUom !== undefined ? this.productionRateUom : <any>null;
    data["batchSize"] =
      this.batchSize !== undefined ? this.batchSize : <any>null;
    return data;
  }
}

export interface ICreateTaskRequest {
  workOrderId: string;
  name: string | null;
  nbr: number;
  description: string | null;
  itemId: string;
  quantityRequired: number;
  notes: string | null;
  schedAssetId: string;
  schedStart: Date;
  schedEnd: Date;
  priority: number;
  uomConversionId: string | null;
  estimatedProdRate: number;
  productionRateUom: ProductionRateUom;
  batchSize: number;
}

export class CreateUomConvDto implements ICreateUomConvDto {
  uomConvIdFrom!: string;
  uomConvIdTo!: string | null;

  constructor(data?: ICreateUomConvDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uomConvIdFrom =
        _data["uomConvIdFrom"] !== undefined
          ? _data["uomConvIdFrom"]
          : <any>null;
      this.uomConvIdTo =
        _data["uomConvIdTo"] !== undefined ? _data["uomConvIdTo"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUomConvDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateUomConvDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uomConvIdFrom"] =
      this.uomConvIdFrom !== undefined ? this.uomConvIdFrom : <any>null;
    data["uomConvIdTo"] =
      this.uomConvIdTo !== undefined ? this.uomConvIdTo : <any>null;
    return data;
  }
}

export interface ICreateUomConvDto {
  uomConvIdFrom: string;
  uomConvIdTo: string | null;
}

export class CreateUomConvRequest implements ICreateUomConvRequest {
  fromUomId!: string;
  toUomId!: string;
  itemId!: string | null;
  factor!: number;
  offset!: number;
  generateReverseCalc!: boolean;

  constructor(data?: ICreateUomConvRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fromUomId =
        _data["fromUomId"] !== undefined ? _data["fromUomId"] : <any>null;
      this.toUomId =
        _data["toUomId"] !== undefined ? _data["toUomId"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.factor = _data["factor"] !== undefined ? _data["factor"] : <any>null;
      this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
      this.generateReverseCalc =
        _data["generateReverseCalc"] !== undefined
          ? _data["generateReverseCalc"]
          : <any>null;
    }
  }

  static fromJS(data: any): CreateUomConvRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateUomConvRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["fromUomId"] =
      this.fromUomId !== undefined ? this.fromUomId : <any>null;
    data["toUomId"] = this.toUomId !== undefined ? this.toUomId : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["factor"] = this.factor !== undefined ? this.factor : <any>null;
    data["offset"] = this.offset !== undefined ? this.offset : <any>null;
    data["generateReverseCalc"] =
      this.generateReverseCalc !== undefined
        ? this.generateReverseCalc
        : <any>null;
    return data;
  }
}

export interface ICreateUomConvRequest {
  fromUomId: string;
  toUomId: string;
  itemId: string | null;
  factor: number;
  offset: number;
  generateReverseCalc: boolean;
}

export class CreateUomDto implements ICreateUomDto {
  uomId!: string;

  constructor(data?: ICreateUomDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uomId = _data["uomId"] !== undefined ? _data["uomId"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUomDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateUomDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uomId"] = this.uomId !== undefined ? this.uomId : <any>null;
    return data;
  }
}

export interface ICreateUomDto {
  uomId: string;
}

export class CreateUomRequest implements ICreateUomRequest {
  name!: string | null;
  description!: string | null;
  abbreviation!: string | null;

  constructor(data?: ICreateUomRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.abbreviation =
        _data["abbreviation"] !== undefined ? _data["abbreviation"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUomRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateUomRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["abbreviation"] =
      this.abbreviation !== undefined ? this.abbreviation : <any>null;
    return data;
  }
}

export interface ICreateUomRequest {
  name: string | null;
  description: string | null;
  abbreviation: string | null;
}

export class CreateUtilCategoryDto implements ICreateUtilCategoryDto {
  id!: string;

  constructor(data?: ICreateUtilCategoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilCategoryDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilCategoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateUtilCategoryDto {
  id: string;
}

export class CreateUtilCategoryRequest implements ICreateUtilCategoryRequest {
  name!: string | null;
  description!: string | null;

  constructor(data?: ICreateUtilCategoryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilCategoryRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilCategoryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    return data;
  }
}

export interface ICreateUtilCategoryRequest {
  name: string | null;
  description: string | null;
}

export class CreateUtilRawDto implements ICreateUtilRawDto {
  id!: string;

  constructor(data?: ICreateUtilRawDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilRawDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilRawDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateUtilRawDto {
  id: string;
}

export class CreateUtilRawGroupDto implements ICreateUtilRawGroupDto {
  id!: string;

  constructor(data?: ICreateUtilRawGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilRawGroupDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilRawGroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateUtilRawGroupDto {
  id: string;
}

export class CreateUtilRawGroupRequest implements ICreateUtilRawGroupRequest {
  name!: string | null;
  description!: string | null;
  parentUtilRawGroupId!: string | null;
  priority!: number | null;

  constructor(data?: ICreateUtilRawGroupRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.parentUtilRawGroupId =
        _data["parentUtilRawGroupId"] !== undefined
          ? _data["parentUtilRawGroupId"]
          : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilRawGroupRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilRawGroupRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["parentUtilRawGroupId"] =
      this.parentUtilRawGroupId !== undefined
        ? this.parentUtilRawGroupId
        : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    return data;
  }
}

export interface ICreateUtilRawGroupRequest {
  name: string | null;
  description: string | null;
  parentUtilRawGroupId: string | null;
  priority: number | null;
}

export class CreateUtilRawRequest implements ICreateUtilRawRequest {
  utilRawGroupId!: string;
  utilStateId!: string;
  name!: string | null;
  description!: string | null;
  priority!: number | null;

  constructor(data?: ICreateUtilRawRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.utilRawGroupId =
        _data["utilRawGroupId"] !== undefined
          ? _data["utilRawGroupId"]
          : <any>null;
      this.utilStateId =
        _data["utilStateId"] !== undefined ? _data["utilStateId"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilRawRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilRawRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["utilRawGroupId"] =
      this.utilRawGroupId !== undefined ? this.utilRawGroupId : <any>null;
    data["utilStateId"] =
      this.utilStateId !== undefined ? this.utilStateId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    return data;
  }
}

export interface ICreateUtilRawRequest {
  utilRawGroupId: string;
  utilStateId: string;
  name: string | null;
  description: string | null;
  priority: number | null;
}

export class CreateUtilStateDto implements ICreateUtilStateDto {
  id!: string;

  constructor(data?: ICreateUtilStateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilStateDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilStateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateUtilStateDto {
  id: string;
}

export class CreateUtilStateGroupDto implements ICreateUtilStateGroupDto {
  id!: string;

  constructor(data?: ICreateUtilStateGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilStateGroupDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilStateGroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateUtilStateGroupDto {
  id: string;
}

export class CreateUtilStateGroupRequest
  implements ICreateUtilStateGroupRequest
{
  name!: string | null;
  description!: string | null;
  parentUtilStateGroupId!: string | null;

  constructor(data?: ICreateUtilStateGroupRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.parentUtilStateGroupId =
        _data["parentUtilStateGroupId"] !== undefined
          ? _data["parentUtilStateGroupId"]
          : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilStateGroupRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilStateGroupRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["parentUtilStateGroupId"] =
      this.parentUtilStateGroupId !== undefined
        ? this.parentUtilStateGroupId
        : <any>null;
    return data;
  }
}

export interface ICreateUtilStateGroupRequest {
  name: string | null;
  description: string | null;
  parentUtilStateGroupId: string | null;
}

export class CreateUtilStateRequest implements ICreateUtilStateRequest {
  utilStateGroupId!: string;
  name!: string | null;
  description!: string | null;
  oeeDefinition!: OeeDefinition;
  color!: string | null;

  constructor(data?: ICreateUtilStateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.utilStateGroupId =
        _data["utilStateGroupId"] !== undefined
          ? _data["utilStateGroupId"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.oeeDefinition =
        _data["oeeDefinition"] !== undefined
          ? _data["oeeDefinition"]
          : <any>null;
      this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
    }
  }

  static fromJS(data: any): CreateUtilStateRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateUtilStateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["utilStateGroupId"] =
      this.utilStateGroupId !== undefined ? this.utilStateGroupId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["oeeDefinition"] =
      this.oeeDefinition !== undefined ? this.oeeDefinition : <any>null;
    data["color"] = this.color !== undefined ? this.color : <any>null;
    return data;
  }
}

export interface ICreateUtilStateRequest {
  utilStateGroupId: string;
  name: string | null;
  description: string | null;
  oeeDefinition: OeeDefinition;
  color: string | null;
}

export class CreateWorkOrderDto implements ICreateWorkOrderDto {
  id!: string;

  constructor(data?: ICreateWorkOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): CreateWorkOrderDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateWorkOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface ICreateWorkOrderDto {
  id: string;
}

export class CreateWorkOrderRequest implements ICreateWorkOrderRequest {
  name!: string | null;
  description!: string | null;
  itemId!: string;
  quantityRequired!: number;
  notes!: string | null;
  dueDateTime!: Date;

  constructor(data?: ICreateWorkOrderRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.dueDateTime = _data["dueDateTime"]
        ? new Date(_data["dueDateTime"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): CreateWorkOrderRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateWorkOrderRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["dueDateTime"] = this.dueDateTime
      ? this.dueDateTime.toISOString()
      : <any>null;
    return data;
  }
}

export interface ICreateWorkOrderRequest {
  name: string | null;
  description: string | null;
  itemId: string;
  quantityRequired: number;
  notes: string | null;
  dueDateTime: Date;
}

export class DatabaseExceptionProblemDetails
  implements IDatabaseExceptionProblemDetails
{
  type!: string | null;
  title!: string | null;
  status!: number | null;
  detail!: string | null;
  instance!: string | null;

  constructor(data?: IDatabaseExceptionProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
      this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
      this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
      this.instance =
        _data["instance"] !== undefined ? _data["instance"] : <any>null;
    }
  }

  static fromJS(data: any): DatabaseExceptionProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new DatabaseExceptionProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["title"] = this.title !== undefined ? this.title : <any>null;
    data["status"] = this.status !== undefined ? this.status : <any>null;
    data["detail"] = this.detail !== undefined ? this.detail : <any>null;
    data["instance"] = this.instance !== undefined ? this.instance : <any>null;
    return data;
  }
}

export interface IDatabaseExceptionProblemDetails {
  type: string | null;
  title: string | null;
  status: number | null;
  detail: string | null;
  instance: string | null;
}

export class GetAllTaskExecsQueryDto implements IGetAllTaskExecsQueryDto {
  assetId!: string;
  assetName!: string | null;
  assetPosition!: number;
  currentTaskStartedAt!: Date | null;
  duration!: number | null;
  currentWorkOrderId!: string | null;
  currentWorkOrderName!: string | null;
  currentTaskId!: string | null;
  currentTaskName!: string | null;
  currentTaskItemName!: string | null;
  currentTaskQuantityRequired!: number | null;
  currentTaskQuantityProduced!: number | null;
  currentTaskQuantityRejected!: number | null;
  currentTaskLogId!: string | null;
  currentTaskStateId!: string | null;
  currentTaskStateName!: string | null;
  currentTaskStateColor!: string | null;
  currentGoodProductionLogId!: string | null;
  currentBadProductionLogId!: string | null;

  constructor(data?: IGetAllTaskExecsQueryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.assetPosition =
        _data["assetPosition"] !== undefined
          ? _data["assetPosition"]
          : <any>null;
      this.currentTaskStartedAt = _data["currentTaskStartedAt"]
        ? new Date(_data["currentTaskStartedAt"].toString())
        : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
      this.currentWorkOrderId =
        _data["currentWorkOrderId"] !== undefined
          ? _data["currentWorkOrderId"]
          : <any>null;
      this.currentWorkOrderName =
        _data["currentWorkOrderName"] !== undefined
          ? _data["currentWorkOrderName"]
          : <any>null;
      this.currentTaskId =
        _data["currentTaskId"] !== undefined
          ? _data["currentTaskId"]
          : <any>null;
      this.currentTaskName =
        _data["currentTaskName"] !== undefined
          ? _data["currentTaskName"]
          : <any>null;
      this.currentTaskItemName =
        _data["currentTaskItemName"] !== undefined
          ? _data["currentTaskItemName"]
          : <any>null;
      this.currentTaskQuantityRequired =
        _data["currentTaskQuantityRequired"] !== undefined
          ? _data["currentTaskQuantityRequired"]
          : <any>null;
      this.currentTaskQuantityProduced =
        _data["currentTaskQuantityProduced"] !== undefined
          ? _data["currentTaskQuantityProduced"]
          : <any>null;
      this.currentTaskQuantityRejected =
        _data["currentTaskQuantityRejected"] !== undefined
          ? _data["currentTaskQuantityRejected"]
          : <any>null;
      this.currentTaskLogId =
        _data["currentTaskLogId"] !== undefined
          ? _data["currentTaskLogId"]
          : <any>null;
      this.currentTaskStateId =
        _data["currentTaskStateId"] !== undefined
          ? _data["currentTaskStateId"]
          : <any>null;
      this.currentTaskStateName =
        _data["currentTaskStateName"] !== undefined
          ? _data["currentTaskStateName"]
          : <any>null;
      this.currentTaskStateColor =
        _data["currentTaskStateColor"] !== undefined
          ? _data["currentTaskStateColor"]
          : <any>null;
      this.currentGoodProductionLogId =
        _data["currentGoodProductionLogId"] !== undefined
          ? _data["currentGoodProductionLogId"]
          : <any>null;
      this.currentBadProductionLogId =
        _data["currentBadProductionLogId"] !== undefined
          ? _data["currentBadProductionLogId"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetAllTaskExecsQueryDto {
    data = typeof data === "object" ? data : {};
    let result = new GetAllTaskExecsQueryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["assetPosition"] =
      this.assetPosition !== undefined ? this.assetPosition : <any>null;
    data["currentTaskStartedAt"] = this.currentTaskStartedAt
      ? this.currentTaskStartedAt.toISOString()
      : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    data["currentWorkOrderId"] =
      this.currentWorkOrderId !== undefined
        ? this.currentWorkOrderId
        : <any>null;
    data["currentWorkOrderName"] =
      this.currentWorkOrderName !== undefined
        ? this.currentWorkOrderName
        : <any>null;
    data["currentTaskId"] =
      this.currentTaskId !== undefined ? this.currentTaskId : <any>null;
    data["currentTaskName"] =
      this.currentTaskName !== undefined ? this.currentTaskName : <any>null;
    data["currentTaskItemName"] =
      this.currentTaskItemName !== undefined
        ? this.currentTaskItemName
        : <any>null;
    data["currentTaskQuantityRequired"] =
      this.currentTaskQuantityRequired !== undefined
        ? this.currentTaskQuantityRequired
        : <any>null;
    data["currentTaskQuantityProduced"] =
      this.currentTaskQuantityProduced !== undefined
        ? this.currentTaskQuantityProduced
        : <any>null;
    data["currentTaskQuantityRejected"] =
      this.currentTaskQuantityRejected !== undefined
        ? this.currentTaskQuantityRejected
        : <any>null;
    data["currentTaskLogId"] =
      this.currentTaskLogId !== undefined ? this.currentTaskLogId : <any>null;
    data["currentTaskStateId"] =
      this.currentTaskStateId !== undefined
        ? this.currentTaskStateId
        : <any>null;
    data["currentTaskStateName"] =
      this.currentTaskStateName !== undefined
        ? this.currentTaskStateName
        : <any>null;
    data["currentTaskStateColor"] =
      this.currentTaskStateColor !== undefined
        ? this.currentTaskStateColor
        : <any>null;
    data["currentGoodProductionLogId"] =
      this.currentGoodProductionLogId !== undefined
        ? this.currentGoodProductionLogId
        : <any>null;
    data["currentBadProductionLogId"] =
      this.currentBadProductionLogId !== undefined
        ? this.currentBadProductionLogId
        : <any>null;
    return data;
  }
}

export interface IGetAllTaskExecsQueryDto {
  assetId: string;
  assetName: string | null;
  assetPosition: number;
  currentTaskStartedAt: Date | null;
  duration: number | null;
  currentWorkOrderId: string | null;
  currentWorkOrderName: string | null;
  currentTaskId: string | null;
  currentTaskName: string | null;
  currentTaskItemName: string | null;
  currentTaskQuantityRequired: number | null;
  currentTaskQuantityProduced: number | null;
  currentTaskQuantityRejected: number | null;
  currentTaskLogId: string | null;
  currentTaskStateId: string | null;
  currentTaskStateName: string | null;
  currentTaskStateColor: string | null;
  currentGoodProductionLogId: string | null;
  currentBadProductionLogId: string | null;
}

export class GetAllUtilExecsQueryDto implements IGetAllUtilExecsQueryDto {
  assetId!: string;
  assetName!: string | null;
  currentUtilRawStartedAt!: Date | null;
  duration!: number | null;
  utilRawId!: string | null;
  utilRawName!: string | null;
  utilStateId!: string | null;
  utilStateName!: string | null;
  utilStateColor!: string | null;
  comment!: string | null;
  createdByUserId!: string | null;
  createdByUserFullName!: string | null;
  createdByUserName!: string | null;
  logId!: string | null;

  constructor(data?: IGetAllUtilExecsQueryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.currentUtilRawStartedAt = _data["currentUtilRawStartedAt"]
        ? new Date(_data["currentUtilRawStartedAt"].toString())
        : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
      this.utilRawId =
        _data["utilRawId"] !== undefined ? _data["utilRawId"] : <any>null;
      this.utilRawName =
        _data["utilRawName"] !== undefined ? _data["utilRawName"] : <any>null;
      this.utilStateId =
        _data["utilStateId"] !== undefined ? _data["utilStateId"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.utilStateColor =
        _data["utilStateColor"] !== undefined
          ? _data["utilStateColor"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.createdByUserId =
        _data["createdByUserId"] !== undefined
          ? _data["createdByUserId"]
          : <any>null;
      this.createdByUserFullName =
        _data["createdByUserFullName"] !== undefined
          ? _data["createdByUserFullName"]
          : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
    }
  }

  static fromJS(data: any): GetAllUtilExecsQueryDto {
    data = typeof data === "object" ? data : {};
    let result = new GetAllUtilExecsQueryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["currentUtilRawStartedAt"] = this.currentUtilRawStartedAt
      ? this.currentUtilRawStartedAt.toISOString()
      : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    data["utilRawId"] =
      this.utilRawId !== undefined ? this.utilRawId : <any>null;
    data["utilRawName"] =
      this.utilRawName !== undefined ? this.utilRawName : <any>null;
    data["utilStateId"] =
      this.utilStateId !== undefined ? this.utilStateId : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["utilStateColor"] =
      this.utilStateColor !== undefined ? this.utilStateColor : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["createdByUserId"] =
      this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
    data["createdByUserFullName"] =
      this.createdByUserFullName !== undefined
        ? this.createdByUserFullName
        : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    return data;
  }
}

export interface IGetAllUtilExecsQueryDto {
  assetId: string;
  assetName: string | null;
  currentUtilRawStartedAt: Date | null;
  duration: number | null;
  utilRawId: string | null;
  utilRawName: string | null;
  utilStateId: string | null;
  utilStateName: string | null;
  utilStateColor: string | null;
  comment: string | null;
  createdByUserId: string | null;
  createdByUserFullName: string | null;
  createdByUserName: string | null;
  logId: string | null;
}

export class GetAssetIntervalAvailabilityByAssetIdsDto
  implements IGetAssetIntervalAvailabilityByAssetIdsDto
{
  assetId!: string;
  intervalStart!: Date;
  intervalEnd!: Date;
  runtime!: number;
  downtime!: number;
  neither!: number;
  availability!: number | null;
  targetAvailability!: number;

  constructor(data?: IGetAssetIntervalAvailabilityByAssetIdsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.intervalStart = _data["intervalStart"]
        ? new Date(_data["intervalStart"].toString())
        : <any>null;
      this.intervalEnd = _data["intervalEnd"]
        ? new Date(_data["intervalEnd"].toString())
        : <any>null;
      this.runtime =
        _data["runtime"] !== undefined ? _data["runtime"] : <any>null;
      this.downtime =
        _data["downtime"] !== undefined ? _data["downtime"] : <any>null;
      this.neither =
        _data["neither"] !== undefined ? _data["neither"] : <any>null;
      this.availability =
        _data["availability"] !== undefined ? _data["availability"] : <any>null;
      this.targetAvailability =
        _data["targetAvailability"] !== undefined
          ? _data["targetAvailability"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetAssetIntervalAvailabilityByAssetIdsDto {
    data = typeof data === "object" ? data : {};
    let result = new GetAssetIntervalAvailabilityByAssetIdsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["intervalStart"] = this.intervalStart
      ? this.intervalStart.toISOString()
      : <any>null;
    data["intervalEnd"] = this.intervalEnd
      ? this.intervalEnd.toISOString()
      : <any>null;
    data["runtime"] = this.runtime !== undefined ? this.runtime : <any>null;
    data["downtime"] = this.downtime !== undefined ? this.downtime : <any>null;
    data["neither"] = this.neither !== undefined ? this.neither : <any>null;
    data["availability"] =
      this.availability !== undefined ? this.availability : <any>null;
    data["targetAvailability"] =
      this.targetAvailability !== undefined
        ? this.targetAvailability
        : <any>null;
    return data;
  }
}

export interface IGetAssetIntervalAvailabilityByAssetIdsDto {
  assetId: string;
  intervalStart: Date;
  intervalEnd: Date;
  runtime: number;
  downtime: number;
  neither: number;
  availability: number | null;
  targetAvailability: number;
}

export class GetAssetIntervalAvailabilityByAssetIdsRequest
  implements IGetAssetIntervalAvailabilityByAssetIdsRequest
{
  assetIds!: string[] | null;
  startDate!: Date | null;
  endDate!: Date | null;

  constructor(data?: IGetAssetIntervalAvailabilityByAssetIdsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["assetIds"])) {
        this.assetIds = [] as any;
        for (let item of _data["assetIds"]) this.assetIds!.push(item);
      } else {
        this.assetIds = <any>null;
      }
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : <any>null;
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): GetAssetIntervalAvailabilityByAssetIdsRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetAssetIntervalAvailabilityByAssetIdsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.assetIds)) {
      data["assetIds"] = [];
      for (let item of this.assetIds) data["assetIds"].push(item);
    }
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : <any>null;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
    return data;
  }
}

export interface IGetAssetIntervalAvailabilityByAssetIdsRequest {
  assetIds: string[] | null;
  startDate: Date | null;
  endDate: Date | null;
}

export class GetAssetIntervalPerformanceByAssetIdsDto
  implements IGetAssetIntervalPerformanceByAssetIdsDto
{
  assetId!: string;
  intervalStart!: Date;
  intervalEnd!: Date;
  performance!: number | null;
  targetPerformance!: number;

  constructor(data?: IGetAssetIntervalPerformanceByAssetIdsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.intervalStart = _data["intervalStart"]
        ? new Date(_data["intervalStart"].toString())
        : <any>null;
      this.intervalEnd = _data["intervalEnd"]
        ? new Date(_data["intervalEnd"].toString())
        : <any>null;
      this.performance =
        _data["performance"] !== undefined ? _data["performance"] : <any>null;
      this.targetPerformance =
        _data["targetPerformance"] !== undefined
          ? _data["targetPerformance"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetAssetIntervalPerformanceByAssetIdsDto {
    data = typeof data === "object" ? data : {};
    let result = new GetAssetIntervalPerformanceByAssetIdsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["intervalStart"] = this.intervalStart
      ? this.intervalStart.toISOString()
      : <any>null;
    data["intervalEnd"] = this.intervalEnd
      ? this.intervalEnd.toISOString()
      : <any>null;
    data["performance"] =
      this.performance !== undefined ? this.performance : <any>null;
    data["targetPerformance"] =
      this.targetPerformance !== undefined ? this.targetPerformance : <any>null;
    return data;
  }
}

export interface IGetAssetIntervalPerformanceByAssetIdsDto {
  assetId: string;
  intervalStart: Date;
  intervalEnd: Date;
  performance: number | null;
  targetPerformance: number;
}

export class GetAssetIntervalPerformanceByAssetIdsRequest
  implements IGetAssetIntervalPerformanceByAssetIdsRequest
{
  assetIds!: string[] | null;
  startDate!: Date | null;
  endDate!: Date | null;

  constructor(data?: IGetAssetIntervalPerformanceByAssetIdsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["assetIds"])) {
        this.assetIds = [] as any;
        for (let item of _data["assetIds"]) this.assetIds!.push(item);
      } else {
        this.assetIds = <any>null;
      }
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : <any>null;
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): GetAssetIntervalPerformanceByAssetIdsRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetAssetIntervalPerformanceByAssetIdsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.assetIds)) {
      data["assetIds"] = [];
      for (let item of this.assetIds) data["assetIds"].push(item);
    }
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : <any>null;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
    return data;
  }
}

export interface IGetAssetIntervalPerformanceByAssetIdsRequest {
  assetIds: string[] | null;
  startDate: Date | null;
  endDate: Date | null;
}

export class GetAssetIntervalQualityByAssetIdsDto
  implements IGetAssetIntervalQualityByAssetIdsDto
{
  assetId!: string;
  intervalStart!: Date;
  intervalEnd!: Date;
  quantityGood!: number;
  quantityBad!: number;
  quality!: number | null;
  targetQuality!: number;

  constructor(data?: IGetAssetIntervalQualityByAssetIdsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.intervalStart = _data["intervalStart"]
        ? new Date(_data["intervalStart"].toString())
        : <any>null;
      this.intervalEnd = _data["intervalEnd"]
        ? new Date(_data["intervalEnd"].toString())
        : <any>null;
      this.quantityGood =
        _data["quantityGood"] !== undefined ? _data["quantityGood"] : <any>null;
      this.quantityBad =
        _data["quantityBad"] !== undefined ? _data["quantityBad"] : <any>null;
      this.quality =
        _data["quality"] !== undefined ? _data["quality"] : <any>null;
      this.targetQuality =
        _data["targetQuality"] !== undefined
          ? _data["targetQuality"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetAssetIntervalQualityByAssetIdsDto {
    data = typeof data === "object" ? data : {};
    let result = new GetAssetIntervalQualityByAssetIdsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["intervalStart"] = this.intervalStart
      ? this.intervalStart.toISOString()
      : <any>null;
    data["intervalEnd"] = this.intervalEnd
      ? this.intervalEnd.toISOString()
      : <any>null;
    data["quantityGood"] =
      this.quantityGood !== undefined ? this.quantityGood : <any>null;
    data["quantityBad"] =
      this.quantityBad !== undefined ? this.quantityBad : <any>null;
    data["quality"] = this.quality !== undefined ? this.quality : <any>null;
    data["targetQuality"] =
      this.targetQuality !== undefined ? this.targetQuality : <any>null;
    return data;
  }
}

export interface IGetAssetIntervalQualityByAssetIdsDto {
  assetId: string;
  intervalStart: Date;
  intervalEnd: Date;
  quantityGood: number;
  quantityBad: number;
  quality: number | null;
  targetQuality: number;
}

export class GetAssetIntervalQualityByAssetIdsRequest
  implements IGetAssetIntervalQualityByAssetIdsRequest
{
  assetIds!: string[] | null;
  startDate!: Date | null;
  endDate!: Date | null;

  constructor(data?: IGetAssetIntervalQualityByAssetIdsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["assetIds"])) {
        this.assetIds = [] as any;
        for (let item of _data["assetIds"]) this.assetIds!.push(item);
      } else {
        this.assetIds = <any>null;
      }
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : <any>null;
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): GetAssetIntervalQualityByAssetIdsRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetAssetIntervalQualityByAssetIdsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.assetIds)) {
      data["assetIds"] = [];
      for (let item of this.assetIds) data["assetIds"].push(item);
    }
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : <any>null;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
    return data;
  }
}

export interface IGetAssetIntervalQualityByAssetIdsRequest {
  assetIds: string[] | null;
  startDate: Date | null;
  endDate: Date | null;
}

export class GetAvailabilityByAssetIdDto
  implements IGetAvailabilityByAssetIdDto
{
  runtime!: number;
  downtime!: number;
  neither!: number;
  availability!: number | null;
  targetAvailability!: number;

  constructor(data?: IGetAvailabilityByAssetIdDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.runtime =
        _data["runtime"] !== undefined ? _data["runtime"] : <any>null;
      this.downtime =
        _data["downtime"] !== undefined ? _data["downtime"] : <any>null;
      this.neither =
        _data["neither"] !== undefined ? _data["neither"] : <any>null;
      this.availability =
        _data["availability"] !== undefined ? _data["availability"] : <any>null;
      this.targetAvailability =
        _data["targetAvailability"] !== undefined
          ? _data["targetAvailability"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetAvailabilityByAssetIdDto {
    data = typeof data === "object" ? data : {};
    let result = new GetAvailabilityByAssetIdDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["runtime"] = this.runtime !== undefined ? this.runtime : <any>null;
    data["downtime"] = this.downtime !== undefined ? this.downtime : <any>null;
    data["neither"] = this.neither !== undefined ? this.neither : <any>null;
    data["availability"] =
      this.availability !== undefined ? this.availability : <any>null;
    data["targetAvailability"] =
      this.targetAvailability !== undefined
        ? this.targetAvailability
        : <any>null;
    return data;
  }
}

export interface IGetAvailabilityByAssetIdDto {
  runtime: number;
  downtime: number;
  neither: number;
  availability: number | null;
  targetAvailability: number;
}

export enum GetAvailableUtilRawsActionType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export class GetNestedAssetsQueryDto implements IGetNestedAssetsQueryDto {
  id!: string;
  parentAssetId!: string | null;
  name!: string | null;
  description!: string | null;
  path!: string | null;
  sourceStack!: string[] | null;
  childrenAssets!: GetNestedAssetsQueryDto[] | null;
  isActive!: boolean;

  constructor(data?: IGetNestedAssetsQueryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.parentAssetId =
        _data["parentAssetId"] !== undefined
          ? _data["parentAssetId"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
      if (Array.isArray(_data["sourceStack"])) {
        this.sourceStack = [] as any;
        for (let item of _data["sourceStack"]) this.sourceStack!.push(item);
      } else {
        this.sourceStack = <any>null;
      }
      if (Array.isArray(_data["childrenAssets"])) {
        this.childrenAssets = [] as any;
        for (let item of _data["childrenAssets"])
          this.childrenAssets!.push(GetNestedAssetsQueryDto.fromJS(item));
      } else {
        this.childrenAssets = <any>null;
      }
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): GetNestedAssetsQueryDto {
    data = typeof data === "object" ? data : {};
    let result = new GetNestedAssetsQueryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["parentAssetId"] =
      this.parentAssetId !== undefined ? this.parentAssetId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["path"] = this.path !== undefined ? this.path : <any>null;
    if (Array.isArray(this.sourceStack)) {
      data["sourceStack"] = [];
      for (let item of this.sourceStack) data["sourceStack"].push(item);
    }
    if (Array.isArray(this.childrenAssets)) {
      data["childrenAssets"] = [];
      for (let item of this.childrenAssets)
        data["childrenAssets"].push(item.toJSON());
    }
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface IGetNestedAssetsQueryDto {
  id: string;
  parentAssetId: string | null;
  name: string | null;
  description: string | null;
  path: string | null;
  sourceStack: string[] | null;
  childrenAssets: GetNestedAssetsQueryDto[] | null;
  isActive: boolean;
}

export class GetNestedAvailableUtilRawsQueryGroupDto
  implements IGetNestedAvailableUtilRawsQueryGroupDto
{
  id!: string;
  parentUtilRawGroupId!: string | null;
  name!: string | null;
  description!: string | null;
  priority!: number | null;
  childrenGroups!: GetNestedAvailableUtilRawsQueryGroupDto[] | null;
  utilRaws!: GetNestedAvailableUtilRawsQueryUtilDto[] | null;

  constructor(data?: IGetNestedAvailableUtilRawsQueryGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.parentUtilRawGroupId =
        _data["parentUtilRawGroupId"] !== undefined
          ? _data["parentUtilRawGroupId"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      if (Array.isArray(_data["childrenGroups"])) {
        this.childrenGroups = [] as any;
        for (let item of _data["childrenGroups"])
          this.childrenGroups!.push(
            GetNestedAvailableUtilRawsQueryGroupDto.fromJS(item)
          );
      } else {
        this.childrenGroups = <any>null;
      }
      if (Array.isArray(_data["utilRaws"])) {
        this.utilRaws = [] as any;
        for (let item of _data["utilRaws"])
          this.utilRaws!.push(
            GetNestedAvailableUtilRawsQueryUtilDto.fromJS(item)
          );
      } else {
        this.utilRaws = <any>null;
      }
    }
  }

  static fromJS(data: any): GetNestedAvailableUtilRawsQueryGroupDto {
    data = typeof data === "object" ? data : {};
    let result = new GetNestedAvailableUtilRawsQueryGroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["parentUtilRawGroupId"] =
      this.parentUtilRawGroupId !== undefined
        ? this.parentUtilRawGroupId
        : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    if (Array.isArray(this.childrenGroups)) {
      data["childrenGroups"] = [];
      for (let item of this.childrenGroups)
        data["childrenGroups"].push(item.toJSON());
    }
    if (Array.isArray(this.utilRaws)) {
      data["utilRaws"] = [];
      for (let item of this.utilRaws) data["utilRaws"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetNestedAvailableUtilRawsQueryGroupDto {
  id: string;
  parentUtilRawGroupId: string | null;
  name: string | null;
  description: string | null;
  priority: number | null;
  childrenGroups: GetNestedAvailableUtilRawsQueryGroupDto[] | null;
  utilRaws: GetNestedAvailableUtilRawsQueryUtilDto[] | null;
}

export class GetNestedAvailableUtilRawsQueryUtilDto
  implements IGetNestedAvailableUtilRawsQueryUtilDto
{
  id!: string;
  utilRawGroupId!: string;
  name!: string | null;
  description!: string | null;
  oeeDefinition!: OeeDefinition;
  priority!: number | null;
  utilStateId!: string;
  utilStateName!: string | null;
  utilStateColor!: string | null;
  sourceGroupStack!: string[] | null;

  constructor(data?: IGetNestedAvailableUtilRawsQueryUtilDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.utilRawGroupId =
        _data["utilRawGroupId"] !== undefined
          ? _data["utilRawGroupId"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.oeeDefinition =
        _data["oeeDefinition"] !== undefined
          ? _data["oeeDefinition"]
          : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.utilStateId =
        _data["utilStateId"] !== undefined ? _data["utilStateId"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.utilStateColor =
        _data["utilStateColor"] !== undefined
          ? _data["utilStateColor"]
          : <any>null;
      if (Array.isArray(_data["sourceGroupStack"])) {
        this.sourceGroupStack = [] as any;
        for (let item of _data["sourceGroupStack"])
          this.sourceGroupStack!.push(item);
      } else {
        this.sourceGroupStack = <any>null;
      }
    }
  }

  static fromJS(data: any): GetNestedAvailableUtilRawsQueryUtilDto {
    data = typeof data === "object" ? data : {};
    let result = new GetNestedAvailableUtilRawsQueryUtilDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["utilRawGroupId"] =
      this.utilRawGroupId !== undefined ? this.utilRawGroupId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["oeeDefinition"] =
      this.oeeDefinition !== undefined ? this.oeeDefinition : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["utilStateId"] =
      this.utilStateId !== undefined ? this.utilStateId : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["utilStateColor"] =
      this.utilStateColor !== undefined ? this.utilStateColor : <any>null;
    if (Array.isArray(this.sourceGroupStack)) {
      data["sourceGroupStack"] = [];
      for (let item of this.sourceGroupStack)
        data["sourceGroupStack"].push(item);
    }
    return data;
  }
}

export interface IGetNestedAvailableUtilRawsQueryUtilDto {
  id: string;
  utilRawGroupId: string;
  name: string | null;
  description: string | null;
  oeeDefinition: OeeDefinition;
  priority: number | null;
  utilStateId: string;
  utilStateName: string | null;
  utilStateColor: string | null;
  sourceGroupStack: string[] | null;
}

export class GetNestedProductionLogHistoryByLogIdDto
  implements IGetNestedProductionLogHistoryByLogIdDto
{
  logId!: string;
  sourceLogId!: string | null;
  workOrderName!: string | null;
  taskId!: string;
  taskName!: string | null;
  assetId!: string;
  assetName!: string | null;
  productionReasonId!: string;
  productionReasonName!: string | null;
  quantityProduced!: number;
  startedAt!: Date;
  finishedAt!: Date | null;
  comment!: string | null;
  itemName!: string | null;
  uomName!: string | null;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;
  createdAt!: Date;
  childrenProductionEvents!: GetNestedProductionLogHistoryByLogIdDto[] | null;

  constructor(data?: IGetNestedProductionLogHistoryByLogIdDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.sourceLogId =
        _data["sourceLogId"] !== undefined ? _data["sourceLogId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
      this.taskName =
        _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.productionReasonId =
        _data["productionReasonId"] !== undefined
          ? _data["productionReasonId"]
          : <any>null;
      this.productionReasonName =
        _data["productionReasonName"] !== undefined
          ? _data["productionReasonName"]
          : <any>null;
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      if (Array.isArray(_data["childrenProductionEvents"])) {
        this.childrenProductionEvents = [] as any;
        for (let item of _data["childrenProductionEvents"])
          this.childrenProductionEvents!.push(
            GetNestedProductionLogHistoryByLogIdDto.fromJS(item)
          );
      } else {
        this.childrenProductionEvents = <any>null;
      }
    }
  }

  static fromJS(data: any): GetNestedProductionLogHistoryByLogIdDto {
    data = typeof data === "object" ? data : {};
    let result = new GetNestedProductionLogHistoryByLogIdDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["sourceLogId"] =
      this.sourceLogId !== undefined ? this.sourceLogId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["productionReasonId"] =
      this.productionReasonId !== undefined
        ? this.productionReasonId
        : <any>null;
    data["productionReasonName"] =
      this.productionReasonName !== undefined
        ? this.productionReasonName
        : <any>null;
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    if (Array.isArray(this.childrenProductionEvents)) {
      data["childrenProductionEvents"] = [];
      for (let item of this.childrenProductionEvents)
        data["childrenProductionEvents"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetNestedProductionLogHistoryByLogIdDto {
  logId: string;
  sourceLogId: string | null;
  workOrderName: string | null;
  taskId: string;
  taskName: string | null;
  assetId: string;
  assetName: string | null;
  productionReasonId: string;
  productionReasonName: string | null;
  quantityProduced: number;
  startedAt: Date;
  finishedAt: Date | null;
  comment: string | null;
  itemName: string | null;
  uomName: string | null;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
  createdAt: Date;
  childrenProductionEvents: GetNestedProductionLogHistoryByLogIdDto[] | null;
}

export class GetNestedUtilLogsByLogIdDto
  implements IGetNestedUtilLogsByLogIdDto
{
  logId!: string;
  sourceLogId!: string | null;
  assetName!: string | null;
  startedAt!: Date;
  finishedAt!: Date | null;
  duration!: number;
  utilRawName!: string | null;
  utilStateName!: string | null;
  utilStateColor!: string | null;
  comment!: string | null;
  createdById!: string | null;
  createdByFullName!: string | null;
  createdByUserName!: string | null;
  createdAt!: Date;
  childrenUtilEvents!: GetNestedUtilLogsByLogIdDto[] | null;

  constructor(data?: IGetNestedUtilLogsByLogIdDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.sourceLogId =
        _data["sourceLogId"] !== undefined ? _data["sourceLogId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
      this.utilRawName =
        _data["utilRawName"] !== undefined ? _data["utilRawName"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.utilStateColor =
        _data["utilStateColor"] !== undefined
          ? _data["utilStateColor"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      if (Array.isArray(_data["childrenUtilEvents"])) {
        this.childrenUtilEvents = [] as any;
        for (let item of _data["childrenUtilEvents"])
          this.childrenUtilEvents!.push(
            GetNestedUtilLogsByLogIdDto.fromJS(item)
          );
      } else {
        this.childrenUtilEvents = <any>null;
      }
    }
  }

  static fromJS(data: any): GetNestedUtilLogsByLogIdDto {
    data = typeof data === "object" ? data : {};
    let result = new GetNestedUtilLogsByLogIdDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["sourceLogId"] =
      this.sourceLogId !== undefined ? this.sourceLogId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    data["utilRawName"] =
      this.utilRawName !== undefined ? this.utilRawName : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["utilStateColor"] =
      this.utilStateColor !== undefined ? this.utilStateColor : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    if (Array.isArray(this.childrenUtilEvents)) {
      data["childrenUtilEvents"] = [];
      for (let item of this.childrenUtilEvents)
        data["childrenUtilEvents"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetNestedUtilLogsByLogIdDto {
  logId: string;
  sourceLogId: string | null;
  assetName: string | null;
  startedAt: Date;
  finishedAt: Date | null;
  duration: number;
  utilRawName: string | null;
  utilStateName: string | null;
  utilStateColor: string | null;
  comment: string | null;
  createdById: string | null;
  createdByFullName: string | null;
  createdByUserName: string | null;
  createdAt: Date;
  childrenUtilEvents: GetNestedUtilLogsByLogIdDto[] | null;
}

export class GetNestedUtilRawsQueryGroupDto
  implements IGetNestedUtilRawsQueryGroupDto
{
  id!: string;
  parentUtilRawGroupId!: string | null;
  name!: string | null;
  description!: string | null;
  priority!: number | null;
  childrenGroups!: GetNestedUtilRawsQueryGroupDto[] | null;
  utilRaws!: GetNestedUtilRawsQueryUtilDto[] | null;

  constructor(data?: IGetNestedUtilRawsQueryGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.parentUtilRawGroupId =
        _data["parentUtilRawGroupId"] !== undefined
          ? _data["parentUtilRawGroupId"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      if (Array.isArray(_data["childrenGroups"])) {
        this.childrenGroups = [] as any;
        for (let item of _data["childrenGroups"])
          this.childrenGroups!.push(
            GetNestedUtilRawsQueryGroupDto.fromJS(item)
          );
      } else {
        this.childrenGroups = <any>null;
      }
      if (Array.isArray(_data["utilRaws"])) {
        this.utilRaws = [] as any;
        for (let item of _data["utilRaws"])
          this.utilRaws!.push(GetNestedUtilRawsQueryUtilDto.fromJS(item));
      } else {
        this.utilRaws = <any>null;
      }
    }
  }

  static fromJS(data: any): GetNestedUtilRawsQueryGroupDto {
    data = typeof data === "object" ? data : {};
    let result = new GetNestedUtilRawsQueryGroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["parentUtilRawGroupId"] =
      this.parentUtilRawGroupId !== undefined
        ? this.parentUtilRawGroupId
        : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    if (Array.isArray(this.childrenGroups)) {
      data["childrenGroups"] = [];
      for (let item of this.childrenGroups)
        data["childrenGroups"].push(item.toJSON());
    }
    if (Array.isArray(this.utilRaws)) {
      data["utilRaws"] = [];
      for (let item of this.utilRaws) data["utilRaws"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetNestedUtilRawsQueryGroupDto {
  id: string;
  parentUtilRawGroupId: string | null;
  name: string | null;
  description: string | null;
  priority: number | null;
  childrenGroups: GetNestedUtilRawsQueryGroupDto[] | null;
  utilRaws: GetNestedUtilRawsQueryUtilDto[] | null;
}

export class GetNestedUtilRawsQueryUtilDto
  implements IGetNestedUtilRawsQueryUtilDto
{
  id!: string;
  utilRawGroupId!: string;
  name!: string | null;
  description!: string | null;
  oeeDefinition!: OeeDefinition;
  priority!: number | null;
  utilStateId!: string;
  utilStateName!: string | null;

  constructor(data?: IGetNestedUtilRawsQueryUtilDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.utilRawGroupId =
        _data["utilRawGroupId"] !== undefined
          ? _data["utilRawGroupId"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.oeeDefinition =
        _data["oeeDefinition"] !== undefined
          ? _data["oeeDefinition"]
          : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.utilStateId =
        _data["utilStateId"] !== undefined ? _data["utilStateId"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetNestedUtilRawsQueryUtilDto {
    data = typeof data === "object" ? data : {};
    let result = new GetNestedUtilRawsQueryUtilDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["utilRawGroupId"] =
      this.utilRawGroupId !== undefined ? this.utilRawGroupId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["oeeDefinition"] =
      this.oeeDefinition !== undefined ? this.oeeDefinition : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["utilStateId"] =
      this.utilStateId !== undefined ? this.utilStateId : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    return data;
  }
}

export interface IGetNestedUtilRawsQueryUtilDto {
  id: string;
  utilRawGroupId: string;
  name: string | null;
  description: string | null;
  oeeDefinition: OeeDefinition;
  priority: number | null;
  utilStateId: string;
  utilStateName: string | null;
}

export class GetNotSlicedUtilLogsOnMissedIntervalsDto
  implements IGetNotSlicedUtilLogsOnMissedIntervalsDto
{
  durationInMinutes!: number;
  slicesToAdd!: number;
  minSliceAt!: Date;
  maxSliceAt!: Date;
  logId!: string;
  logSliceId!: string;
  assetId!: string;
  startedAt!: Date;
  finishedAt!: Date | null;

  constructor(data?: IGetNotSlicedUtilLogsOnMissedIntervalsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.durationInMinutes =
        _data["durationInMinutes"] !== undefined
          ? _data["durationInMinutes"]
          : <any>null;
      this.slicesToAdd =
        _data["slicesToAdd"] !== undefined ? _data["slicesToAdd"] : <any>null;
      this.minSliceAt = _data["minSliceAt"]
        ? new Date(_data["minSliceAt"].toString())
        : <any>null;
      this.maxSliceAt = _data["maxSliceAt"]
        ? new Date(_data["maxSliceAt"].toString())
        : <any>null;
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.logSliceId =
        _data["logSliceId"] !== undefined ? _data["logSliceId"] : <any>null;
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): GetNotSlicedUtilLogsOnMissedIntervalsDto {
    data = typeof data === "object" ? data : {};
    let result = new GetNotSlicedUtilLogsOnMissedIntervalsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["durationInMinutes"] =
      this.durationInMinutes !== undefined ? this.durationInMinutes : <any>null;
    data["slicesToAdd"] =
      this.slicesToAdd !== undefined ? this.slicesToAdd : <any>null;
    data["minSliceAt"] = this.minSliceAt
      ? this.minSliceAt.toISOString()
      : <any>null;
    data["maxSliceAt"] = this.maxSliceAt
      ? this.maxSliceAt.toISOString()
      : <any>null;
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["logSliceId"] =
      this.logSliceId !== undefined ? this.logSliceId : <any>null;
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    return data;
  }
}

export interface IGetNotSlicedUtilLogsOnMissedIntervalsDto {
  durationInMinutes: number;
  slicesToAdd: number;
  minSliceAt: Date;
  maxSliceAt: Date;
  logId: string;
  logSliceId: string;
  assetId: string;
  startedAt: Date;
  finishedAt: Date | null;
}

export class GetPerformanceByAssetIdDto implements IGetPerformanceByAssetIdDto {
  performance!: number | null;
  targetPerformance!: number;

  constructor(data?: IGetPerformanceByAssetIdDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.performance =
        _data["performance"] !== undefined ? _data["performance"] : <any>null;
      this.targetPerformance =
        _data["targetPerformance"] !== undefined
          ? _data["targetPerformance"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetPerformanceByAssetIdDto {
    data = typeof data === "object" ? data : {};
    let result = new GetPerformanceByAssetIdDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["performance"] =
      this.performance !== undefined ? this.performance : <any>null;
    data["targetPerformance"] =
      this.targetPerformance !== undefined ? this.targetPerformance : <any>null;
    return data;
  }
}

export interface IGetPerformanceByAssetIdDto {
  performance: number | null;
  targetPerformance: number;
}

export class GetPlainProductionLogHistoryByLogIdDto
  implements IGetPlainProductionLogHistoryByLogIdDto
{
  logId!: string;
  sourceLogId!: string | null;
  workOrderName!: string | null;
  taskId!: string;
  taskName!: string | null;
  assetId!: string;
  assetName!: string | null;
  productionReasonId!: string;
  productionReasonName!: string | null;
  quantityProduced!: number;
  startedAt!: Date;
  finishedAt!: Date | null;
  comment!: string | null;
  itemName!: string | null;
  uomName!: string | null;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;
  createdAt!: Date;

  constructor(data?: IGetPlainProductionLogHistoryByLogIdDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.sourceLogId =
        _data["sourceLogId"] !== undefined ? _data["sourceLogId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
      this.taskName =
        _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.productionReasonId =
        _data["productionReasonId"] !== undefined
          ? _data["productionReasonId"]
          : <any>null;
      this.productionReasonName =
        _data["productionReasonName"] !== undefined
          ? _data["productionReasonName"]
          : <any>null;
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): GetPlainProductionLogHistoryByLogIdDto {
    data = typeof data === "object" ? data : {};
    let result = new GetPlainProductionLogHistoryByLogIdDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["sourceLogId"] =
      this.sourceLogId !== undefined ? this.sourceLogId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["productionReasonId"] =
      this.productionReasonId !== undefined
        ? this.productionReasonId
        : <any>null;
    data["productionReasonName"] =
      this.productionReasonName !== undefined
        ? this.productionReasonName
        : <any>null;
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    return data;
  }
}

export interface IGetPlainProductionLogHistoryByLogIdDto {
  logId: string;
  sourceLogId: string | null;
  workOrderName: string | null;
  taskId: string;
  taskName: string | null;
  assetId: string;
  assetName: string | null;
  productionReasonId: string;
  productionReasonName: string | null;
  quantityProduced: number;
  startedAt: Date;
  finishedAt: Date | null;
  comment: string | null;
  itemName: string | null;
  uomName: string | null;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
  createdAt: Date;
}

export class GetPlainUtilLogsByLogIdDto implements IGetPlainUtilLogsByLogIdDto {
  logId!: string;
  sourceLogId!: string | null;
  assetName!: string | null;
  startedAt!: Date;
  finishedAt!: Date | null;
  duration!: number;
  utilRawName!: string | null;
  utilStateName!: string | null;
  comment!: string | null;
  createdById!: string | null;
  createdByFullName!: string | null;
  createdByUserName!: string | null;
  createdAt!: Date;

  constructor(data?: IGetPlainUtilLogsByLogIdDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.sourceLogId =
        _data["sourceLogId"] !== undefined ? _data["sourceLogId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
      this.utilRawName =
        _data["utilRawName"] !== undefined ? _data["utilRawName"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): GetPlainUtilLogsByLogIdDto {
    data = typeof data === "object" ? data : {};
    let result = new GetPlainUtilLogsByLogIdDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["sourceLogId"] =
      this.sourceLogId !== undefined ? this.sourceLogId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    data["utilRawName"] =
      this.utilRawName !== undefined ? this.utilRawName : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    return data;
  }
}

export interface IGetPlainUtilLogsByLogIdDto {
  logId: string;
  sourceLogId: string | null;
  assetName: string | null;
  startedAt: Date;
  finishedAt: Date | null;
  duration: number;
  utilRawName: string | null;
  utilStateName: string | null;
  comment: string | null;
  createdById: string | null;
  createdByFullName: string | null;
  createdByUserName: string | null;
  createdAt: Date;
}

export class GetProductionLogsDto implements IGetProductionLogsDto {
  logId!: string;
  workOrderId!: string;
  workOrderName!: string | null;
  taskId!: string;
  taskName!: string | null;
  assetId!: string;
  assetName!: string | null;
  productionReasonId!: string;
  productionReasonName!: string | null;
  quantityProduced!: number;
  startedAt!: Date;
  lastProducedAt!: Date;
  finishedAt!: Date | null;
  comment!: string | null;
  sourceLogId!: string | null;
  itemId!: string;
  itemName!: string | null;
  uomId!: string;
  uomName!: string | null;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;

  constructor(data?: IGetProductionLogsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.workOrderId =
        _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
      this.taskName =
        _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.productionReasonId =
        _data["productionReasonId"] !== undefined
          ? _data["productionReasonId"]
          : <any>null;
      this.productionReasonName =
        _data["productionReasonName"] !== undefined
          ? _data["productionReasonName"]
          : <any>null;
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.lastProducedAt = _data["lastProducedAt"]
        ? new Date(_data["lastProducedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.sourceLogId =
        _data["sourceLogId"] !== undefined ? _data["sourceLogId"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.uomId = _data["uomId"] !== undefined ? _data["uomId"] : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetProductionLogsDto {
    data = typeof data === "object" ? data : {};
    let result = new GetProductionLogsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["workOrderId"] =
      this.workOrderId !== undefined ? this.workOrderId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["productionReasonId"] =
      this.productionReasonId !== undefined
        ? this.productionReasonId
        : <any>null;
    data["productionReasonName"] =
      this.productionReasonName !== undefined
        ? this.productionReasonName
        : <any>null;
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["lastProducedAt"] = this.lastProducedAt
      ? this.lastProducedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["sourceLogId"] =
      this.sourceLogId !== undefined ? this.sourceLogId : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["uomId"] = this.uomId !== undefined ? this.uomId : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    return data;
  }
}

export interface IGetProductionLogsDto {
  logId: string;
  workOrderId: string;
  workOrderName: string | null;
  taskId: string;
  taskName: string | null;
  assetId: string;
  assetName: string | null;
  productionReasonId: string;
  productionReasonName: string | null;
  quantityProduced: number;
  startedAt: Date;
  lastProducedAt: Date;
  finishedAt: Date | null;
  comment: string | null;
  sourceLogId: string | null;
  itemId: string;
  itemName: string | null;
  uomId: string;
  uomName: string | null;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
}

export class GetQualityByAssetIdDto implements IGetQualityByAssetIdDto {
  quantityGood!: number;
  quantityBad!: number;
  quality!: number | null;
  targetQuality!: number;

  constructor(data?: IGetQualityByAssetIdDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.quantityGood =
        _data["quantityGood"] !== undefined ? _data["quantityGood"] : <any>null;
      this.quantityBad =
        _data["quantityBad"] !== undefined ? _data["quantityBad"] : <any>null;
      this.quality =
        _data["quality"] !== undefined ? _data["quality"] : <any>null;
      this.targetQuality =
        _data["targetQuality"] !== undefined
          ? _data["targetQuality"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetQualityByAssetIdDto {
    data = typeof data === "object" ? data : {};
    let result = new GetQualityByAssetIdDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["quantityGood"] =
      this.quantityGood !== undefined ? this.quantityGood : <any>null;
    data["quantityBad"] =
      this.quantityBad !== undefined ? this.quantityBad : <any>null;
    data["quality"] = this.quality !== undefined ? this.quality : <any>null;
    data["targetQuality"] =
      this.targetQuality !== undefined ? this.targetQuality : <any>null;
    return data;
  }
}

export interface IGetQualityByAssetIdDto {
  quantityGood: number;
  quantityBad: number;
  quality: number | null;
  targetQuality: number;
}

export class GetTaskByIdQueryDto implements IGetTaskByIdQueryDto {
  id!: string;
  workOrderId!: string;
  workOrderName!: string | null;
  name!: string | null;
  nbr!: number;
  description!: string | null;
  taskStateId!: string;
  taskStateName!: string | null;
  taskStateColor!: string | null;
  itemId!: string;
  itemName!: string | null;
  quantityRequired!: number;
  notes!: string | null;
  scheduledAssetId!: string;
  scheduledAssetName!: string | null;
  scheduledStartAt!: Date;
  scheduledFinishAt!: Date;
  priority!: number;
  uomId!: string;
  uomConversionId!: string | null;
  abbreviation!: string | null;
  uomName!: string | null;
  productionRateUom!: number;
  batchSize!: number;
  estimatedProdRate!: number;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;
  createdAt!: Date;
  editedById!: string | null;
  editedByUserName!: string | null;
  editedByFullName!: string | null;
  editedAt!: Date | null;

  constructor(data?: IGetTaskByIdQueryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.workOrderId =
        _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.nbr = _data["nbr"] !== undefined ? _data["nbr"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.taskStateId =
        _data["taskStateId"] !== undefined ? _data["taskStateId"] : <any>null;
      this.taskStateName =
        _data["taskStateName"] !== undefined
          ? _data["taskStateName"]
          : <any>null;
      this.taskStateColor =
        _data["taskStateColor"] !== undefined
          ? _data["taskStateColor"]
          : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.scheduledAssetId =
        _data["scheduledAssetId"] !== undefined
          ? _data["scheduledAssetId"]
          : <any>null;
      this.scheduledAssetName =
        _data["scheduledAssetName"] !== undefined
          ? _data["scheduledAssetName"]
          : <any>null;
      this.scheduledStartAt = _data["scheduledStartAt"]
        ? new Date(_data["scheduledStartAt"].toString())
        : <any>null;
      this.scheduledFinishAt = _data["scheduledFinishAt"]
        ? new Date(_data["scheduledFinishAt"].toString())
        : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.uomId = _data["uomId"] !== undefined ? _data["uomId"] : <any>null;
      this.uomConversionId =
        _data["uomConversionId"] !== undefined
          ? _data["uomConversionId"]
          : <any>null;
      this.abbreviation =
        _data["abbreviation"] !== undefined ? _data["abbreviation"] : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      this.productionRateUom =
        _data["productionRateUom"] !== undefined
          ? _data["productionRateUom"]
          : <any>null;
      this.batchSize =
        _data["batchSize"] !== undefined ? _data["batchSize"] : <any>null;
      this.estimatedProdRate =
        _data["estimatedProdRate"] !== undefined
          ? _data["estimatedProdRate"]
          : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      this.editedById =
        _data["editedById"] !== undefined ? _data["editedById"] : <any>null;
      this.editedByUserName =
        _data["editedByUserName"] !== undefined
          ? _data["editedByUserName"]
          : <any>null;
      this.editedByFullName =
        _data["editedByFullName"] !== undefined
          ? _data["editedByFullName"]
          : <any>null;
      this.editedAt = _data["editedAt"]
        ? new Date(_data["editedAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): GetTaskByIdQueryDto {
    data = typeof data === "object" ? data : {};
    let result = new GetTaskByIdQueryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["workOrderId"] =
      this.workOrderId !== undefined ? this.workOrderId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["nbr"] = this.nbr !== undefined ? this.nbr : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["taskStateId"] =
      this.taskStateId !== undefined ? this.taskStateId : <any>null;
    data["taskStateName"] =
      this.taskStateName !== undefined ? this.taskStateName : <any>null;
    data["taskStateColor"] =
      this.taskStateColor !== undefined ? this.taskStateColor : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["scheduledAssetId"] =
      this.scheduledAssetId !== undefined ? this.scheduledAssetId : <any>null;
    data["scheduledAssetName"] =
      this.scheduledAssetName !== undefined
        ? this.scheduledAssetName
        : <any>null;
    data["scheduledStartAt"] = this.scheduledStartAt
      ? this.scheduledStartAt.toISOString()
      : <any>null;
    data["scheduledFinishAt"] = this.scheduledFinishAt
      ? this.scheduledFinishAt.toISOString()
      : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["uomId"] = this.uomId !== undefined ? this.uomId : <any>null;
    data["uomConversionId"] =
      this.uomConversionId !== undefined ? this.uomConversionId : <any>null;
    data["abbreviation"] =
      this.abbreviation !== undefined ? this.abbreviation : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["productionRateUom"] =
      this.productionRateUom !== undefined ? this.productionRateUom : <any>null;
    data["batchSize"] =
      this.batchSize !== undefined ? this.batchSize : <any>null;
    data["estimatedProdRate"] =
      this.estimatedProdRate !== undefined ? this.estimatedProdRate : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data["editedById"] =
      this.editedById !== undefined ? this.editedById : <any>null;
    data["editedByUserName"] =
      this.editedByUserName !== undefined ? this.editedByUserName : <any>null;
    data["editedByFullName"] =
      this.editedByFullName !== undefined ? this.editedByFullName : <any>null;
    data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : <any>null;
    return data;
  }
}

export interface IGetTaskByIdQueryDto {
  id: string;
  workOrderId: string;
  workOrderName: string | null;
  name: string | null;
  nbr: number;
  description: string | null;
  taskStateId: string;
  taskStateName: string | null;
  taskStateColor: string | null;
  itemId: string;
  itemName: string | null;
  quantityRequired: number;
  notes: string | null;
  scheduledAssetId: string;
  scheduledAssetName: string | null;
  scheduledStartAt: Date;
  scheduledFinishAt: Date;
  priority: number;
  uomId: string;
  uomConversionId: string | null;
  abbreviation: string | null;
  uomName: string | null;
  productionRateUom: number;
  batchSize: number;
  estimatedProdRate: number;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
  createdAt: Date;
  editedById: string | null;
  editedByUserName: string | null;
  editedByFullName: string | null;
  editedAt: Date | null;
}

export class GetTaskExecByTaskIdQueryDto
  implements IGetTaskExecByTaskIdQueryDto
{
  assetId!: string;
  assetName!: string | null;
  assetPosition!: number;
  currentTaskStartedAt!: Date | null;
  duration!: number | null;
  currentWorkOrderId!: string | null;
  currentWorkOrderName!: string | null;
  currentTaskId!: string | null;
  currentTaskName!: string | null;
  currentTaskItemName!: string | null;
  currentTaskQuantityRequired!: number | null;
  currentTaskQuantityProduced!: number | null;
  currentTaskQuantityRejected!: number | null;
  currentTaskLogId!: string | null;
  currentTaskStateId!: string | null;
  currentTaskStateName!: string | null;
  currentTaskStateColor!: string | null;
  currentGoodProductionLogId!: string | null;
  currentBadProductionLogId!: string | null;

  constructor(data?: IGetTaskExecByTaskIdQueryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.assetPosition =
        _data["assetPosition"] !== undefined
          ? _data["assetPosition"]
          : <any>null;
      this.currentTaskStartedAt = _data["currentTaskStartedAt"]
        ? new Date(_data["currentTaskStartedAt"].toString())
        : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
      this.currentWorkOrderId =
        _data["currentWorkOrderId"] !== undefined
          ? _data["currentWorkOrderId"]
          : <any>null;
      this.currentWorkOrderName =
        _data["currentWorkOrderName"] !== undefined
          ? _data["currentWorkOrderName"]
          : <any>null;
      this.currentTaskId =
        _data["currentTaskId"] !== undefined
          ? _data["currentTaskId"]
          : <any>null;
      this.currentTaskName =
        _data["currentTaskName"] !== undefined
          ? _data["currentTaskName"]
          : <any>null;
      this.currentTaskItemName =
        _data["currentTaskItemName"] !== undefined
          ? _data["currentTaskItemName"]
          : <any>null;
      this.currentTaskQuantityRequired =
        _data["currentTaskQuantityRequired"] !== undefined
          ? _data["currentTaskQuantityRequired"]
          : <any>null;
      this.currentTaskQuantityProduced =
        _data["currentTaskQuantityProduced"] !== undefined
          ? _data["currentTaskQuantityProduced"]
          : <any>null;
      this.currentTaskQuantityRejected =
        _data["currentTaskQuantityRejected"] !== undefined
          ? _data["currentTaskQuantityRejected"]
          : <any>null;
      this.currentTaskLogId =
        _data["currentTaskLogId"] !== undefined
          ? _data["currentTaskLogId"]
          : <any>null;
      this.currentTaskStateId =
        _data["currentTaskStateId"] !== undefined
          ? _data["currentTaskStateId"]
          : <any>null;
      this.currentTaskStateName =
        _data["currentTaskStateName"] !== undefined
          ? _data["currentTaskStateName"]
          : <any>null;
      this.currentTaskStateColor =
        _data["currentTaskStateColor"] !== undefined
          ? _data["currentTaskStateColor"]
          : <any>null;
      this.currentGoodProductionLogId =
        _data["currentGoodProductionLogId"] !== undefined
          ? _data["currentGoodProductionLogId"]
          : <any>null;
      this.currentBadProductionLogId =
        _data["currentBadProductionLogId"] !== undefined
          ? _data["currentBadProductionLogId"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetTaskExecByTaskIdQueryDto {
    data = typeof data === "object" ? data : {};
    let result = new GetTaskExecByTaskIdQueryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["assetPosition"] =
      this.assetPosition !== undefined ? this.assetPosition : <any>null;
    data["currentTaskStartedAt"] = this.currentTaskStartedAt
      ? this.currentTaskStartedAt.toISOString()
      : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    data["currentWorkOrderId"] =
      this.currentWorkOrderId !== undefined
        ? this.currentWorkOrderId
        : <any>null;
    data["currentWorkOrderName"] =
      this.currentWorkOrderName !== undefined
        ? this.currentWorkOrderName
        : <any>null;
    data["currentTaskId"] =
      this.currentTaskId !== undefined ? this.currentTaskId : <any>null;
    data["currentTaskName"] =
      this.currentTaskName !== undefined ? this.currentTaskName : <any>null;
    data["currentTaskItemName"] =
      this.currentTaskItemName !== undefined
        ? this.currentTaskItemName
        : <any>null;
    data["currentTaskQuantityRequired"] =
      this.currentTaskQuantityRequired !== undefined
        ? this.currentTaskQuantityRequired
        : <any>null;
    data["currentTaskQuantityProduced"] =
      this.currentTaskQuantityProduced !== undefined
        ? this.currentTaskQuantityProduced
        : <any>null;
    data["currentTaskQuantityRejected"] =
      this.currentTaskQuantityRejected !== undefined
        ? this.currentTaskQuantityRejected
        : <any>null;
    data["currentTaskLogId"] =
      this.currentTaskLogId !== undefined ? this.currentTaskLogId : <any>null;
    data["currentTaskStateId"] =
      this.currentTaskStateId !== undefined
        ? this.currentTaskStateId
        : <any>null;
    data["currentTaskStateName"] =
      this.currentTaskStateName !== undefined
        ? this.currentTaskStateName
        : <any>null;
    data["currentTaskStateColor"] =
      this.currentTaskStateColor !== undefined
        ? this.currentTaskStateColor
        : <any>null;
    data["currentGoodProductionLogId"] =
      this.currentGoodProductionLogId !== undefined
        ? this.currentGoodProductionLogId
        : <any>null;
    data["currentBadProductionLogId"] =
      this.currentBadProductionLogId !== undefined
        ? this.currentBadProductionLogId
        : <any>null;
    return data;
  }
}

export interface IGetTaskExecByTaskIdQueryDto {
  assetId: string;
  assetName: string | null;
  assetPosition: number;
  currentTaskStartedAt: Date | null;
  duration: number | null;
  currentWorkOrderId: string | null;
  currentWorkOrderName: string | null;
  currentTaskId: string | null;
  currentTaskName: string | null;
  currentTaskItemName: string | null;
  currentTaskQuantityRequired: number | null;
  currentTaskQuantityProduced: number | null;
  currentTaskQuantityRejected: number | null;
  currentTaskLogId: string | null;
  currentTaskStateId: string | null;
  currentTaskStateName: string | null;
  currentTaskStateColor: string | null;
  currentGoodProductionLogId: string | null;
  currentBadProductionLogId: string | null;
}

export class GetTaskLogsDto implements IGetTaskLogsDto {
  logId!: string;
  workOrderId!: string;
  workOrderName!: string | null;
  taskId!: string;
  taskName!: string | null;
  assetId!: string;
  assetName!: string | null;
  itemId!: string;
  itemName!: string | null;
  startedAt!: Date;
  finishedAt!: Date | null;
  taskStateId!: string;
  taskStateName!: string | null;
  taskStateColor!: string | null;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;

  constructor(data?: IGetTaskLogsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.workOrderId =
        _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
      this.taskName =
        _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.taskStateId =
        _data["taskStateId"] !== undefined ? _data["taskStateId"] : <any>null;
      this.taskStateName =
        _data["taskStateName"] !== undefined
          ? _data["taskStateName"]
          : <any>null;
      this.taskStateColor =
        _data["taskStateColor"] !== undefined
          ? _data["taskStateColor"]
          : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetTaskLogsDto {
    data = typeof data === "object" ? data : {};
    let result = new GetTaskLogsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["workOrderId"] =
      this.workOrderId !== undefined ? this.workOrderId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["taskStateId"] =
      this.taskStateId !== undefined ? this.taskStateId : <any>null;
    data["taskStateName"] =
      this.taskStateName !== undefined ? this.taskStateName : <any>null;
    data["taskStateColor"] =
      this.taskStateColor !== undefined ? this.taskStateColor : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    return data;
  }
}

export interface IGetTaskLogsDto {
  logId: string;
  workOrderId: string;
  workOrderName: string | null;
  taskId: string;
  taskName: string | null;
  assetId: string;
  assetName: string | null;
  itemId: string;
  itemName: string | null;
  startedAt: Date;
  finishedAt: Date | null;
  taskStateId: string;
  taskStateName: string | null;
  taskStateColor: string | null;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
}

export class GetUtilExecByAssetIdDto implements IGetUtilExecByAssetIdDto {
  assetId!: string;
  assetName!: string | null;
  currentUtilRawStartedAt!: Date | null;
  duration!: number | null;
  utilStateColor!: string | null;
  utilRawId!: string | null;
  utilRawName!: string | null;
  utilStateId!: string | null;
  utilStateName!: string | null;
  comment!: string | null;
  createdByUserId!: string | null;
  createdByUserFullName!: string | null;
  createdByUserName!: string | null;
  logId!: string | null;

  constructor(data?: IGetUtilExecByAssetIdDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.currentUtilRawStartedAt = _data["currentUtilRawStartedAt"]
        ? new Date(_data["currentUtilRawStartedAt"].toString())
        : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
      this.utilStateColor =
        _data["utilStateColor"] !== undefined
          ? _data["utilStateColor"]
          : <any>null;
      this.utilRawId =
        _data["utilRawId"] !== undefined ? _data["utilRawId"] : <any>null;
      this.utilRawName =
        _data["utilRawName"] !== undefined ? _data["utilRawName"] : <any>null;
      this.utilStateId =
        _data["utilStateId"] !== undefined ? _data["utilStateId"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.createdByUserId =
        _data["createdByUserId"] !== undefined
          ? _data["createdByUserId"]
          : <any>null;
      this.createdByUserFullName =
        _data["createdByUserFullName"] !== undefined
          ? _data["createdByUserFullName"]
          : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
    }
  }

  static fromJS(data: any): GetUtilExecByAssetIdDto {
    data = typeof data === "object" ? data : {};
    let result = new GetUtilExecByAssetIdDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["currentUtilRawStartedAt"] = this.currentUtilRawStartedAt
      ? this.currentUtilRawStartedAt.toISOString()
      : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    data["utilStateColor"] =
      this.utilStateColor !== undefined ? this.utilStateColor : <any>null;
    data["utilRawId"] =
      this.utilRawId !== undefined ? this.utilRawId : <any>null;
    data["utilRawName"] =
      this.utilRawName !== undefined ? this.utilRawName : <any>null;
    data["utilStateId"] =
      this.utilStateId !== undefined ? this.utilStateId : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["createdByUserId"] =
      this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
    data["createdByUserFullName"] =
      this.createdByUserFullName !== undefined
        ? this.createdByUserFullName
        : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    return data;
  }
}

export interface IGetUtilExecByAssetIdDto {
  assetId: string;
  assetName: string | null;
  currentUtilRawStartedAt: Date | null;
  duration: number | null;
  utilStateColor: string | null;
  utilRawId: string | null;
  utilRawName: string | null;
  utilStateId: string | null;
  utilStateName: string | null;
  comment: string | null;
  createdByUserId: string | null;
  createdByUserFullName: string | null;
  createdByUserName: string | null;
  logId: string | null;
}

export class GetUtilLogByIdDto implements IGetUtilLogByIdDto {
  logId!: string;
  assetId!: string;
  assetName!: string | null;
  startedAt!: Date;
  finishedAt!: Date | null;
  duration!: number;
  utilRawId!: string;
  utilRawName!: string | null;
  utilStateId!: string;
  utilStateName!: string | null;
  utilStateColor!: string | null;
  oeeDefinition!: OeeDefinition;
  comment!: string | null;
  sourceLogId!: string | null;
  isFinal!: boolean;
  createdById!: string | null;
  createdByFullName!: string | null;
  createdByUserName!: string | null;

  constructor(data?: IGetUtilLogByIdDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
      this.utilRawId =
        _data["utilRawId"] !== undefined ? _data["utilRawId"] : <any>null;
      this.utilRawName =
        _data["utilRawName"] !== undefined ? _data["utilRawName"] : <any>null;
      this.utilStateId =
        _data["utilStateId"] !== undefined ? _data["utilStateId"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.utilStateColor =
        _data["utilStateColor"] !== undefined
          ? _data["utilStateColor"]
          : <any>null;
      this.oeeDefinition =
        _data["oeeDefinition"] !== undefined
          ? _data["oeeDefinition"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.sourceLogId =
        _data["sourceLogId"] !== undefined ? _data["sourceLogId"] : <any>null;
      this.isFinal =
        _data["isFinal"] !== undefined ? _data["isFinal"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetUtilLogByIdDto {
    data = typeof data === "object" ? data : {};
    let result = new GetUtilLogByIdDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    data["utilRawId"] =
      this.utilRawId !== undefined ? this.utilRawId : <any>null;
    data["utilRawName"] =
      this.utilRawName !== undefined ? this.utilRawName : <any>null;
    data["utilStateId"] =
      this.utilStateId !== undefined ? this.utilStateId : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["utilStateColor"] =
      this.utilStateColor !== undefined ? this.utilStateColor : <any>null;
    data["oeeDefinition"] =
      this.oeeDefinition !== undefined ? this.oeeDefinition : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["sourceLogId"] =
      this.sourceLogId !== undefined ? this.sourceLogId : <any>null;
    data["isFinal"] = this.isFinal !== undefined ? this.isFinal : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    return data;
  }
}

export interface IGetUtilLogByIdDto {
  logId: string;
  assetId: string;
  assetName: string | null;
  startedAt: Date;
  finishedAt: Date | null;
  duration: number;
  utilRawId: string;
  utilRawName: string | null;
  utilStateId: string;
  utilStateName: string | null;
  utilStateColor: string | null;
  oeeDefinition: OeeDefinition;
  comment: string | null;
  sourceLogId: string | null;
  isFinal: boolean;
  createdById: string | null;
  createdByFullName: string | null;
  createdByUserName: string | null;
}

export class GetUtilLogsByAssetIdQueryDto
  implements IGetUtilLogsByAssetIdQueryDto
{
  logId!: string;
  assetName!: string | null;
  startedAt!: Date;
  finishedAt!: Date | null;
  duration!: number;
  utilRawId!: string;
  utilRawName!: string | null;
  utilStateId!: string;
  utilStateName!: string | null;
  utilStateColor!: string | null;
  oeeDefinition!: OeeDefinition;
  comment!: string | null;
  createdById!: string | null;
  createdByFullName!: string | null;
  createdByUserName!: string | null;

  constructor(data?: IGetUtilLogsByAssetIdQueryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
      this.utilRawId =
        _data["utilRawId"] !== undefined ? _data["utilRawId"] : <any>null;
      this.utilRawName =
        _data["utilRawName"] !== undefined ? _data["utilRawName"] : <any>null;
      this.utilStateId =
        _data["utilStateId"] !== undefined ? _data["utilStateId"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.utilStateColor =
        _data["utilStateColor"] !== undefined
          ? _data["utilStateColor"]
          : <any>null;
      this.oeeDefinition =
        _data["oeeDefinition"] !== undefined
          ? _data["oeeDefinition"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetUtilLogsByAssetIdQueryDto {
    data = typeof data === "object" ? data : {};
    let result = new GetUtilLogsByAssetIdQueryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    data["utilRawId"] =
      this.utilRawId !== undefined ? this.utilRawId : <any>null;
    data["utilRawName"] =
      this.utilRawName !== undefined ? this.utilRawName : <any>null;
    data["utilStateId"] =
      this.utilStateId !== undefined ? this.utilStateId : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["utilStateColor"] =
      this.utilStateColor !== undefined ? this.utilStateColor : <any>null;
    data["oeeDefinition"] =
      this.oeeDefinition !== undefined ? this.oeeDefinition : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    return data;
  }
}

export interface IGetUtilLogsByAssetIdQueryDto {
  logId: string;
  assetName: string | null;
  startedAt: Date;
  finishedAt: Date | null;
  duration: number;
  utilRawId: string;
  utilRawName: string | null;
  utilStateId: string;
  utilStateName: string | null;
  utilStateColor: string | null;
  oeeDefinition: OeeDefinition;
  comment: string | null;
  createdById: string | null;
  createdByFullName: string | null;
  createdByUserName: string | null;
}

export class GetUtilLogsDto implements IGetUtilLogsDto {
  logId!: string;
  assetId!: string;
  assetName!: string | null;
  startedAt!: Date;
  finishedAt!: Date | null;
  duration!: number;
  utilRawId!: string;
  utilRawName!: string | null;
  utilStateId!: string;
  utilStateName!: string | null;
  utilStateColor!: string | null;
  oeeDefinition!: OeeDefinition;
  comment!: string | null;
  createdById!: string | null;
  createdByFullName!: string | null;
  createdByUserName!: string | null;

  constructor(data?: IGetUtilLogsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.assetName =
        _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
      this.utilRawId =
        _data["utilRawId"] !== undefined ? _data["utilRawId"] : <any>null;
      this.utilRawName =
        _data["utilRawName"] !== undefined ? _data["utilRawName"] : <any>null;
      this.utilStateId =
        _data["utilStateId"] !== undefined ? _data["utilStateId"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.utilStateColor =
        _data["utilStateColor"] !== undefined
          ? _data["utilStateColor"]
          : <any>null;
      this.oeeDefinition =
        _data["oeeDefinition"] !== undefined
          ? _data["oeeDefinition"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetUtilLogsDto {
    data = typeof data === "object" ? data : {};
    let result = new GetUtilLogsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["assetName"] =
      this.assetName !== undefined ? this.assetName : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    data["utilRawId"] =
      this.utilRawId !== undefined ? this.utilRawId : <any>null;
    data["utilRawName"] =
      this.utilRawName !== undefined ? this.utilRawName : <any>null;
    data["utilStateId"] =
      this.utilStateId !== undefined ? this.utilStateId : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["utilStateColor"] =
      this.utilStateColor !== undefined ? this.utilStateColor : <any>null;
    data["oeeDefinition"] =
      this.oeeDefinition !== undefined ? this.oeeDefinition : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    return data;
  }
}

export interface IGetUtilLogsDto {
  logId: string;
  assetId: string;
  assetName: string | null;
  startedAt: Date;
  finishedAt: Date | null;
  duration: number;
  utilRawId: string;
  utilRawName: string | null;
  utilStateId: string;
  utilStateName: string | null;
  utilStateColor: string | null;
  oeeDefinition: OeeDefinition;
  comment: string | null;
  createdById: string | null;
  createdByFullName: string | null;
  createdByUserName: string | null;
}

export class GetUtilRawsGroupedByStatesByAssetIdQueryDto
  implements IGetUtilRawsGroupedByStatesByAssetIdQueryDto
{
  percent!: number;
  utilStateName!: string | null;
  utilStateColor!: string | null;

  constructor(data?: IGetUtilRawsGroupedByStatesByAssetIdQueryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.percent =
        _data["percent"] !== undefined ? _data["percent"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.utilStateColor =
        _data["utilStateColor"] !== undefined
          ? _data["utilStateColor"]
          : <any>null;
    }
  }

  static fromJS(data: any): GetUtilRawsGroupedByStatesByAssetIdQueryDto {
    data = typeof data === "object" ? data : {};
    let result = new GetUtilRawsGroupedByStatesByAssetIdQueryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["percent"] = this.percent !== undefined ? this.percent : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["utilStateColor"] =
      this.utilStateColor !== undefined ? this.utilStateColor : <any>null;
    return data;
  }
}

export interface IGetUtilRawsGroupedByStatesByAssetIdQueryDto {
  percent: number;
  utilStateName: string | null;
  utilStateColor: string | null;
}

export class GetWorkOrderByIdQueryDto implements IGetWorkOrderByIdQueryDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  state!: WorkOrderState;
  itemId!: string;
  itemName!: string | null;
  quantityRequired!: number;
  notes!: string | null;
  dueDateTime!: Date;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;
  createdAt!: Date;
  editedBy!: string | null;
  editedByUserName!: string | null;
  editedByFullName!: string | null;
  editedAt!: Date | null;

  constructor(data?: IGetWorkOrderByIdQueryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.dueDateTime = _data["dueDateTime"]
        ? new Date(_data["dueDateTime"].toString())
        : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      this.editedBy =
        _data["editedBy"] !== undefined ? _data["editedBy"] : <any>null;
      this.editedByUserName =
        _data["editedByUserName"] !== undefined
          ? _data["editedByUserName"]
          : <any>null;
      this.editedByFullName =
        _data["editedByFullName"] !== undefined
          ? _data["editedByFullName"]
          : <any>null;
      this.editedAt = _data["editedAt"]
        ? new Date(_data["editedAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): GetWorkOrderByIdQueryDto {
    data = typeof data === "object" ? data : {};
    let result = new GetWorkOrderByIdQueryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["state"] = this.state !== undefined ? this.state : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["dueDateTime"] = this.dueDateTime
      ? this.dueDateTime.toISOString()
      : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data["editedBy"] = this.editedBy !== undefined ? this.editedBy : <any>null;
    data["editedByUserName"] =
      this.editedByUserName !== undefined ? this.editedByUserName : <any>null;
    data["editedByFullName"] =
      this.editedByFullName !== undefined ? this.editedByFullName : <any>null;
    data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : <any>null;
    return data;
  }
}

export interface IGetWorkOrderByIdQueryDto {
  id: string;
  name: string | null;
  description: string | null;
  state: WorkOrderState;
  itemId: string;
  itemName: string | null;
  quantityRequired: number;
  notes: string | null;
  dueDateTime: Date;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
  createdAt: Date;
  editedBy: string | null;
  editedByUserName: string | null;
  editedByFullName: string | null;
  editedAt: Date | null;
}

export class GetWorkOrderByTaskIdQueryDto
  implements IGetWorkOrderByTaskIdQueryDto
{
  id!: string;
  name!: string | null;
  description!: string | null;
  state!: WorkOrderState;
  itemId!: string;
  itemName!: string | null;
  quantityRequired!: number;
  notes!: string | null;
  dueDateTime!: Date;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;
  createdAt!: Date;
  editedBy!: string | null;
  editedByUserName!: string | null;
  editedByFullName!: string | null;
  editedAt!: Date | null;

  constructor(data?: IGetWorkOrderByTaskIdQueryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.dueDateTime = _data["dueDateTime"]
        ? new Date(_data["dueDateTime"].toString())
        : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      this.editedBy =
        _data["editedBy"] !== undefined ? _data["editedBy"] : <any>null;
      this.editedByUserName =
        _data["editedByUserName"] !== undefined
          ? _data["editedByUserName"]
          : <any>null;
      this.editedByFullName =
        _data["editedByFullName"] !== undefined
          ? _data["editedByFullName"]
          : <any>null;
      this.editedAt = _data["editedAt"]
        ? new Date(_data["editedAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): GetWorkOrderByTaskIdQueryDto {
    data = typeof data === "object" ? data : {};
    let result = new GetWorkOrderByTaskIdQueryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["state"] = this.state !== undefined ? this.state : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["dueDateTime"] = this.dueDateTime
      ? this.dueDateTime.toISOString()
      : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data["editedBy"] = this.editedBy !== undefined ? this.editedBy : <any>null;
    data["editedByUserName"] =
      this.editedByUserName !== undefined ? this.editedByUserName : <any>null;
    data["editedByFullName"] =
      this.editedByFullName !== undefined ? this.editedByFullName : <any>null;
    data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : <any>null;
    return data;
  }
}

export interface IGetWorkOrderByTaskIdQueryDto {
  id: string;
  name: string | null;
  description: string | null;
  state: WorkOrderState;
  itemId: string;
  itemName: string | null;
  quantityRequired: number;
  notes: string | null;
  dueDateTime: Date;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
  createdAt: Date;
  editedBy: string | null;
  editedByUserName: string | null;
  editedByFullName: string | null;
  editedAt: Date | null;
}

export class GiveUtilRawUtilCategoryDto implements IGiveUtilRawUtilCategoryDto {
  linkId!: string;

  constructor(data?: IGiveUtilRawUtilCategoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.linkId = _data["linkId"] !== undefined ? _data["linkId"] : <any>null;
    }
  }

  static fromJS(data: any): GiveUtilRawUtilCategoryDto {
    data = typeof data === "object" ? data : {};
    let result = new GiveUtilRawUtilCategoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["linkId"] = this.linkId !== undefined ? this.linkId : <any>null;
    return data;
  }
}

export interface IGiveUtilRawUtilCategoryDto {
  linkId: string;
}

export class InvalidCommandExceptionProblemDetails
  implements IInvalidCommandExceptionProblemDetails
{
  type!: string | null;
  title!: string | null;
  status!: number | null;
  detail!: string | null;
  instance!: string | null;

  constructor(data?: IInvalidCommandExceptionProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
      this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
      this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
      this.instance =
        _data["instance"] !== undefined ? _data["instance"] : <any>null;
    }
  }

  static fromJS(data: any): InvalidCommandExceptionProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new InvalidCommandExceptionProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["title"] = this.title !== undefined ? this.title : <any>null;
    data["status"] = this.status !== undefined ? this.status : <any>null;
    data["detail"] = this.detail !== undefined ? this.detail : <any>null;
    data["instance"] = this.instance !== undefined ? this.instance : <any>null;
    return data;
  }
}

export interface IInvalidCommandExceptionProblemDetails {
  type: string | null;
  title: string | null;
  status: number | null;
  detail: string | null;
  instance: string | null;
}

export class ItemDto implements IItemDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  nomProdRate!: number | null;
  nomCovTime!: number | null;
  notes!: string | null;
  uomId!: string;
  uomName!: string | null;
  abbreviation!: string | null;
  itemTypeId!: string;
  itemTypeName!: string | null;
  itemTypeDescription!: string | null;

  constructor(data?: IItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.nomProdRate =
        _data["nomProdRate"] !== undefined ? _data["nomProdRate"] : <any>null;
      this.nomCovTime =
        _data["nomCovTime"] !== undefined ? _data["nomCovTime"] : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.uomId = _data["uomId"] !== undefined ? _data["uomId"] : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      this.abbreviation =
        _data["abbreviation"] !== undefined ? _data["abbreviation"] : <any>null;
      this.itemTypeId =
        _data["itemTypeId"] !== undefined ? _data["itemTypeId"] : <any>null;
      this.itemTypeName =
        _data["itemTypeName"] !== undefined ? _data["itemTypeName"] : <any>null;
      this.itemTypeDescription =
        _data["itemTypeDescription"] !== undefined
          ? _data["itemTypeDescription"]
          : <any>null;
    }
  }

  static fromJS(data: any): ItemDto {
    data = typeof data === "object" ? data : {};
    let result = new ItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["nomProdRate"] =
      this.nomProdRate !== undefined ? this.nomProdRate : <any>null;
    data["nomCovTime"] =
      this.nomCovTime !== undefined ? this.nomCovTime : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["uomId"] = this.uomId !== undefined ? this.uomId : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["abbreviation"] =
      this.abbreviation !== undefined ? this.abbreviation : <any>null;
    data["itemTypeId"] =
      this.itemTypeId !== undefined ? this.itemTypeId : <any>null;
    data["itemTypeName"] =
      this.itemTypeName !== undefined ? this.itemTypeName : <any>null;
    data["itemTypeDescription"] =
      this.itemTypeDescription !== undefined
        ? this.itemTypeDescription
        : <any>null;
    return data;
  }
}

export interface IItemDto {
  id: string;
  name: string | null;
  description: string | null;
  nomProdRate: number | null;
  nomCovTime: number | null;
  notes: string | null;
  uomId: string;
  uomName: string | null;
  abbreviation: string | null;
  itemTypeId: string;
  itemTypeName: string | null;
  itemTypeDescription: string | null;
}

export class ItemTypeDto implements IItemTypeDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  state!: number;

  constructor(data?: IItemTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
    }
  }

  static fromJS(data: any): ItemTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new ItemTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["state"] = this.state !== undefined ? this.state : <any>null;
    return data;
  }
}

export interface IItemTypeDto {
  id: string;
  name: string | null;
  description: string | null;
  state: number;
}

export enum ItemTypeState {
  _0 = 0,
  _1 = 1,
}

export class LogOffAssetRequest implements ILogOffAssetRequest {
  assetId!: string;

  constructor(data?: ILogOffAssetRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
    }
  }

  static fromJS(data: any): LogOffAssetRequest {
    data = typeof data === "object" ? data : {};
    let result = new LogOffAssetRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    return data;
  }
}

export interface ILogOffAssetRequest {
  assetId: string;
}

export class LogOffTaskRequest implements ILogOffTaskRequest {
  taskId!: string;

  constructor(data?: ILogOffTaskRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
    }
  }

  static fromJS(data: any): LogOffTaskRequest {
    data = typeof data === "object" ? data : {};
    let result = new LogOffTaskRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    return data;
  }
}

export interface ILogOffTaskRequest {
  taskId: string;
}

export class LogOnAssetDto implements ILogOnAssetDto {
  logId!: string;

  constructor(data?: ILogOnAssetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
    }
  }

  static fromJS(data: any): LogOnAssetDto {
    data = typeof data === "object" ? data : {};
    let result = new LogOnAssetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    return data;
  }
}

export interface ILogOnAssetDto {
  logId: string;
}

export class LogOnAssetRequest implements ILogOnAssetRequest {
  assetId!: string;
  logOffOtherEnts!: boolean;

  constructor(data?: ILogOnAssetRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.logOffOtherEnts =
        _data["logOffOtherEnts"] !== undefined
          ? _data["logOffOtherEnts"]
          : <any>null;
    }
  }

  static fromJS(data: any): LogOnAssetRequest {
    data = typeof data === "object" ? data : {};
    let result = new LogOnAssetRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["logOffOtherEnts"] =
      this.logOffOtherEnts !== undefined ? this.logOffOtherEnts : <any>null;
    return data;
  }
}

export interface ILogOnAssetRequest {
  assetId: string;
  logOffOtherEnts: boolean;
}

export class LogOnTaskRequest implements ILogOnTaskRequest {
  taskId!: string;

  constructor(data?: ILogOnTaskRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
    }
  }

  static fromJS(data: any): LogOnTaskRequest {
    data = typeof data === "object" ? data : {};
    let result = new LogOnTaskRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    return data;
  }
}

export interface ILogOnTaskRequest {
  taskId: string;
}

export class LoginUserDto implements ILoginUserDto {
  userId!: string;
  token!: string | null;

  constructor(data?: ILoginUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
      this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
    }
  }

  static fromJS(data: any): LoginUserDto {
    data = typeof data === "object" ? data : {};
    let result = new LoginUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userId"] = this.userId !== undefined ? this.userId : <any>null;
    data["token"] = this.token !== undefined ? this.token : <any>null;
    return data;
  }
}

export interface ILoginUserDto {
  userId: string;
  token: string | null;
}

export class LoginUserRequest implements ILoginUserRequest {
  connectionType!: ConnectionCategory;
  userName!: string | null;
  password!: string | null;

  constructor(data?: ILoginUserRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.connectionType =
        _data["connectionType"] !== undefined
          ? _data["connectionType"]
          : <any>null;
      this.userName =
        _data["userName"] !== undefined ? _data["userName"] : <any>null;
      this.password =
        _data["password"] !== undefined ? _data["password"] : <any>null;
    }
  }

  static fromJS(data: any): LoginUserRequest {
    data = typeof data === "object" ? data : {};
    let result = new LoginUserRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["connectionType"] =
      this.connectionType !== undefined ? this.connectionType : <any>null;
    data["userName"] = this.userName !== undefined ? this.userName : <any>null;
    data["password"] = this.password !== undefined ? this.password : <any>null;
    return data;
  }
}

export interface ILoginUserRequest {
  connectionType: ConnectionCategory;
  userName: string | null;
  password: string | null;
}

export class ManufacturingTaskDto implements IManufacturingTaskDto {
  taskId!: string;
  workOrderId!: string;
  workOrderName!: string | null;
  taskName!: string | null;
  taskDescription!: string | null;
  taskStateId!: string;
  taskStateName!: string | null;
  taskStateColor!: string | null;
  itemId!: string;
  itemName!: string | null;
  uomId!: string;
  uomName!: string | null;
  abbreviation!: string | null;
  quantityRequired!: number;
  quantityProduced!: number;
  quantityRejected!: number;
  notes!: string | null;
  scheduledAssetId!: string;
  scheduledAssetName!: string | null;
  scheduledStartAt!: Date;
  scheduledFinishAt!: Date;
  executionAssetId!: string | null;
  executionAssetName!: string | null;
  executionStartedAt!: Date | null;
  executionFinishedAt!: Date | null;
  priority!: number;
  currentTaskLogId!: string | null;
  currentGoodProductionLogId!: string | null;
  currentBadProductionLogId!: string | null;

  constructor(data?: IManufacturingTaskDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
      this.workOrderId =
        _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.taskName =
        _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
      this.taskDescription =
        _data["taskDescription"] !== undefined
          ? _data["taskDescription"]
          : <any>null;
      this.taskStateId =
        _data["taskStateId"] !== undefined ? _data["taskStateId"] : <any>null;
      this.taskStateName =
        _data["taskStateName"] !== undefined
          ? _data["taskStateName"]
          : <any>null;
      this.taskStateColor =
        _data["taskStateColor"] !== undefined
          ? _data["taskStateColor"]
          : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.uomId = _data["uomId"] !== undefined ? _data["uomId"] : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      this.abbreviation =
        _data["abbreviation"] !== undefined ? _data["abbreviation"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.quantityRejected =
        _data["quantityRejected"] !== undefined
          ? _data["quantityRejected"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.scheduledAssetId =
        _data["scheduledAssetId"] !== undefined
          ? _data["scheduledAssetId"]
          : <any>null;
      this.scheduledAssetName =
        _data["scheduledAssetName"] !== undefined
          ? _data["scheduledAssetName"]
          : <any>null;
      this.scheduledStartAt = _data["scheduledStartAt"]
        ? new Date(_data["scheduledStartAt"].toString())
        : <any>null;
      this.scheduledFinishAt = _data["scheduledFinishAt"]
        ? new Date(_data["scheduledFinishAt"].toString())
        : <any>null;
      this.executionAssetId =
        _data["executionAssetId"] !== undefined
          ? _data["executionAssetId"]
          : <any>null;
      this.executionAssetName =
        _data["executionAssetName"] !== undefined
          ? _data["executionAssetName"]
          : <any>null;
      this.executionStartedAt = _data["executionStartedAt"]
        ? new Date(_data["executionStartedAt"].toString())
        : <any>null;
      this.executionFinishedAt = _data["executionFinishedAt"]
        ? new Date(_data["executionFinishedAt"].toString())
        : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.currentTaskLogId =
        _data["currentTaskLogId"] !== undefined
          ? _data["currentTaskLogId"]
          : <any>null;
      this.currentGoodProductionLogId =
        _data["currentGoodProductionLogId"] !== undefined
          ? _data["currentGoodProductionLogId"]
          : <any>null;
      this.currentBadProductionLogId =
        _data["currentBadProductionLogId"] !== undefined
          ? _data["currentBadProductionLogId"]
          : <any>null;
    }
  }

  static fromJS(data: any): ManufacturingTaskDto {
    data = typeof data === "object" ? data : {};
    let result = new ManufacturingTaskDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    data["workOrderId"] =
      this.workOrderId !== undefined ? this.workOrderId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
    data["taskDescription"] =
      this.taskDescription !== undefined ? this.taskDescription : <any>null;
    data["taskStateId"] =
      this.taskStateId !== undefined ? this.taskStateId : <any>null;
    data["taskStateName"] =
      this.taskStateName !== undefined ? this.taskStateName : <any>null;
    data["taskStateColor"] =
      this.taskStateColor !== undefined ? this.taskStateColor : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["uomId"] = this.uomId !== undefined ? this.uomId : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["abbreviation"] =
      this.abbreviation !== undefined ? this.abbreviation : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["quantityRejected"] =
      this.quantityRejected !== undefined ? this.quantityRejected : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["scheduledAssetId"] =
      this.scheduledAssetId !== undefined ? this.scheduledAssetId : <any>null;
    data["scheduledAssetName"] =
      this.scheduledAssetName !== undefined
        ? this.scheduledAssetName
        : <any>null;
    data["scheduledStartAt"] = this.scheduledStartAt
      ? this.scheduledStartAt.toISOString()
      : <any>null;
    data["scheduledFinishAt"] = this.scheduledFinishAt
      ? this.scheduledFinishAt.toISOString()
      : <any>null;
    data["executionAssetId"] =
      this.executionAssetId !== undefined ? this.executionAssetId : <any>null;
    data["executionAssetName"] =
      this.executionAssetName !== undefined
        ? this.executionAssetName
        : <any>null;
    data["executionStartedAt"] = this.executionStartedAt
      ? this.executionStartedAt.toISOString()
      : <any>null;
    data["executionFinishedAt"] = this.executionFinishedAt
      ? this.executionFinishedAt.toISOString()
      : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["currentTaskLogId"] =
      this.currentTaskLogId !== undefined ? this.currentTaskLogId : <any>null;
    data["currentGoodProductionLogId"] =
      this.currentGoodProductionLogId !== undefined
        ? this.currentGoodProductionLogId
        : <any>null;
    data["currentBadProductionLogId"] =
      this.currentBadProductionLogId !== undefined
        ? this.currentBadProductionLogId
        : <any>null;
    return data;
  }
}

export interface IManufacturingTaskDto {
  taskId: string;
  workOrderId: string;
  workOrderName: string | null;
  taskName: string | null;
  taskDescription: string | null;
  taskStateId: string;
  taskStateName: string | null;
  taskStateColor: string | null;
  itemId: string;
  itemName: string | null;
  uomId: string;
  uomName: string | null;
  abbreviation: string | null;
  quantityRequired: number;
  quantityProduced: number;
  quantityRejected: number;
  notes: string | null;
  scheduledAssetId: string;
  scheduledAssetName: string | null;
  scheduledStartAt: Date;
  scheduledFinishAt: Date;
  executionAssetId: string | null;
  executionAssetName: string | null;
  executionStartedAt: Date | null;
  executionFinishedAt: Date | null;
  priority: number;
  currentTaskLogId: string | null;
  currentGoodProductionLogId: string | null;
  currentBadProductionLogId: string | null;
}

export class NestedSystemAttributeDTO implements INestedSystemAttributeDTO {
  systemAttributeGroupId!: string;
  id!: string | null;
  name!: string | null;
  description!: string | null;
  value!: string | null;
  valueType!: number | null;
  isActive!: boolean | null;

  constructor(data?: INestedSystemAttributeDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.systemAttributeGroupId =
        _data["systemAttributeGroupId"] !== undefined
          ? _data["systemAttributeGroupId"]
          : <any>null;
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      this.valueType =
        _data["valueType"] !== undefined ? _data["valueType"] : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): NestedSystemAttributeDTO {
    data = typeof data === "object" ? data : {};
    let result = new NestedSystemAttributeDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["systemAttributeGroupId"] =
      this.systemAttributeGroupId !== undefined
        ? this.systemAttributeGroupId
        : <any>null;
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["value"] = this.value !== undefined ? this.value : <any>null;
    data["valueType"] =
      this.valueType !== undefined ? this.valueType : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface INestedSystemAttributeDTO {
  systemAttributeGroupId: string;
  id: string | null;
  name: string | null;
  description: string | null;
  value: string | null;
  valueType: number | null;
  isActive: boolean | null;
}

export class NestedSystemAttributeGroupDTO
  implements INestedSystemAttributeGroupDTO
{
  id!: string;
  name!: string | null;
  description!: string | null;
  parentSystemAttributeGroupId!: string | null;
  isActive!: boolean;
  systemAttributes!: NestedSystemAttributeDTO[] | null;
  systemAttributeGroups!: NestedSystemAttributeGroupDTO[] | null;

  constructor(data?: INestedSystemAttributeGroupDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.parentSystemAttributeGroupId =
        _data["parentSystemAttributeGroupId"] !== undefined
          ? _data["parentSystemAttributeGroupId"]
          : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
      if (Array.isArray(_data["systemAttributes"])) {
        this.systemAttributes = [] as any;
        for (let item of _data["systemAttributes"])
          this.systemAttributes!.push(NestedSystemAttributeDTO.fromJS(item));
      } else {
        this.systemAttributes = <any>null;
      }
      if (Array.isArray(_data["systemAttributeGroups"])) {
        this.systemAttributeGroups = [] as any;
        for (let item of _data["systemAttributeGroups"])
          this.systemAttributeGroups!.push(
            NestedSystemAttributeGroupDTO.fromJS(item)
          );
      } else {
        this.systemAttributeGroups = <any>null;
      }
    }
  }

  static fromJS(data: any): NestedSystemAttributeGroupDTO {
    data = typeof data === "object" ? data : {};
    let result = new NestedSystemAttributeGroupDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["parentSystemAttributeGroupId"] =
      this.parentSystemAttributeGroupId !== undefined
        ? this.parentSystemAttributeGroupId
        : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    if (Array.isArray(this.systemAttributes)) {
      data["systemAttributes"] = [];
      for (let item of this.systemAttributes)
        data["systemAttributes"].push(item.toJSON());
    }
    if (Array.isArray(this.systemAttributeGroups)) {
      data["systemAttributeGroups"] = [];
      for (let item of this.systemAttributeGroups)
        data["systemAttributeGroups"].push(item.toJSON());
    }
    return data;
  }
}

export interface INestedSystemAttributeGroupDTO {
  id: string;
  name: string | null;
  description: string | null;
  parentSystemAttributeGroupId: string | null;
  isActive: boolean;
  systemAttributes: NestedSystemAttributeDTO[] | null;
  systemAttributeGroups: NestedSystemAttributeGroupDTO[] | null;
}

export enum OeeDefinition {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export class PeriodDto implements IPeriodDto {
  id!: string;
  name!: string | null;
  startTime!: string;
  endTime!: string;
  startDate!: Date;
  endDate!: Date;
  recurrence!: number;
  interval!: number | null;
  monday!: boolean;
  tuesday!: boolean;
  wednesday!: boolean;
  thursday!: boolean;
  friday!: boolean;
  saturday!: boolean;
  sunday!: boolean;
  createdBy!: string | null;
  createdAt!: Date;
  editedBy!: string | null;
  editedAt!: Date | null;
  isActive!: boolean;

  constructor(data?: IPeriodDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.startTime =
        _data["startTime"] !== undefined ? _data["startTime"] : <any>null;
      this.endTime =
        _data["endTime"] !== undefined ? _data["endTime"] : <any>null;
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : <any>null;
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : <any>null;
      this.recurrence =
        _data["recurrence"] !== undefined ? _data["recurrence"] : <any>null;
      this.interval =
        _data["interval"] !== undefined ? _data["interval"] : <any>null;
      this.monday = _data["monday"] !== undefined ? _data["monday"] : <any>null;
      this.tuesday =
        _data["tuesday"] !== undefined ? _data["tuesday"] : <any>null;
      this.wednesday =
        _data["wednesday"] !== undefined ? _data["wednesday"] : <any>null;
      this.thursday =
        _data["thursday"] !== undefined ? _data["thursday"] : <any>null;
      this.friday = _data["friday"] !== undefined ? _data["friday"] : <any>null;
      this.saturday =
        _data["saturday"] !== undefined ? _data["saturday"] : <any>null;
      this.sunday = _data["sunday"] !== undefined ? _data["sunday"] : <any>null;
      this.createdBy =
        _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      this.editedBy =
        _data["editedBy"] !== undefined ? _data["editedBy"] : <any>null;
      this.editedAt = _data["editedAt"]
        ? new Date(_data["editedAt"].toString())
        : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): PeriodDto {
    data = typeof data === "object" ? data : {};
    let result = new PeriodDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["startTime"] =
      this.startTime !== undefined ? this.startTime : <any>null;
    data["endTime"] = this.endTime !== undefined ? this.endTime : <any>null;
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : <any>null;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
    data["recurrence"] =
      this.recurrence !== undefined ? this.recurrence : <any>null;
    data["interval"] = this.interval !== undefined ? this.interval : <any>null;
    data["monday"] = this.monday !== undefined ? this.monday : <any>null;
    data["tuesday"] = this.tuesday !== undefined ? this.tuesday : <any>null;
    data["wednesday"] =
      this.wednesday !== undefined ? this.wednesday : <any>null;
    data["thursday"] = this.thursday !== undefined ? this.thursday : <any>null;
    data["friday"] = this.friday !== undefined ? this.friday : <any>null;
    data["saturday"] = this.saturday !== undefined ? this.saturday : <any>null;
    data["sunday"] = this.sunday !== undefined ? this.sunday : <any>null;
    data["createdBy"] =
      this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data["editedBy"] = this.editedBy !== undefined ? this.editedBy : <any>null;
    data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface IPeriodDto {
  id: string;
  name: string | null;
  startTime: string;
  endTime: string;
  startDate: Date;
  endDate: Date;
  recurrence: number;
  interval: number | null;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  createdBy: string | null;
  createdAt: Date;
  editedBy: string | null;
  editedAt: Date | null;
  isActive: boolean;
}

export class ProblemDetails implements IProblemDetails {
  type!: string | null;
  title!: string | null;
  status!: number | null;
  detail!: string | null;
  instance!: string | null;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
      this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
      this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
      this.instance =
        _data["instance"] !== undefined ? _data["instance"] : <any>null;
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["title"] = this.title !== undefined ? this.title : <any>null;
    data["status"] = this.status !== undefined ? this.status : <any>null;
    data["detail"] = this.detail !== undefined ? this.detail : <any>null;
    data["instance"] = this.instance !== undefined ? this.instance : <any>null;
    return data;
  }
}

export interface IProblemDetails {
  type: string | null;
  title: string | null;
  status: number | null;
  detail: string | null;
  instance: string | null;
}

export class ProductionLogDto implements IProductionLogDto {
  logId!: string;
  workOrderName!: string | null;
  taskId!: string;
  taskName!: string | null;
  assetId!: string | null;
  productionReasonId!: string;
  productionReasonName!: string | null;
  quantityProduced!: number;
  startedAt!: Date;
  lastProducedAt!: Date;
  finishedAt!: Date | null;
  comment!: string | null;
  sourceLogId!: string | null;
  itemId!: string;
  itemName!: string | null;
  uomId!: string;
  uomName!: string | null;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;

  constructor(data?: IProductionLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
      this.taskName =
        _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.productionReasonId =
        _data["productionReasonId"] !== undefined
          ? _data["productionReasonId"]
          : <any>null;
      this.productionReasonName =
        _data["productionReasonName"] !== undefined
          ? _data["productionReasonName"]
          : <any>null;
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.lastProducedAt = _data["lastProducedAt"]
        ? new Date(_data["lastProducedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.sourceLogId =
        _data["sourceLogId"] !== undefined ? _data["sourceLogId"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.uomId = _data["uomId"] !== undefined ? _data["uomId"] : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
    }
  }

  static fromJS(data: any): ProductionLogDto {
    data = typeof data === "object" ? data : {};
    let result = new ProductionLogDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["productionReasonId"] =
      this.productionReasonId !== undefined
        ? this.productionReasonId
        : <any>null;
    data["productionReasonName"] =
      this.productionReasonName !== undefined
        ? this.productionReasonName
        : <any>null;
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["lastProducedAt"] = this.lastProducedAt
      ? this.lastProducedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["sourceLogId"] =
      this.sourceLogId !== undefined ? this.sourceLogId : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["uomId"] = this.uomId !== undefined ? this.uomId : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    return data;
  }
}

export interface IProductionLogDto {
  logId: string;
  workOrderName: string | null;
  taskId: string;
  taskName: string | null;
  assetId: string | null;
  productionReasonId: string;
  productionReasonName: string | null;
  quantityProduced: number;
  startedAt: Date;
  lastProducedAt: Date;
  finishedAt: Date | null;
  comment: string | null;
  sourceLogId: string | null;
  itemId: string;
  itemName: string | null;
  uomId: string;
  uomName: string | null;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
}

export enum ProductionRateUom {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
}

export class ProductionReasonDto implements IProductionReasonDto {
  id!: string;
  name!: string | null;
  description!: string | null;

  constructor(data?: IProductionReasonDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
    }
  }

  static fromJS(data: any): ProductionReasonDto {
    data = typeof data === "object" ? data : {};
    let result = new ProductionReasonDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    return data;
  }
}

export interface IProductionReasonDto {
  id: string;
  name: string | null;
  description: string | null;
}

export class ProductionSummaryDto implements IProductionSummaryDto {
  assetId!: string;
  itemName!: string | null;
  productionReasonId!: string;
  productionReasonName!: string | null;
  quantity!: number;

  constructor(data?: IProductionSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.productionReasonId =
        _data["productionReasonId"] !== undefined
          ? _data["productionReasonId"]
          : <any>null;
      this.productionReasonName =
        _data["productionReasonName"] !== undefined
          ? _data["productionReasonName"]
          : <any>null;
      this.quantity =
        _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
    }
  }

  static fromJS(data: any): ProductionSummaryDto {
    data = typeof data === "object" ? data : {};
    let result = new ProductionSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["productionReasonId"] =
      this.productionReasonId !== undefined
        ? this.productionReasonId
        : <any>null;
    data["productionReasonName"] =
      this.productionReasonName !== undefined
        ? this.productionReasonName
        : <any>null;
    data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
    return data;
  }
}

export interface IProductionSummaryDto {
  assetId: string;
  itemName: string | null;
  productionReasonId: string;
  productionReasonName: string | null;
  quantity: number;
}

export enum Recurrence {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export class RefreshTokenDto implements IRefreshTokenDto {
  token!: string | null;

  constructor(data?: IRefreshTokenDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
    }
  }

  static fromJS(data: any): RefreshTokenDto {
    data = typeof data === "object" ? data : {};
    let result = new RefreshTokenDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["token"] = this.token !== undefined ? this.token : <any>null;
    return data;
  }
}

export interface IRefreshTokenDto {
  token: string | null;
}

export class RegisterBadProductionRequest
  implements IRegisterBadProductionRequest
{
  quantityProduced!: number;
  comment!: string | null;
  tryAggregate!: boolean | null;

  constructor(data?: IRegisterBadProductionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.tryAggregate =
        _data["tryAggregate"] !== undefined ? _data["tryAggregate"] : <any>null;
    }
  }

  static fromJS(data: any): RegisterBadProductionRequest {
    data = typeof data === "object" ? data : {};
    let result = new RegisterBadProductionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["tryAggregate"] =
      this.tryAggregate !== undefined ? this.tryAggregate : <any>null;
    return data;
  }
}

export interface IRegisterBadProductionRequest {
  quantityProduced: number;
  comment: string | null;
  tryAggregate: boolean | null;
}

export class RegisterGoodProductionRequest
  implements IRegisterGoodProductionRequest
{
  quantityProduced!: number;
  comment!: string | null;
  tryAggregate!: boolean | null;

  constructor(data?: IRegisterGoodProductionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
      this.tryAggregate =
        _data["tryAggregate"] !== undefined ? _data["tryAggregate"] : <any>null;
    }
  }

  static fromJS(data: any): RegisterGoodProductionRequest {
    data = typeof data === "object" ? data : {};
    let result = new RegisterGoodProductionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    data["tryAggregate"] =
      this.tryAggregate !== undefined ? this.tryAggregate : <any>null;
    return data;
  }
}

export interface IRegisterGoodProductionRequest {
  quantityProduced: number;
  comment: string | null;
  tryAggregate: boolean | null;
}

export class RegisterUserDto implements IRegisterUserDto {
  id!: string;

  constructor(data?: IRegisterUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
    }
  }

  static fromJS(data: any): RegisterUserDto {
    data = typeof data === "object" ? data : {};
    let result = new RegisterUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    return data;
  }
}

export interface IRegisterUserDto {
  id: string;
}

export class RegisterUserRequest implements IRegisterUserRequest {
  userName!: string | null;
  password!: string | null;
  firstName!: string | null;
  lastName!: string | null;
  description!: string | null;
  email!: string | null;
  expirationDate!: Date | null;

  constructor(data?: IRegisterUserRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName =
        _data["userName"] !== undefined ? _data["userName"] : <any>null;
      this.password =
        _data["password"] !== undefined ? _data["password"] : <any>null;
      this.firstName =
        _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
      this.lastName =
        _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
      this.expirationDate = _data["expirationDate"]
        ? new Date(_data["expirationDate"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): RegisterUserRequest {
    data = typeof data === "object" ? data : {};
    let result = new RegisterUserRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userName"] = this.userName !== undefined ? this.userName : <any>null;
    data["password"] = this.password !== undefined ? this.password : <any>null;
    data["firstName"] =
      this.firstName !== undefined ? this.firstName : <any>null;
    data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["email"] = this.email !== undefined ? this.email : <any>null;
    data["expirationDate"] = this.expirationDate
      ? this.expirationDate.toISOString()
      : <any>null;
    return data;
  }
}

export interface IRegisterUserRequest {
  userName: string | null;
  password: string | null;
  firstName: string | null;
  lastName: string | null;
  description: string | null;
  email: string | null;
  expirationDate: Date | null;
}

export class RoleDto implements IRoleDto {
  id!: string;
  name!: string | null;
  defaultLang!: string | null;
  defaultConfSet!: string | null;

  constructor(data?: IRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.defaultLang =
        _data["defaultLang"] !== undefined ? _data["defaultLang"] : <any>null;
      this.defaultConfSet =
        _data["defaultConfSet"] !== undefined
          ? _data["defaultConfSet"]
          : <any>null;
    }
  }

  static fromJS(data: any): RoleDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["defaultLang"] =
      this.defaultLang !== undefined ? this.defaultLang : <any>null;
    data["defaultConfSet"] =
      this.defaultConfSet !== undefined ? this.defaultConfSet : <any>null;
    return data;
  }
}

export interface IRoleDto {
  id: string;
  name: string | null;
  defaultLang: string | null;
  defaultConfSet: string | null;
}

export class RunTaskRequest implements IRunTaskRequest {
  assetId!: string;

  constructor(data?: IRunTaskRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
    }
  }

  static fromJS(data: any): RunTaskRequest {
    data = typeof data === "object" ? data : {};
    let result = new RunTaskRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    return data;
  }
}

export interface IRunTaskRequest {
  assetId: string;
}

export class RunnedTaskDto implements IRunnedTaskDto {
  workOrderId!: string;
  workOrderName!: string | null;
  taskId!: string;
  taskName!: string | null;
  description!: string | null;
  priority!: number;
  quantityRequired!: number;
  quantityProduced!: number;
  quantityRejected!: number;
  notes!: string | null;
  scheduledStartAt!: Date;
  scheduledFinishAt!: Date;
  executionStartedAt!: Date | null;
  executionFinishedAt!: Date | null;
  scheduledAssetId!: string;
  scheduledAssetName!: string | null;
  executionAssetId!: string | null;
  executionAssetName!: string | null;
  taskStateName!: string | null;
  taskStateColor!: string | null;
  itemId!: string;
  itemName!: string | null;
  itemDescription!: string | null;
  uomId!: string;
  uomName!: string | null;
  abbreviation!: string | null;
  estimatedProdRate!: number;
  batchSize!: number;
  productionRateUom!: number;
  duration!: number;

  constructor(data?: IRunnedTaskDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.workOrderId =
        _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
      this.taskName =
        _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.quantityRejected =
        _data["quantityRejected"] !== undefined
          ? _data["quantityRejected"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.scheduledStartAt = _data["scheduledStartAt"]
        ? new Date(_data["scheduledStartAt"].toString())
        : <any>null;
      this.scheduledFinishAt = _data["scheduledFinishAt"]
        ? new Date(_data["scheduledFinishAt"].toString())
        : <any>null;
      this.executionStartedAt = _data["executionStartedAt"]
        ? new Date(_data["executionStartedAt"].toString())
        : <any>null;
      this.executionFinishedAt = _data["executionFinishedAt"]
        ? new Date(_data["executionFinishedAt"].toString())
        : <any>null;
      this.scheduledAssetId =
        _data["scheduledAssetId"] !== undefined
          ? _data["scheduledAssetId"]
          : <any>null;
      this.scheduledAssetName =
        _data["scheduledAssetName"] !== undefined
          ? _data["scheduledAssetName"]
          : <any>null;
      this.executionAssetId =
        _data["executionAssetId"] !== undefined
          ? _data["executionAssetId"]
          : <any>null;
      this.executionAssetName =
        _data["executionAssetName"] !== undefined
          ? _data["executionAssetName"]
          : <any>null;
      this.taskStateName =
        _data["taskStateName"] !== undefined
          ? _data["taskStateName"]
          : <any>null;
      this.taskStateColor =
        _data["taskStateColor"] !== undefined
          ? _data["taskStateColor"]
          : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.itemDescription =
        _data["itemDescription"] !== undefined
          ? _data["itemDescription"]
          : <any>null;
      this.uomId = _data["uomId"] !== undefined ? _data["uomId"] : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      this.abbreviation =
        _data["abbreviation"] !== undefined ? _data["abbreviation"] : <any>null;
      this.estimatedProdRate =
        _data["estimatedProdRate"] !== undefined
          ? _data["estimatedProdRate"]
          : <any>null;
      this.batchSize =
        _data["batchSize"] !== undefined ? _data["batchSize"] : <any>null;
      this.productionRateUom =
        _data["productionRateUom"] !== undefined
          ? _data["productionRateUom"]
          : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
    }
  }

  static fromJS(data: any): RunnedTaskDto {
    data = typeof data === "object" ? data : {};
    let result = new RunnedTaskDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["workOrderId"] =
      this.workOrderId !== undefined ? this.workOrderId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["quantityRejected"] =
      this.quantityRejected !== undefined ? this.quantityRejected : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["scheduledStartAt"] = this.scheduledStartAt
      ? this.scheduledStartAt.toISOString()
      : <any>null;
    data["scheduledFinishAt"] = this.scheduledFinishAt
      ? this.scheduledFinishAt.toISOString()
      : <any>null;
    data["executionStartedAt"] = this.executionStartedAt
      ? this.executionStartedAt.toISOString()
      : <any>null;
    data["executionFinishedAt"] = this.executionFinishedAt
      ? this.executionFinishedAt.toISOString()
      : <any>null;
    data["scheduledAssetId"] =
      this.scheduledAssetId !== undefined ? this.scheduledAssetId : <any>null;
    data["scheduledAssetName"] =
      this.scheduledAssetName !== undefined
        ? this.scheduledAssetName
        : <any>null;
    data["executionAssetId"] =
      this.executionAssetId !== undefined ? this.executionAssetId : <any>null;
    data["executionAssetName"] =
      this.executionAssetName !== undefined
        ? this.executionAssetName
        : <any>null;
    data["taskStateName"] =
      this.taskStateName !== undefined ? this.taskStateName : <any>null;
    data["taskStateColor"] =
      this.taskStateColor !== undefined ? this.taskStateColor : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["itemDescription"] =
      this.itemDescription !== undefined ? this.itemDescription : <any>null;
    data["uomId"] = this.uomId !== undefined ? this.uomId : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["abbreviation"] =
      this.abbreviation !== undefined ? this.abbreviation : <any>null;
    data["estimatedProdRate"] =
      this.estimatedProdRate !== undefined ? this.estimatedProdRate : <any>null;
    data["batchSize"] =
      this.batchSize !== undefined ? this.batchSize : <any>null;
    data["productionRateUom"] =
      this.productionRateUom !== undefined ? this.productionRateUom : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    return data;
  }
}

export interface IRunnedTaskDto {
  workOrderId: string;
  workOrderName: string | null;
  taskId: string;
  taskName: string | null;
  description: string | null;
  priority: number;
  quantityRequired: number;
  quantityProduced: number;
  quantityRejected: number;
  notes: string | null;
  scheduledStartAt: Date;
  scheduledFinishAt: Date;
  executionStartedAt: Date | null;
  executionFinishedAt: Date | null;
  scheduledAssetId: string;
  scheduledAssetName: string | null;
  executionAssetId: string | null;
  executionAssetName: string | null;
  taskStateName: string | null;
  taskStateColor: string | null;
  itemId: string;
  itemName: string | null;
  itemDescription: string | null;
  uomId: string;
  uomName: string | null;
  abbreviation: string | null;
  estimatedProdRate: number;
  batchSize: number;
  productionRateUom: number;
  duration: number;
}

export class ShiftTemplateDto implements IShiftTemplateDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  shiftTemplateType!: ShiftTemplateType;
  createdBy!: string | null;
  createdAt!: Date;
  editedBy!: string | null;
  editedAt!: Date | null;
  isActive!: boolean;

  constructor(data?: IShiftTemplateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.shiftTemplateType =
        _data["shiftTemplateType"] !== undefined
          ? _data["shiftTemplateType"]
          : <any>null;
      this.createdBy =
        _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      this.editedBy =
        _data["editedBy"] !== undefined ? _data["editedBy"] : <any>null;
      this.editedAt = _data["editedAt"]
        ? new Date(_data["editedAt"].toString())
        : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): ShiftTemplateDto {
    data = typeof data === "object" ? data : {};
    let result = new ShiftTemplateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["shiftTemplateType"] =
      this.shiftTemplateType !== undefined ? this.shiftTemplateType : <any>null;
    data["createdBy"] =
      this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data["editedBy"] = this.editedBy !== undefined ? this.editedBy : <any>null;
    data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface IShiftTemplateDto {
  id: string;
  name: string | null;
  description: string | null;
  shiftTemplateType: ShiftTemplateType;
  createdBy: string | null;
  createdAt: Date;
  editedBy: string | null;
  editedAt: Date | null;
  isActive: boolean;
}

export enum ShiftTemplateType {
  _0 = 0,
  _1 = 1,
}

export class SliceUtilLogsOnMissedIntervalsRequest
  implements ISliceUtilLogsOnMissedIntervalsRequest
{
  assetId!: string | null;
  startAt!: Date;
  finishAt!: Date | null;

  constructor(data?: ISliceUtilLogsOnMissedIntervalsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.startAt = _data["startAt"]
        ? new Date(_data["startAt"].toString())
        : <any>null;
      this.finishAt = _data["finishAt"]
        ? new Date(_data["finishAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): SliceUtilLogsOnMissedIntervalsRequest {
    data = typeof data === "object" ? data : {};
    let result = new SliceUtilLogsOnMissedIntervalsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>null;
    data["finishAt"] = this.finishAt ? this.finishAt.toISOString() : <any>null;
    return data;
  }
}

export interface ISliceUtilLogsOnMissedIntervalsRequest {
  assetId: string | null;
  startAt: Date;
  finishAt: Date | null;
}

export class SplitProductionLogDto implements ISplitProductionLogDto {
  createdProductionLogs!: SplitProductionLogResult[] | null;
  correctedProductionLogs!: SplitProductionLogResult[] | null;

  constructor(data?: ISplitProductionLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["createdProductionLogs"])) {
        this.createdProductionLogs = [] as any;
        for (let item of _data["createdProductionLogs"])
          this.createdProductionLogs!.push(
            SplitProductionLogResult.fromJS(item)
          );
      } else {
        this.createdProductionLogs = <any>null;
      }
      if (Array.isArray(_data["correctedProductionLogs"])) {
        this.correctedProductionLogs = [] as any;
        for (let item of _data["correctedProductionLogs"])
          this.correctedProductionLogs!.push(
            SplitProductionLogResult.fromJS(item)
          );
      } else {
        this.correctedProductionLogs = <any>null;
      }
    }
  }

  static fromJS(data: any): SplitProductionLogDto {
    data = typeof data === "object" ? data : {};
    let result = new SplitProductionLogDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.createdProductionLogs)) {
      data["createdProductionLogs"] = [];
      for (let item of this.createdProductionLogs)
        data["createdProductionLogs"].push(item.toJSON());
    }
    if (Array.isArray(this.correctedProductionLogs)) {
      data["correctedProductionLogs"] = [];
      for (let item of this.correctedProductionLogs)
        data["correctedProductionLogs"].push(item.toJSON());
    }
    return data;
  }
}

export interface ISplitProductionLogDto {
  createdProductionLogs: SplitProductionLogResult[] | null;
  correctedProductionLogs: SplitProductionLogResult[] | null;
}

export class SplitProductionLogRequest implements ISplitProductionLogRequest {
  newProductionLogs!: SplitProductionLogRequestDetails[] | null;

  constructor(data?: ISplitProductionLogRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["newProductionLogs"])) {
        this.newProductionLogs = [] as any;
        for (let item of _data["newProductionLogs"])
          this.newProductionLogs!.push(
            SplitProductionLogRequestDetails.fromJS(item)
          );
      } else {
        this.newProductionLogs = <any>null;
      }
    }
  }

  static fromJS(data: any): SplitProductionLogRequest {
    data = typeof data === "object" ? data : {};
    let result = new SplitProductionLogRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.newProductionLogs)) {
      data["newProductionLogs"] = [];
      for (let item of this.newProductionLogs)
        data["newProductionLogs"].push(item.toJSON());
    }
    return data;
  }
}

export interface ISplitProductionLogRequest {
  newProductionLogs: SplitProductionLogRequestDetails[] | null;
}

export class SplitProductionLogRequestDetails
  implements ISplitProductionLogRequestDetails
{
  productionReasonId!: string;
  quantity!: number;
  comment!: string | null;

  constructor(data?: ISplitProductionLogRequestDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productionReasonId =
        _data["productionReasonId"] !== undefined
          ? _data["productionReasonId"]
          : <any>null;
      this.quantity =
        _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
    }
  }

  static fromJS(data: any): SplitProductionLogRequestDetails {
    data = typeof data === "object" ? data : {};
    let result = new SplitProductionLogRequestDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["productionReasonId"] =
      this.productionReasonId !== undefined
        ? this.productionReasonId
        : <any>null;
    data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    return data;
  }
}

export interface ISplitProductionLogRequestDetails {
  productionReasonId: string;
  quantity: number;
  comment: string | null;
}

export class SplitProductionLogResult implements ISplitProductionLogResult {
  logId!: string;
  productionReasonId!: string;
  quantity!: number;

  constructor(data?: ISplitProductionLogResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.productionReasonId =
        _data["productionReasonId"] !== undefined
          ? _data["productionReasonId"]
          : <any>null;
      this.quantity =
        _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
    }
  }

  static fromJS(data: any): SplitProductionLogResult {
    data = typeof data === "object" ? data : {};
    let result = new SplitProductionLogResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["productionReasonId"] =
      this.productionReasonId !== undefined
        ? this.productionReasonId
        : <any>null;
    data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
    return data;
  }
}

export interface ISplitProductionLogResult {
  logId: string;
  productionReasonId: string;
  quantity: number;
}

export class SplitUtilLogDto implements ISplitUtilLogDto {
  splittedLogId!: string;
  olderLogId!: string;
  newerLogId!: string;

  constructor(data?: ISplitUtilLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.splittedLogId =
        _data["splittedLogId"] !== undefined
          ? _data["splittedLogId"]
          : <any>null;
      this.olderLogId =
        _data["olderLogId"] !== undefined ? _data["olderLogId"] : <any>null;
      this.newerLogId =
        _data["newerLogId"] !== undefined ? _data["newerLogId"] : <any>null;
    }
  }

  static fromJS(data: any): SplitUtilLogDto {
    data = typeof data === "object" ? data : {};
    let result = new SplitUtilLogDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["splittedLogId"] =
      this.splittedLogId !== undefined ? this.splittedLogId : <any>null;
    data["olderLogId"] =
      this.olderLogId !== undefined ? this.olderLogId : <any>null;
    data["newerLogId"] =
      this.newerLogId !== undefined ? this.newerLogId : <any>null;
    return data;
  }
}

export interface ISplitUtilLogDto {
  splittedLogId: string;
  olderLogId: string;
  newerLogId: string;
}

export class SplitUtilLogRequest implements ISplitUtilLogRequest {
  olderRange!: SplitUtilLogRequestRange;
  splitTime!: Date;
  newerRange!: SplitUtilLogRequestRange;

  constructor(data?: ISplitUtilLogRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.olderRange = _data["olderRange"]
        ? SplitUtilLogRequestRange.fromJS(_data["olderRange"])
        : <any>null;
      this.splitTime = _data["splitTime"]
        ? new Date(_data["splitTime"].toString())
        : <any>null;
      this.newerRange = _data["newerRange"]
        ? SplitUtilLogRequestRange.fromJS(_data["newerRange"])
        : <any>null;
    }
  }

  static fromJS(data: any): SplitUtilLogRequest {
    data = typeof data === "object" ? data : {};
    let result = new SplitUtilLogRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["olderRange"] = this.olderRange ? this.olderRange.toJSON() : <any>null;
    data["splitTime"] = this.splitTime
      ? this.splitTime.toISOString()
      : <any>null;
    data["newerRange"] = this.newerRange ? this.newerRange.toJSON() : <any>null;
    return data;
  }
}

export interface ISplitUtilLogRequest {
  olderRange: SplitUtilLogRequestRange;
  splitTime: Date;
  newerRange: SplitUtilLogRequestRange;
}

export class SplitUtilLogRequestRange implements ISplitUtilLogRequestRange {
  utilRawId!: string;
  comment!: string | null;

  constructor(data?: ISplitUtilLogRequestRange) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.utilRawId =
        _data["utilRawId"] !== undefined ? _data["utilRawId"] : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
    }
  }

  static fromJS(data: any): SplitUtilLogRequestRange {
    data = typeof data === "object" ? data : {};
    let result = new SplitUtilLogRequestRange();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["utilRawId"] =
      this.utilRawId !== undefined ? this.utilRawId : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    return data;
  }
}

export interface ISplitUtilLogRequestRange {
  utilRawId: string;
  comment: string | null;
}

export class SystemAttributeDTO implements ISystemAttributeDTO {
  id!: string;
  systemAttributeGroupId!: string;
  systemAttributeGroupName!: string | null;
  name!: string | null;
  description!: string | null;
  value!: string | null;
  valueType!: number;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;
  createdAt!: Date;
  editedById!: string | null;
  editedByUserName!: string | null;
  editedByFullName!: string | null;
  editedAt!: Date | null;
  isActive!: boolean;

  constructor(data?: ISystemAttributeDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.systemAttributeGroupId =
        _data["systemAttributeGroupId"] !== undefined
          ? _data["systemAttributeGroupId"]
          : <any>null;
      this.systemAttributeGroupName =
        _data["systemAttributeGroupName"] !== undefined
          ? _data["systemAttributeGroupName"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      this.valueType =
        _data["valueType"] !== undefined ? _data["valueType"] : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      this.editedById =
        _data["editedById"] !== undefined ? _data["editedById"] : <any>null;
      this.editedByUserName =
        _data["editedByUserName"] !== undefined
          ? _data["editedByUserName"]
          : <any>null;
      this.editedByFullName =
        _data["editedByFullName"] !== undefined
          ? _data["editedByFullName"]
          : <any>null;
      this.editedAt = _data["editedAt"]
        ? new Date(_data["editedAt"].toString())
        : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): SystemAttributeDTO {
    data = typeof data === "object" ? data : {};
    let result = new SystemAttributeDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["systemAttributeGroupId"] =
      this.systemAttributeGroupId !== undefined
        ? this.systemAttributeGroupId
        : <any>null;
    data["systemAttributeGroupName"] =
      this.systemAttributeGroupName !== undefined
        ? this.systemAttributeGroupName
        : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["value"] = this.value !== undefined ? this.value : <any>null;
    data["valueType"] =
      this.valueType !== undefined ? this.valueType : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data["editedById"] =
      this.editedById !== undefined ? this.editedById : <any>null;
    data["editedByUserName"] =
      this.editedByUserName !== undefined ? this.editedByUserName : <any>null;
    data["editedByFullName"] =
      this.editedByFullName !== undefined ? this.editedByFullName : <any>null;
    data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface ISystemAttributeDTO {
  id: string;
  systemAttributeGroupId: string;
  systemAttributeGroupName: string | null;
  name: string | null;
  description: string | null;
  value: string | null;
  valueType: number;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
  createdAt: Date;
  editedById: string | null;
  editedByUserName: string | null;
  editedByFullName: string | null;
  editedAt: Date | null;
  isActive: boolean;
}

export class SystemAttributeGroupDTO implements ISystemAttributeGroupDTO {
  id!: string;
  name!: string | null;
  description!: string | null;
  parentSystemAttributeGroupId!: string | null;
  parentSystemAttributeGroupName!: string | null;
  isActive!: boolean;

  constructor(data?: ISystemAttributeGroupDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.parentSystemAttributeGroupId =
        _data["parentSystemAttributeGroupId"] !== undefined
          ? _data["parentSystemAttributeGroupId"]
          : <any>null;
      this.parentSystemAttributeGroupName =
        _data["parentSystemAttributeGroupName"] !== undefined
          ? _data["parentSystemAttributeGroupName"]
          : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): SystemAttributeGroupDTO {
    data = typeof data === "object" ? data : {};
    let result = new SystemAttributeGroupDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["parentSystemAttributeGroupId"] =
      this.parentSystemAttributeGroupId !== undefined
        ? this.parentSystemAttributeGroupId
        : <any>null;
    data["parentSystemAttributeGroupName"] =
      this.parentSystemAttributeGroupName !== undefined
        ? this.parentSystemAttributeGroupName
        : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface ISystemAttributeGroupDTO {
  id: string;
  name: string | null;
  description: string | null;
  parentSystemAttributeGroupId: string | null;
  parentSystemAttributeGroupName: string | null;
  isActive: boolean;
}

export class TaskDto implements ITaskDto {
  id!: string;
  workOrderId!: string;
  workOrderName!: string | null;
  name!: string | null;
  nbr!: number;
  description!: string | null;
  taskStateId!: string;
  taskStateName!: string | null;
  taskStateColor!: string | null;
  itemId!: string;
  itemName!: string | null;
  quantityRequired!: number;
  notes!: string | null;
  scheduledAssetId!: string;
  scheduledAssetName!: string | null;
  scheduledStartAt!: Date;
  scheduledFinishAt!: Date;
  priority!: number;
  uomId!: string;
  uomConversionId!: string | null;
  abbreviation!: string | null;
  uomName!: string | null;
  readonly productionRateUom!: number;
  readonly batchSize!: number;
  readonly estimatedProdRate!: number;
  createdById!: string | null;
  createdByUserName!: string | null;
  createdByFullName!: string | null;
  createdAt!: Date;
  editedById!: string | null;
  editedByUserName!: string | null;
  editedByFullName!: string | null;
  editedAt!: Date | null;

  constructor(data?: ITaskDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.workOrderId =
        _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.nbr = _data["nbr"] !== undefined ? _data["nbr"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.taskStateId =
        _data["taskStateId"] !== undefined ? _data["taskStateId"] : <any>null;
      this.taskStateName =
        _data["taskStateName"] !== undefined
          ? _data["taskStateName"]
          : <any>null;
      this.taskStateColor =
        _data["taskStateColor"] !== undefined
          ? _data["taskStateColor"]
          : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.scheduledAssetId =
        _data["scheduledAssetId"] !== undefined
          ? _data["scheduledAssetId"]
          : <any>null;
      this.scheduledAssetName =
        _data["scheduledAssetName"] !== undefined
          ? _data["scheduledAssetName"]
          : <any>null;
      this.scheduledStartAt = _data["scheduledStartAt"]
        ? new Date(_data["scheduledStartAt"].toString())
        : <any>null;
      this.scheduledFinishAt = _data["scheduledFinishAt"]
        ? new Date(_data["scheduledFinishAt"].toString())
        : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.uomId = _data["uomId"] !== undefined ? _data["uomId"] : <any>null;
      this.uomConversionId =
        _data["uomConversionId"] !== undefined
          ? _data["uomConversionId"]
          : <any>null;
      this.abbreviation =
        _data["abbreviation"] !== undefined ? _data["abbreviation"] : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      (<any>this).productionRateUom =
        _data["productionRateUom"] !== undefined
          ? _data["productionRateUom"]
          : <any>null;
      (<any>this).batchSize =
        _data["batchSize"] !== undefined ? _data["batchSize"] : <any>null;
      (<any>this).estimatedProdRate =
        _data["estimatedProdRate"] !== undefined
          ? _data["estimatedProdRate"]
          : <any>null;
      this.createdById =
        _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
      this.createdByUserName =
        _data["createdByUserName"] !== undefined
          ? _data["createdByUserName"]
          : <any>null;
      this.createdByFullName =
        _data["createdByFullName"] !== undefined
          ? _data["createdByFullName"]
          : <any>null;
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>null;
      this.editedById =
        _data["editedById"] !== undefined ? _data["editedById"] : <any>null;
      this.editedByUserName =
        _data["editedByUserName"] !== undefined
          ? _data["editedByUserName"]
          : <any>null;
      this.editedByFullName =
        _data["editedByFullName"] !== undefined
          ? _data["editedByFullName"]
          : <any>null;
      this.editedAt = _data["editedAt"]
        ? new Date(_data["editedAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): TaskDto {
    data = typeof data === "object" ? data : {};
    let result = new TaskDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["workOrderId"] =
      this.workOrderId !== undefined ? this.workOrderId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["nbr"] = this.nbr !== undefined ? this.nbr : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["taskStateId"] =
      this.taskStateId !== undefined ? this.taskStateId : <any>null;
    data["taskStateName"] =
      this.taskStateName !== undefined ? this.taskStateName : <any>null;
    data["taskStateColor"] =
      this.taskStateColor !== undefined ? this.taskStateColor : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["scheduledAssetId"] =
      this.scheduledAssetId !== undefined ? this.scheduledAssetId : <any>null;
    data["scheduledAssetName"] =
      this.scheduledAssetName !== undefined
        ? this.scheduledAssetName
        : <any>null;
    data["scheduledStartAt"] = this.scheduledStartAt
      ? this.scheduledStartAt.toISOString()
      : <any>null;
    data["scheduledFinishAt"] = this.scheduledFinishAt
      ? this.scheduledFinishAt.toISOString()
      : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["uomId"] = this.uomId !== undefined ? this.uomId : <any>null;
    data["uomConversionId"] =
      this.uomConversionId !== undefined ? this.uomConversionId : <any>null;
    data["abbreviation"] =
      this.abbreviation !== undefined ? this.abbreviation : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["productionRateUom"] =
      this.productionRateUom !== undefined ? this.productionRateUom : <any>null;
    data["batchSize"] =
      this.batchSize !== undefined ? this.batchSize : <any>null;
    data["estimatedProdRate"] =
      this.estimatedProdRate !== undefined ? this.estimatedProdRate : <any>null;
    data["createdById"] =
      this.createdById !== undefined ? this.createdById : <any>null;
    data["createdByUserName"] =
      this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
    data["createdByFullName"] =
      this.createdByFullName !== undefined ? this.createdByFullName : <any>null;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data["editedById"] =
      this.editedById !== undefined ? this.editedById : <any>null;
    data["editedByUserName"] =
      this.editedByUserName !== undefined ? this.editedByUserName : <any>null;
    data["editedByFullName"] =
      this.editedByFullName !== undefined ? this.editedByFullName : <any>null;
    data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : <any>null;
    return data;
  }
}

export interface ITaskDto {
  id: string;
  workOrderId: string;
  workOrderName: string | null;
  name: string | null;
  nbr: number;
  description: string | null;
  taskStateId: string;
  taskStateName: string | null;
  taskStateColor: string | null;
  itemId: string;
  itemName: string | null;
  quantityRequired: number;
  notes: string | null;
  scheduledAssetId: string;
  scheduledAssetName: string | null;
  scheduledStartAt: Date;
  scheduledFinishAt: Date;
  priority: number;
  uomId: string;
  uomConversionId: string | null;
  abbreviation: string | null;
  uomName: string | null;
  productionRateUom: number;
  batchSize: number;
  estimatedProdRate: number;
  createdById: string | null;
  createdByUserName: string | null;
  createdByFullName: string | null;
  createdAt: Date;
  editedById: string | null;
  editedByUserName: string | null;
  editedByFullName: string | null;
  editedAt: Date | null;
}

export class TaskLogonDTO implements ITaskLogonDTO {
  logId!: string;
  workOrderId!: string;
  workOrderName!: string | null;
  taskId!: string;
  taskName!: string | null;
  userId!: string;
  userName!: string | null;
  userFullName!: string | null;
  connectionId!: string;
  startedAt!: Date;
  finishedAt!: Date | null;

  constructor(data?: ITaskLogonDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logId = _data["logId"] !== undefined ? _data["logId"] : <any>null;
      this.workOrderId =
        _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
      this.taskName =
        _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
      this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
      this.userName =
        _data["userName"] !== undefined ? _data["userName"] : <any>null;
      this.userFullName =
        _data["userFullName"] !== undefined ? _data["userFullName"] : <any>null;
      this.connectionId =
        _data["connectionId"] !== undefined ? _data["connectionId"] : <any>null;
      this.startedAt = _data["startedAt"]
        ? new Date(_data["startedAt"].toString())
        : <any>null;
      this.finishedAt = _data["finishedAt"]
        ? new Date(_data["finishedAt"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): TaskLogonDTO {
    data = typeof data === "object" ? data : {};
    let result = new TaskLogonDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logId"] = this.logId !== undefined ? this.logId : <any>null;
    data["workOrderId"] =
      this.workOrderId !== undefined ? this.workOrderId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
    data["userId"] = this.userId !== undefined ? this.userId : <any>null;
    data["userName"] = this.userName !== undefined ? this.userName : <any>null;
    data["userFullName"] =
      this.userFullName !== undefined ? this.userFullName : <any>null;
    data["connectionId"] =
      this.connectionId !== undefined ? this.connectionId : <any>null;
    data["startedAt"] = this.startedAt
      ? this.startedAt.toISOString()
      : <any>null;
    data["finishedAt"] = this.finishedAt
      ? this.finishedAt.toISOString()
      : <any>null;
    return data;
  }
}

export interface ITaskLogonDTO {
  logId: string;
  workOrderId: string;
  workOrderName: string | null;
  taskId: string;
  taskName: string | null;
  userId: string;
  userName: string | null;
  userFullName: string | null;
  connectionId: string;
  startedAt: Date;
  finishedAt: Date | null;
}

export class TaskStateDto implements ITaskStateDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  color!: string | null;

  constructor(data?: ITaskStateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
    }
  }

  static fromJS(data: any): TaskStateDto {
    data = typeof data === "object" ? data : {};
    let result = new TaskStateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["color"] = this.color !== undefined ? this.color : <any>null;
    return data;
  }
}

export interface ITaskStateDto {
  id: string;
  name: string | null;
  description: string | null;
  color: string | null;
}

export class UnregisterBadProductionRequest
  implements IUnregisterBadProductionRequest
{
  quantity!: number;
  comment!: string | null;

  constructor(data?: IUnregisterBadProductionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.quantity =
        _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
    }
  }

  static fromJS(data: any): UnregisterBadProductionRequest {
    data = typeof data === "object" ? data : {};
    let result = new UnregisterBadProductionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    return data;
  }
}

export interface IUnregisterBadProductionRequest {
  quantity: number;
  comment: string | null;
}

export class UnregisterGoodProductionRequest
  implements IUnregisterGoodProductionRequest
{
  quantity!: number;
  comment!: string | null;

  constructor(data?: IUnregisterGoodProductionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.quantity =
        _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
      this.comment =
        _data["comment"] !== undefined ? _data["comment"] : <any>null;
    }
  }

  static fromJS(data: any): UnregisterGoodProductionRequest {
    data = typeof data === "object" ? data : {};
    let result = new UnregisterGoodProductionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
    data["comment"] = this.comment !== undefined ? this.comment : <any>null;
    return data;
  }
}

export interface IUnregisterGoodProductionRequest {
  quantity: number;
  comment: string | null;
}

export class UomConvDto implements IUomConvDto {
  id!: string;
  fromUomId!: string;
  fromUomName!: string | null;
  toUomId!: string;
  toUomName!: string | null;
  itemId!: string | null;
  itemName!: string | null;
  factor!: number;
  offset!: number;

  constructor(data?: IUomConvDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.fromUomId =
        _data["fromUomId"] !== undefined ? _data["fromUomId"] : <any>null;
      this.fromUomName =
        _data["fromUomName"] !== undefined ? _data["fromUomName"] : <any>null;
      this.toUomId =
        _data["toUomId"] !== undefined ? _data["toUomId"] : <any>null;
      this.toUomName =
        _data["toUomName"] !== undefined ? _data["toUomName"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.factor = _data["factor"] !== undefined ? _data["factor"] : <any>null;
      this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
    }
  }

  static fromJS(data: any): UomConvDto {
    data = typeof data === "object" ? data : {};
    let result = new UomConvDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["fromUomId"] =
      this.fromUomId !== undefined ? this.fromUomId : <any>null;
    data["fromUomName"] =
      this.fromUomName !== undefined ? this.fromUomName : <any>null;
    data["toUomId"] = this.toUomId !== undefined ? this.toUomId : <any>null;
    data["toUomName"] =
      this.toUomName !== undefined ? this.toUomName : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["factor"] = this.factor !== undefined ? this.factor : <any>null;
    data["offset"] = this.offset !== undefined ? this.offset : <any>null;
    return data;
  }
}

export interface IUomConvDto {
  id: string;
  fromUomId: string;
  fromUomName: string | null;
  toUomId: string;
  toUomName: string | null;
  itemId: string | null;
  itemName: string | null;
  factor: number;
  offset: number;
}

export class UomDto implements IUomDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  abbreviation!: string | null;

  constructor(data?: IUomDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.abbreviation =
        _data["abbreviation"] !== undefined ? _data["abbreviation"] : <any>null;
    }
  }

  static fromJS(data: any): UomDto {
    data = typeof data === "object" ? data : {};
    let result = new UomDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["abbreviation"] =
      this.abbreviation !== undefined ? this.abbreviation : <any>null;
    return data;
  }
}

export interface IUomDto {
  id: string;
  name: string | null;
  description: string | null;
  abbreviation: string | null;
}

export class UserDto implements IUserDto {
  id!: string;
  userName!: string | null;
  firstName!: string | null;
  lastName!: string | null;
  description!: string | null;
  isActive!: boolean;
  email!: string | null;
  expirationDate!: Date | null;

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.userName =
        _data["userName"] !== undefined ? _data["userName"] : <any>null;
      this.firstName =
        _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
      this.lastName =
        _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
      this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
      this.expirationDate = _data["expirationDate"]
        ? new Date(_data["expirationDate"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === "object" ? data : {};
    let result = new UserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["userName"] = this.userName !== undefined ? this.userName : <any>null;
    data["firstName"] =
      this.firstName !== undefined ? this.firstName : <any>null;
    data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    data["email"] = this.email !== undefined ? this.email : <any>null;
    data["expirationDate"] = this.expirationDate
      ? this.expirationDate.toISOString()
      : <any>null;
    return data;
  }
}

export interface IUserDto {
  id: string;
  userName: string | null;
  firstName: string | null;
  lastName: string | null;
  description: string | null;
  isActive: boolean;
  email: string | null;
  expirationDate: Date | null;
}

export class UtilCategoryDto implements IUtilCategoryDto {
  id!: string;
  name!: string | null;
  description!: string | null;

  constructor(data?: IUtilCategoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
    }
  }

  static fromJS(data: any): UtilCategoryDto {
    data = typeof data === "object" ? data : {};
    let result = new UtilCategoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    return data;
  }
}

export interface IUtilCategoryDto {
  id: string;
  name: string | null;
  description: string | null;
}

export class UtilRawDto implements IUtilRawDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  oeeDefinition!: OeeDefinition;
  utilRawGroupId!: string;
  utilRawGroupName!: string | null;
  utilStateId!: string;
  utilStateName!: string | null;
  priority!: number | null;
  isActive!: boolean;

  constructor(data?: IUtilRawDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.oeeDefinition =
        _data["oeeDefinition"] !== undefined
          ? _data["oeeDefinition"]
          : <any>null;
      this.utilRawGroupId =
        _data["utilRawGroupId"] !== undefined
          ? _data["utilRawGroupId"]
          : <any>null;
      this.utilRawGroupName =
        _data["utilRawGroupName"] !== undefined
          ? _data["utilRawGroupName"]
          : <any>null;
      this.utilStateId =
        _data["utilStateId"] !== undefined ? _data["utilStateId"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): UtilRawDto {
    data = typeof data === "object" ? data : {};
    let result = new UtilRawDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["oeeDefinition"] =
      this.oeeDefinition !== undefined ? this.oeeDefinition : <any>null;
    data["utilRawGroupId"] =
      this.utilRawGroupId !== undefined ? this.utilRawGroupId : <any>null;
    data["utilRawGroupName"] =
      this.utilRawGroupName !== undefined ? this.utilRawGroupName : <any>null;
    data["utilStateId"] =
      this.utilStateId !== undefined ? this.utilStateId : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface IUtilRawDto {
  id: string;
  name: string | null;
  description: string | null;
  oeeDefinition: OeeDefinition;
  utilRawGroupId: string;
  utilRawGroupName: string | null;
  utilStateId: string;
  utilStateName: string | null;
  priority: number | null;
  isActive: boolean;
}

export class UtilRawGroupDto implements IUtilRawGroupDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  parentUtilRawGroupId!: string | null;
  priority!: number | null;
  isActive!: boolean;

  constructor(data?: IUtilRawGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.parentUtilRawGroupId =
        _data["parentUtilRawGroupId"] !== undefined
          ? _data["parentUtilRawGroupId"]
          : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): UtilRawGroupDto {
    data = typeof data === "object" ? data : {};
    let result = new UtilRawGroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["parentUtilRawGroupId"] =
      this.parentUtilRawGroupId !== undefined
        ? this.parentUtilRawGroupId
        : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface IUtilRawGroupDto {
  id: string;
  name: string | null;
  description: string | null;
  parentUtilRawGroupId: string | null;
  priority: number | null;
  isActive: boolean;
}

export class UtilStateDto implements IUtilStateDto {
  id!: string;
  utilStateGroupId!: string;
  name!: string | null;
  description!: string | null;
  oeeDefinition!: OeeDefinition;
  color!: string | null;
  isActive!: boolean;

  constructor(data?: IUtilStateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.utilStateGroupId =
        _data["utilStateGroupId"] !== undefined
          ? _data["utilStateGroupId"]
          : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.oeeDefinition =
        _data["oeeDefinition"] !== undefined
          ? _data["oeeDefinition"]
          : <any>null;
      this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): UtilStateDto {
    data = typeof data === "object" ? data : {};
    let result = new UtilStateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["utilStateGroupId"] =
      this.utilStateGroupId !== undefined ? this.utilStateGroupId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["oeeDefinition"] =
      this.oeeDefinition !== undefined ? this.oeeDefinition : <any>null;
    data["color"] = this.color !== undefined ? this.color : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface IUtilStateDto {
  id: string;
  utilStateGroupId: string;
  name: string | null;
  description: string | null;
  oeeDefinition: OeeDefinition;
  color: string | null;
  isActive: boolean;
}

export class UtilStateGroupDto implements IUtilStateGroupDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  parentUtilStateGroupId!: string | null;
  isActive!: boolean;

  constructor(data?: IUtilStateGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.parentUtilStateGroupId =
        _data["parentUtilStateGroupId"] !== undefined
          ? _data["parentUtilStateGroupId"]
          : <any>null;
      this.isActive =
        _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
    }
  }

  static fromJS(data: any): UtilStateGroupDto {
    data = typeof data === "object" ? data : {};
    let result = new UtilStateGroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["parentUtilStateGroupId"] =
      this.parentUtilStateGroupId !== undefined
        ? this.parentUtilStateGroupId
        : <any>null;
    data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    return data;
  }
}

export interface IUtilStateGroupDto {
  id: string;
  name: string | null;
  description: string | null;
  parentUtilStateGroupId: string | null;
  isActive: boolean;
}

export class UtilizationSummaryDto implements IUtilizationSummaryDto {
  assetId!: string;
  utilStateName!: string | null;
  utilStateColor!: string | null;
  duration!: number;

  constructor(data?: IUtilizationSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId =
        _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
      this.utilStateName =
        _data["utilStateName"] !== undefined
          ? _data["utilStateName"]
          : <any>null;
      this.utilStateColor =
        _data["utilStateColor"] !== undefined
          ? _data["utilStateColor"]
          : <any>null;
      this.duration =
        _data["duration"] !== undefined ? _data["duration"] : <any>null;
    }
  }

  static fromJS(data: any): UtilizationSummaryDto {
    data = typeof data === "object" ? data : {};
    let result = new UtilizationSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
    data["utilStateName"] =
      this.utilStateName !== undefined ? this.utilStateName : <any>null;
    data["utilStateColor"] =
      this.utilStateColor !== undefined ? this.utilStateColor : <any>null;
    data["duration"] = this.duration !== undefined ? this.duration : <any>null;
    return data;
  }
}

export interface IUtilizationSummaryDto {
  assetId: string;
  utilStateName: string | null;
  utilStateColor: string | null;
  duration: number;
}

export enum ValueType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export class WorkOrderDto implements IWorkOrderDto {
  id!: string;
  name!: string | null;
  description!: string | null;
  state!: WorkOrderState;
  itemId!: string;
  quantityRequired!: number;
  notes!: string | null;
  dueDateTime!: Date;

  constructor(data?: IWorkOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description =
        _data["description"] !== undefined ? _data["description"] : <any>null;
      this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
      this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.dueDateTime = _data["dueDateTime"]
        ? new Date(_data["dueDateTime"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): WorkOrderDto {
    data = typeof data === "object" ? data : {};
    let result = new WorkOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] =
      this.description !== undefined ? this.description : <any>null;
    data["state"] = this.state !== undefined ? this.state : <any>null;
    data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["dueDateTime"] = this.dueDateTime
      ? this.dueDateTime.toISOString()
      : <any>null;
    return data;
  }
}

export interface IWorkOrderDto {
  id: string;
  name: string | null;
  description: string | null;
  state: WorkOrderState;
  itemId: string;
  quantityRequired: number;
  notes: string | null;
  dueDateTime: Date;
}

export enum WorkOrderState {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class WorkQueueDto implements IWorkQueueDto {
  workOrderId!: string;
  workOrderName!: string | null;
  taskId!: string;
  taskName!: string | null;
  taskDescription!: string | null;
  priority!: number;
  quantityRequired!: number;
  quantityProduced!: number;
  quantityRejected!: number;
  notes!: string | null;
  scheduledStartAt!: Date;
  scheduledFinishAt!: Date;
  executionStartedAt!: Date | null;
  executionFinishedAt!: Date | null;
  scheduledAssetId!: string;
  scheduledAssetName!: string | null;
  executionAssetId!: string | null;
  executionAssetName!: string | null;
  taskStateName!: string | null;
  taskStateColor!: string | null;
  itemName!: string | null;
  itemDescription!: string | null;
  uomName!: string | null;
  abbreviation!: string | null;

  constructor(data?: IWorkQueueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.workOrderId =
        _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
      this.workOrderName =
        _data["workOrderName"] !== undefined
          ? _data["workOrderName"]
          : <any>null;
      this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : <any>null;
      this.taskName =
        _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
      this.taskDescription =
        _data["taskDescription"] !== undefined
          ? _data["taskDescription"]
          : <any>null;
      this.priority =
        _data["priority"] !== undefined ? _data["priority"] : <any>null;
      this.quantityRequired =
        _data["quantityRequired"] !== undefined
          ? _data["quantityRequired"]
          : <any>null;
      this.quantityProduced =
        _data["quantityProduced"] !== undefined
          ? _data["quantityProduced"]
          : <any>null;
      this.quantityRejected =
        _data["quantityRejected"] !== undefined
          ? _data["quantityRejected"]
          : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.scheduledStartAt = _data["scheduledStartAt"]
        ? new Date(_data["scheduledStartAt"].toString())
        : <any>null;
      this.scheduledFinishAt = _data["scheduledFinishAt"]
        ? new Date(_data["scheduledFinishAt"].toString())
        : <any>null;
      this.executionStartedAt = _data["executionStartedAt"]
        ? new Date(_data["executionStartedAt"].toString())
        : <any>null;
      this.executionFinishedAt = _data["executionFinishedAt"]
        ? new Date(_data["executionFinishedAt"].toString())
        : <any>null;
      this.scheduledAssetId =
        _data["scheduledAssetId"] !== undefined
          ? _data["scheduledAssetId"]
          : <any>null;
      this.scheduledAssetName =
        _data["scheduledAssetName"] !== undefined
          ? _data["scheduledAssetName"]
          : <any>null;
      this.executionAssetId =
        _data["executionAssetId"] !== undefined
          ? _data["executionAssetId"]
          : <any>null;
      this.executionAssetName =
        _data["executionAssetName"] !== undefined
          ? _data["executionAssetName"]
          : <any>null;
      this.taskStateName =
        _data["taskStateName"] !== undefined
          ? _data["taskStateName"]
          : <any>null;
      this.taskStateColor =
        _data["taskStateColor"] !== undefined
          ? _data["taskStateColor"]
          : <any>null;
      this.itemName =
        _data["itemName"] !== undefined ? _data["itemName"] : <any>null;
      this.itemDescription =
        _data["itemDescription"] !== undefined
          ? _data["itemDescription"]
          : <any>null;
      this.uomName =
        _data["uomName"] !== undefined ? _data["uomName"] : <any>null;
      this.abbreviation =
        _data["abbreviation"] !== undefined ? _data["abbreviation"] : <any>null;
    }
  }

  static fromJS(data: any): WorkQueueDto {
    data = typeof data === "object" ? data : {};
    let result = new WorkQueueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["workOrderId"] =
      this.workOrderId !== undefined ? this.workOrderId : <any>null;
    data["workOrderName"] =
      this.workOrderName !== undefined ? this.workOrderName : <any>null;
    data["taskId"] = this.taskId !== undefined ? this.taskId : <any>null;
    data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
    data["taskDescription"] =
      this.taskDescription !== undefined ? this.taskDescription : <any>null;
    data["priority"] = this.priority !== undefined ? this.priority : <any>null;
    data["quantityRequired"] =
      this.quantityRequired !== undefined ? this.quantityRequired : <any>null;
    data["quantityProduced"] =
      this.quantityProduced !== undefined ? this.quantityProduced : <any>null;
    data["quantityRejected"] =
      this.quantityRejected !== undefined ? this.quantityRejected : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["scheduledStartAt"] = this.scheduledStartAt
      ? this.scheduledStartAt.toISOString()
      : <any>null;
    data["scheduledFinishAt"] = this.scheduledFinishAt
      ? this.scheduledFinishAt.toISOString()
      : <any>null;
    data["executionStartedAt"] = this.executionStartedAt
      ? this.executionStartedAt.toISOString()
      : <any>null;
    data["executionFinishedAt"] = this.executionFinishedAt
      ? this.executionFinishedAt.toISOString()
      : <any>null;
    data["scheduledAssetId"] =
      this.scheduledAssetId !== undefined ? this.scheduledAssetId : <any>null;
    data["scheduledAssetName"] =
      this.scheduledAssetName !== undefined
        ? this.scheduledAssetName
        : <any>null;
    data["executionAssetId"] =
      this.executionAssetId !== undefined ? this.executionAssetId : <any>null;
    data["executionAssetName"] =
      this.executionAssetName !== undefined
        ? this.executionAssetName
        : <any>null;
    data["taskStateName"] =
      this.taskStateName !== undefined ? this.taskStateName : <any>null;
    data["taskStateColor"] =
      this.taskStateColor !== undefined ? this.taskStateColor : <any>null;
    data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
    data["itemDescription"] =
      this.itemDescription !== undefined ? this.itemDescription : <any>null;
    data["uomName"] = this.uomName !== undefined ? this.uomName : <any>null;
    data["abbreviation"] =
      this.abbreviation !== undefined ? this.abbreviation : <any>null;
    return data;
  }
}

export interface IWorkQueueDto {
  workOrderId: string;
  workOrderName: string | null;
  taskId: string;
  taskName: string | null;
  taskDescription: string | null;
  priority: number;
  quantityRequired: number;
  quantityProduced: number;
  quantityRejected: number;
  notes: string | null;
  scheduledStartAt: Date;
  scheduledFinishAt: Date;
  executionStartedAt: Date | null;
  executionFinishedAt: Date | null;
  scheduledAssetId: string;
  scheduledAssetName: string | null;
  executionAssetId: string | null;
  executionAssetName: string | null;
  taskStateName: string | null;
  taskStateColor: string | null;
  itemName: string | null;
  itemDescription: string | null;
  uomName: string | null;
  abbreviation: string | null;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
